webpackJsonp([3],{

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(820),
	__webpack_require__(911),
	__webpack_require__(1064),
	__webpack_require__(910),
	__webpack_require__(2147),
	__webpack_require__(1353),
	__webpack_require__(2148),
	__webpack_require__(1066),
	__webpack_require__(2149),
	__webpack_require__(2153),
	__webpack_require__(912),
	__webpack_require__(2157),
	__webpack_require__(2158),
	__webpack_require__(978),
	__webpack_require__(2160),
	__webpack_require__(2163),
	__webpack_require__(934),
	__webpack_require__(2164),
	__webpack_require__(1367),
	__webpack_require__(913),
	__webpack_require__(2165),
	__webpack_require__(2166),
	__webpack_require__(2167),
	__webpack_require__(2168),
	__webpack_require__(2171),
	__webpack_require__(1067),
	__webpack_require__(2172),
	__webpack_require__(2173),
	__webpack_require__(2174),
	__webpack_require__(2175),
	__webpack_require__(2176),
	__webpack_require__(2177)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

return jQuery;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// [[Class]] -> type pairs
	return {};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(935)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.slice;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(935)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.indexOf;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1055)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( class2type ) {
	"use strict";

	return class2type.hasOwnProperty;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1060)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( pnum ) {

"use strict";

return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1060)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( pnum ) {
	"use strict";

	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(1063),
	__webpack_require__(889)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, documentElement, support ) {

"use strict";

( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(813)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document ) {
	"use strict";

	return document.documentElement;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(867)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rnothtmlwhite ) {

"use strict";

// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

/**
 * Determines whether an object can have data
 */
return function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(850),
	__webpack_require__(910),
	__webpack_require__(1064)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, dataPriv ) {

"use strict";

jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(1059),
	__webpack_require__(867),
	__webpack_require__(1345),
	__webpack_require__(1356),
	__webpack_require__(1339),
	__webpack_require__(1348),
	__webpack_require__(850),
	__webpack_require__(2150),

	__webpack_require__(839),
	__webpack_require__(1066),
	__webpack_require__(910),
	__webpack_require__(911),
	__webpack_require__(978),
	__webpack_require__(934),
	__webpack_require__(2152)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, rcssNum, rnothtmlwhite, cssExpand, isHiddenWithinTree, swap,
	adjustCSS, dataPriv, showHide ) {

"use strict";

var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(813),
	__webpack_require__(889)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document, support ) {

"use strict";

( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(867)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( rnothtmlwhite ) {
	"use strict";

	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}

	return stripAndCollapse;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(850),
	__webpack_require__(1065),
	__webpack_require__(1058),

	__webpack_require__(912)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, dataPriv, acceptData, hasOwn ) {

"use strict";

var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

// A method for quickly swapping in/out CSS properties to get correct calculations.
return function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(935)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.concat;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(935)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.push;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1058)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( hasOwn ) {
	"use strict";

	return hasOwn.toString;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(813)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document ) {
	"use strict";

	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}

	return DOMEval;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /^margin/ );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1061),
	__webpack_require__(1344),
	__webpack_require__(1346),
	__webpack_require__(1062),
	__webpack_require__(820) // Get jQuery.contains
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rnumnonpx, rmargin, getStyles, support ) {

"use strict";

function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}

return curCSS;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1059)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rcssNum ) {

"use strict";

function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}

return adjustCSS;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}

return addGetHookIf;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// Match a standalone tag
	return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1057),
	__webpack_require__(1352),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, indexOf, rneedsContext ) {

"use strict";

var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(2144),
	__webpack_require__(910)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document ) {

"use strict";

// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(867),
	__webpack_require__(1065)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rnothtmlwhite, acceptData ) {

"use strict";

function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};

return Data;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1354)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Data ) {
	"use strict";

	return new Data();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(820)

	// css is assumed
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {
	"use strict";

	// isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
	// through the CSS cascade), which is useful in deciding whether or not to make it visible.
	// It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
	// * A hidden ancestor does not force an element to be classified as hidden.
	// * Being disconnected from the document does not force an element to be classified as hidden.
	// These differences improve the behavior of .toggle() et al. when applied to elements that are
	// detached or contained within hidden ancestors (gh-2404, gh-2863).
	return function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /^$|\/(?:java|ecma)script/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

return wrapMap;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(868)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, nodeName ) {

"use strict";

function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}

return getAll;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(850)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( dataPriv ) {

"use strict";

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}

return setGlobalEval;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1358),
	__webpack_require__(1359),
	__webpack_require__(1360),
	__webpack_require__(1361),
	__webpack_require__(1362)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rtagName, rscriptType, wrapMap, getAll, setGlobalEval ) {

"use strict";

var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}

return buildFragment;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(890),
	__webpack_require__(1068),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, support ) {

"use strict";

var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {
	"use strict";

	return jQuery.now();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /\?/ );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1357),
	__webpack_require__(839),
	__webpack_require__(911), // filter
	__webpack_require__(1364)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rcheckableType ) {

"use strict";

var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var utils = _interopRequireWildcard(_utils);

var _advanced = __webpack_require__(2128);

var _advanced2 = _interopRequireDefault(_advanced);

var _display = __webpack_require__(2130);

var _display2 = _interopRequireDefault(_display);

var _general = __webpack_require__(2335);

var _general2 = _interopRequireDefault(_general);

var _notifications = __webpack_require__(2337);

var _notifications2 = _interopRequireDefault(_notifications);

var _security = __webpack_require__(2341);

var _security2 = _interopRequireDefault(_security);

var _sidebar = __webpack_require__(2347);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserSettings = function (_React$Component) {
    (0, _inherits3.default)(UserSettings, _React$Component);

    function UserSettings(props) {
        (0, _classCallCheck3.default)(this, UserSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserSettings.__proto__ || (0, _getPrototypeOf2.default)(UserSettings)).call(this, props));

        _this.onListenerChange = function () {
            var user = _user_store2.default.getCurrentUser();
            if (!utils.areObjectsEqual(_this.state.user, user)) {
                _this.setState({ user: user });
            }
        };

        _this.state = { user: _user_store2.default.getCurrentUser() };
        return _this;
    }

    (0, _createClass3.default)(UserSettings, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addChangeListener(this.onListenerChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeChangeListener(this.onListenerChange);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.activeTab === 'general') {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_general2.default, {
                        user: this.state.user,
                        activeSection: this.props.activeSection,
                        prevActiveSection: this.props.prevActiveSection,
                        updateSection: this.props.updateSection,
                        updateTab: this.props.updateTab,
                        closeModal: this.props.closeModal,
                        collapseModal: this.props.collapseModal
                    })
                );
            } else if (this.props.activeTab === 'security') {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_security2.default, {
                        user: this.state.user,
                        activeSection: this.props.activeSection,
                        prevActiveSection: this.props.prevActiveSection,
                        updateSection: this.props.updateSection,
                        updateTab: this.props.updateTab,
                        closeModal: this.props.closeModal,
                        collapseModal: this.props.collapseModal,
                        setEnforceFocus: this.props.setEnforceFocus
                    })
                );
            } else if (this.props.activeTab === 'notifications') {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_notifications2.default, {
                        user: this.state.user,
                        activeSection: this.props.activeSection,
                        prevActiveSection: this.props.prevActiveSection,
                        updateSection: this.props.updateSection,
                        updateTab: this.props.updateTab,
                        closeModal: this.props.closeModal,
                        collapseModal: this.props.collapseModal
                    })
                );
            } else if (this.props.activeTab === 'display') {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_display2.default, {
                        user: this.state.user,
                        activeSection: this.props.activeSection,
                        prevActiveSection: this.props.prevActiveSection,
                        updateSection: this.props.updateSection,
                        updateTab: this.props.updateTab,
                        closeModal: this.props.closeModal,
                        collapseModal: this.props.collapseModal,
                        setEnforceFocus: this.props.setEnforceFocus,
                        setRequireConfirm: this.props.setRequireConfirm
                    })
                );
            } else if (this.props.activeTab === 'sidebar') {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_sidebar2.default, {
                        activeSection: this.props.activeSection,
                        prevActiveSection: this.props.prevActiveSection,
                        updateSection: this.props.updateSection,
                        updateTab: this.props.updateTab,
                        closeModal: this.props.closeModal,
                        collapseModal: this.props.collapseModal
                    })
                );
            } else if (this.props.activeTab === 'advanced') {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_advanced2.default, {
                        user: this.state.user,
                        activeSection: this.props.activeSection,
                        prevActiveSection: this.props.prevActiveSection,
                        updateSection: this.props.updateSection,
                        updateTab: this.props.updateTab,
                        closeModal: this.props.closeModal,
                        collapseModal: this.props.collapseModal
                    })
                );
            }

            return _react2.default.createElement('div', null);
        }
    }]);
    return UserSettings;
}(_react2.default.Component);

exports.default = UserSettings;


UserSettings.propTypes = {
    activeTab: _propTypes2.default.string,
    activeSection: _propTypes2.default.string,
    prevActiveSection: _propTypes2.default.string,
    updateSection: _propTypes2.default.func,
    updateTab: _propTypes2.default.func,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    setEnforceFocus: _propTypes2.default.func.isRequired,
    setRequireConfirm: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 2128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _user_settings_advanced = __webpack_require__(2129);

var _user_settings_advanced2 = _interopRequireDefault(_user_settings_advanced);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var license = (0, _general.getLicense)(state);

    var enableWebrtc = config.EnableWebrtc === 'true';
    var enablePreviewFeatures = config.EnablePreviewFeatures === 'true';
    var buildEnterpriseReady = config.BuildEnterpriseReady === 'true';
    var isLicensed = license && license.IsLicensed === 'true';

    return {
        enableWebrtc: enableWebrtc,
        enablePreviewFeatures: enablePreviewFeatures,
        buildEnterpriseReady: buildEnterpriseReady,
        isLicensed: isLicensed
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_user_settings_advanced2.default);

/***/ }),

/***/ 2129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PreReleaseFeatures = _constants2.default.PRE_RELEASE_FEATURES;

var AdvancedSettingsDisplay = function (_React$Component) {
    (0, _inherits3.default)(AdvancedSettingsDisplay, _React$Component);

    function AdvancedSettingsDisplay(props) {
        (0, _classCallCheck3.default)(this, AdvancedSettingsDisplay);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AdvancedSettingsDisplay.__proto__ || (0, _getPrototypeOf2.default)(AdvancedSettingsDisplay)).call(this, props));

        _this.getStateFromStores = function () {
            var preReleaseFeaturesKeys = (0, _keys2.default)(PreReleaseFeatures);
            var advancedSettings = _preference_store2.default.getCategory(_constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS);
            var settings = {
                send_on_ctrl_enter: _preference_store2.default.get(_constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter', 'false'),
                formatting: _preference_store2.default.get(_constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS, 'formatting', 'true'),
                join_leave: _preference_store2.default.get(_constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS, 'join_leave', 'true')
            };

            var webrtcEnabled = _this.props.enableWebrtc;

            if (!webrtcEnabled) {
                preReleaseFeaturesKeys = preReleaseFeaturesKeys.filter(function (f) {
                    return f !== 'WEBRTC_PREVIEW';
                });
            }

            var enabledFeatures = 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(advancedSettings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        name = _step$value[0],
                        value = _step$value[1];

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(preReleaseFeaturesKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var key = _step2.value;

                            var feature = PreReleaseFeatures[key];

                            if (name === _constants2.default.FeatureTogglePrefix + feature.label) {
                                settings[name] = value;

                                if (value === 'true') {
                                    enabledFeatures += 1;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var isSaving = false;

            var previewFeaturesEnabled = _this.props.enablePreviewFeatures;

            return {
                preReleaseFeatures: PreReleaseFeatures,
                settings: settings,
                preReleaseFeaturesKeys: preReleaseFeaturesKeys,
                enabledFeatures: enabledFeatures,
                isSaving: isSaving,
                previewFeaturesEnabled: previewFeaturesEnabled
            };
        };

        _this.updateSetting = function (setting, value) {
            var settings = _this.state.settings;
            settings[setting] = value;
            _this.setState(settings);
        };

        _this.toggleFeature = function (feature, checked) {
            var settings = _this.state.settings;
            settings[_constants2.default.FeatureTogglePrefix + feature] = String(checked);

            var enabledFeatures = 0;
            (0, _keys2.default)(_this.state.settings).forEach(function (setting) {
                if (setting.lastIndexOf(_constants2.default.FeatureTogglePrefix) === 0 && _this.state.settings[setting] === 'true') {
                    enabledFeatures++;
                }
            });

            _this.setState({ settings: settings, enabledFeatures: enabledFeatures });
        };

        _this.saveEnabledFeatures = function () {
            var features = [];
            (0, _keys2.default)(_this.state.settings).forEach(function (setting) {
                if (setting.lastIndexOf(_constants2.default.FeatureTogglePrefix) === 0) {
                    features.push(setting);
                }
            });

            _this.handleSubmit(features);
        };

        _this.handleSubmit = function (settings) {
            var preferences = [];
            var userId = _user_store2.default.getCurrentId();

            // this should be refactored so we can actually be certain about what type everything is
            (Array.isArray(settings) ? settings : [settings]).forEach(function (setting) {
                preferences.push({
                    user_id: userId,
                    category: _constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS,
                    name: setting,
                    value: _this.state.settings[setting]
                });
            });

            _this.setState({ isSaving: true });

            (0, _user_actions.savePreferences)(preferences, function () {
                _this.handleUpdateSection('');
            });
        };

        _this.handleUpdateSection = function (section) {
            if (!section) {
                _this.setState(_this.getStateFromStores());
            }
            _this.setState({ isSaving: false });
            _this.props.updateSection(section);
        };

        _this.renderFormattingSection = function () {
            if (_this.props.activeSection === 'formatting') {
                return _react2.default.createElement(_setting_item_max2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.advance.formattingTitle',
                        defaultMessage: 'Enable Post Formatting'
                    }),
                    inputs: [_react2.default.createElement(
                        'div',
                        { key: 'formattingSetting' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'postFormattingOn',
                                    type: 'radio',
                                    name: 'formatting',
                                    checked: _this.state.settings.formatting !== 'false',
                                    onChange: _this.updateSetting.bind(_this, 'formatting', 'true')
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.advance.on',
                                    defaultMessage: 'On'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'postFormattingOff',
                                    type: 'radio',
                                    name: 'formatting',
                                    checked: _this.state.settings.formatting === 'false',
                                    onChange: _this.updateSetting.bind(_this, 'formatting', 'false')
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.advance.off',
                                    defaultMessage: 'Off'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.advance.formattingDesc',
                                defaultMessage: 'If enabled, posts will be formatted to create links, show emoji, style the text, and add line breaks. By default, this setting is enabled. Changing this setting requires the page to be refreshed.'
                            })
                        )
                    )],
                    setting: 'formatting',
                    submit: _this.handleSubmit,
                    saving: _this.state.isSaving,
                    server_error: _this.state.serverError,
                    updateSection: _this.handleUpdateSection
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.advance.formattingTitle',
                    defaultMessage: 'Enable Post Formatting'
                }),
                describe: _this.renderOnOffLabel(_this.state.settings.formatting),
                focused: _this.props.prevActiveSection === _this.prevSections.formatting,
                section: 'formatting',
                updateSection: _this.handleUpdateSection
            });
        };

        _this.renderJoinLeaveSection = function () {
            if (_this.props.buildEnterpriseReady && _this.props.isLicensed) {
                if (_this.props.activeSection === 'join_leave') {
                    return _react2.default.createElement(_setting_item_max2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.joinLeaveTitle',
                            defaultMessage: 'Enable Join/Leave Messages'
                        }),
                        inputs: [_react2.default.createElement(
                            'div',
                            { key: 'joinLeaveSetting' },
                            _react2.default.createElement(
                                'div',
                                { className: 'radio' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'joinLeaveOn',
                                        type: 'radio',
                                        name: 'join_leave',
                                        checked: _this.state.settings.join_leave !== 'false',
                                        onChange: _this.updateSetting.bind(_this, 'join_leave', 'true')
                                    }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'user.settings.advance.on',
                                        defaultMessage: 'On'
                                    })
                                ),
                                _react2.default.createElement('br', null)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'radio' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'joinLeaveOff',
                                        type: 'radio',
                                        name: 'join_leave',
                                        checked: _this.state.settings.join_leave === 'false',
                                        onChange: _this.updateSetting.bind(_this, 'join_leave', 'false')
                                    }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'user.settings.advance.off',
                                        defaultMessage: 'Off'
                                    })
                                ),
                                _react2.default.createElement('br', null)
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.advance.joinLeaveDesc',
                                    defaultMessage: 'When "On", System Messages saying a user has joined or left a channel will be visible. When "Off", the System Messages about joining or leaving a channel will be hidden. A message will still show up when you are added to a channel, so you can receive a notification.'
                                })
                            )
                        )],
                        setting: 'join_leave',
                        submit: _this.handleSubmit,
                        saving: _this.state.isSaving,
                        server_error: _this.state.serverError,
                        updateSection: _this.handleUpdateSection
                    });
                }

                return _react2.default.createElement(_setting_item_min2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.advance.joinLeaveTitle',
                        defaultMessage: 'Enable Join/Leave Messages'
                    }),
                    describe: _this.renderOnOffLabel(_this.state.settings.join_leave),
                    focused: _this.props.prevActiveSection === _this.prevSections.join_leave,
                    section: 'join_leave',
                    updateSection: _this.handleUpdateSection
                });
            }

            return null;
        };

        _this.state = _this.getStateFromStores();

        _this.prevSections = {
            advancedCtrlSend: 'dummySectionName', // dummy value that should never match any section name
            formatting: 'advancedCtrlSend',
            join_leave: 'formatting',
            advancedPreviewFeatures: 'join_leave'
        };
        return _this;
    }

    (0, _createClass3.default)(AdvancedSettingsDisplay, [{
        key: 'renderOnOffLabel',
        value: function renderOnOffLabel(enabled) {
            if (enabled === 'false') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.advance.off',
                    defaultMessage: 'Off'
                });
            }

            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'user.settings.advance.on',
                defaultMessage: 'On'
            });
        }
    }, {
        key: 'renderFeatureLabel',
        value: function renderFeatureLabel(feature) {
            switch (feature) {
                case 'MARKDOWN_PREVIEW':
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.advance.markdown_preview',
                        defaultMessage: 'Show markdown preview option in message input box'
                    });
                case 'WEBRTC_PREVIEW':
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.advance.webrtc_preview',
                        defaultMessage: 'Enable the ability to make and receive one-on-one WebRTC calls'
                    });
                default:
                    return null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var serverError = this.state.serverError || null;
            var ctrlSendSection = void 0;

            if (this.props.activeSection === 'advancedCtrlSend') {
                var ctrlSendActive = [this.state.settings.send_on_ctrl_enter === 'true', this.state.settings.send_on_ctrl_enter === 'false'];

                var inputs = [_react2.default.createElement(
                    'div',
                    { key: 'ctrlSendSetting' },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'ctrlSendOn',
                                type: 'radio',
                                name: 'sendOnCtrlEnter',
                                checked: ctrlSendActive[0],
                                onChange: this.updateSetting.bind(this, 'send_on_ctrl_enter', 'true')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.advance.on',
                                defaultMessage: 'On'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'ctrlSendOff',
                                type: 'radio',
                                name: 'sendOnCtrlEnter',
                                checked: ctrlSendActive[1],
                                onChange: this.updateSetting.bind(this, 'send_on_ctrl_enter', 'false')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.advance.off',
                                defaultMessage: 'Off'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.sendDesc',
                            defaultMessage: 'If enabled ENTER inserts a new line and CTRL+ENTER submits the message.'
                        })
                    )
                )];
                ctrlSendSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.advance.sendTitle',
                        defaultMessage: 'Send messages on CTRL+ENTER'
                    }),
                    inputs: inputs,
                    setting: 'send_on_ctrl_enter',
                    submit: this.handleSubmit,
                    saving: this.state.isSaving,
                    server_error: serverError,
                    updateSection: this.handleUpdateSection
                });
            } else {
                ctrlSendSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.advance.sendTitle',
                        defaultMessage: 'Send messages on CTRL+ENTER'
                    }),
                    describe: this.renderOnOffLabel(this.state.settings.send_on_ctrl_enter),
                    focused: this.props.prevActiveSection === this.prevSections.advancedCtrlSend,
                    section: 'advancedCtrlSend',
                    updateSection: this.handleUpdateSection
                });
            }

            var formattingSection = this.renderFormattingSection();
            var formattingSectionDivider = null;
            if (formattingSection) {
                formattingSectionDivider = _react2.default.createElement('div', { className: 'divider-light' });
            }

            var displayJoinLeaveSection = this.renderJoinLeaveSection();
            var displayJoinLeaveSectionDivider = null;
            if (displayJoinLeaveSection) {
                displayJoinLeaveSectionDivider = _react2.default.createElement('div', { className: 'divider-light' });
                this.prevSections.advancedPreviewFeatures = 'join_leave';
            } else {
                this.prevSections.advancedPreviewFeatures = this.prevSections.join_leave;
            }

            var previewFeaturesSection = void 0;
            var previewFeaturesSectionDivider = void 0;
            if (this.state.previewFeaturesEnabled && this.state.preReleaseFeaturesKeys.length > 0) {
                previewFeaturesSectionDivider = _react2.default.createElement('div', { className: 'divider-light' });

                if (this.props.activeSection === 'advancedPreviewFeatures') {
                    var _inputs = [];

                    this.state.preReleaseFeaturesKeys.forEach(function (key) {
                        var feature = _this2.state.preReleaseFeatures[key];
                        _inputs.push(_react2.default.createElement(
                            'div',
                            { key: 'advancedPreviewFeatures_' + feature.label },
                            _react2.default.createElement(
                                'div',
                                { className: 'checkbox' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'advancedPreviewFeatures' + feature.label,
                                        type: 'checkbox',
                                        checked: _this2.state.settings[_constants2.default.FeatureTogglePrefix + feature.label] === 'true',
                                        onChange: function onChange(e) {
                                            _this2.toggleFeature(feature.label, e.target.checked);
                                        }
                                    }),
                                    _this2.renderFeatureLabel(key)
                                )
                            )
                        ));
                    });

                    _inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'advancedPreviewFeatures_helptext' },
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.preReleaseDesc',
                            defaultMessage: 'Check any pre-released features you\'d like to preview.  You may also need to refresh the page before the setting will take effect.'
                        })
                    ));
                    previewFeaturesSection = _react2.default.createElement(_setting_item_max2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.preReleaseTitle',
                            defaultMessage: 'Preview pre-release features'
                        }),
                        inputs: _inputs,
                        submit: this.saveEnabledFeatures,
                        saving: this.state.isSaving,
                        server_error: serverError,
                        updateSection: this.handleUpdateSection
                    });
                } else {
                    previewFeaturesSection = _react2.default.createElement(_setting_item_min2.default, {
                        title: Utils.localizeMessage('user.settings.advance.preReleaseTitle', 'Preview pre-release features'),
                        describe: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.enabledFeatures',
                            defaultMessage: '{count, number} {count, plural, one {Feature} other {Features}} Enabled',
                            values: { count: this.state.enabledFeatures }
                        }),
                        focused: this.props.prevActiveSection === this.prevSections.advancedPreviewFeatures,
                        section: 'advancedPreviewFeatures',
                        updateSection: this.handleUpdateSection
                    });
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'closeButton',
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': 'Close',
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.title',
                            defaultMessage: 'Advanced Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'user-settings' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.advance.title',
                            defaultMessage: 'Advanced Settings'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    ctrlSendSection,
                    formattingSectionDivider,
                    formattingSection,
                    displayJoinLeaveSectionDivider,
                    displayJoinLeaveSection,
                    previewFeaturesSectionDivider,
                    previewFeaturesSection,
                    _react2.default.createElement('div', { className: 'divider-dark' })
                )
            );
        }
    }]);
    return AdvancedSettingsDisplay;
}(_react2.default.Component);

exports.default = AdvancedSettingsDisplay;


AdvancedSettingsDisplay.propTypes = {
    user: _propTypes2.default.object,
    updateSection: _propTypes2.default.func,
    updateTab: _propTypes2.default.func,
    activeSection: _propTypes2.default.string,
    prevActiveSection: _propTypes2.default.string,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    enableWebrtc: _propTypes2.default.bool,
    enablePreviewFeatures: _propTypes2.default.bool,
    buildEnterpriseReady: _propTypes2.default.bool,
    isLicensed: _propTypes2.default.bool
};

/***/ }),

/***/ 2130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _general = __webpack_require__(946);

var _timezone = __webpack_require__(1178);

var _general2 = __webpack_require__(113);

var _users = __webpack_require__(777);

var _timezone2 = __webpack_require__(1029);

var _timezone_utils = __webpack_require__(923);

var _user_settings_display = __webpack_require__(2131);

var _user_settings_display2 = _interopRequireDefault(_user_settings_display);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general2.getConfig)(state);
    var timezones = (0, _general2.getSupportedTimezones)(state);
    var currentUserId = (0, _users.getCurrentUserId)(state);
    var userTimezone = (0, _timezone2.getUserTimezone)(state, currentUserId);
    var automaticTimezoneNotSet = userTimezone && userTimezone.useAutomaticTimezone && !userTimezone.automaticTimezone;
    var shouldAutoUpdateTimezone = !userTimezone || automaticTimezoneNotSet;

    var allowCustomThemes = config.AllowCustomThemes === 'true';
    var enableLinkPreviews = config.EnableLinkPreviews === 'true';
    var defaultClientLocale = config.DefaultClientLocale;
    var enableThemeSelection = config.EnableThemeSelection === 'true';
    var enableTimezone = config.ExperimentalTimezone === 'true';
    var configTeammateNameDisplay = config.TeammateNameDisplay;

    return {
        allowCustomThemes: allowCustomThemes,
        configTeammateNameDisplay: configTeammateNameDisplay,
        enableLinkPreviews: enableLinkPreviews,
        defaultClientLocale: defaultClientLocale,
        enableThemeSelection: enableThemeSelection,
        enableTimezone: enableTimezone,
        timezones: timezones,
        userTimezone: userTimezone,
        shouldAutoUpdateTimezone: shouldAutoUpdateTimezone,
        currentUserTimezone: (0, _timezone_utils.getUserCurrentTimezone)(userTimezone)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getSupportedTimezones: _general.getSupportedTimezones,
            autoUpdateTimezone: _timezone.autoUpdateTimezone
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_user_settings_display2.default);

/***/ }),

/***/ 2131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _timezone_utils = __webpack_require__(923);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _timezone = __webpack_require__(962);

var _i18n = __webpack_require__(924);

var I18n = _interopRequireWildcard(_i18n);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _manage_timezones = __webpack_require__(2132);

var _manage_timezones2 = _interopRequireDefault(_manage_timezones);

var _manage_languages = __webpack_require__(2134);

var _manage_languages2 = _interopRequireDefault(_manage_languages);

var _user_settings_theme = __webpack_require__(2135);

var _user_settings_theme2 = _interopRequireDefault(_user_settings_theme);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Preferences = _constants2.default.Preferences;

function getDisplayStateFromStores(props) {
    return {
        militaryTime: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.USE_MILITARY_TIME, Preferences.USE_MILITARY_TIME_DEFAULT),
        teammateNameDisplay: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.NAME_NAME_FORMAT, props.configTeammateNameDisplay),
        channelDisplayMode: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT),
        messageDisplay: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.MESSAGE_DISPLAY, Preferences.MESSAGE_DISPLAY_DEFAULT),
        collapseDisplay: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.COLLAPSE_DISPLAY, Preferences.COLLAPSE_DISPLAY_DEFAULT),
        linkPreviewDisplay: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.LINK_PREVIEW_DISPLAY, Preferences.LINK_PREVIEW_DISPLAY_DEFAULT)
    };
}

var UserSettingsDisplay = function (_React$Component) {
    (0, _inherits3.default)(UserSettingsDisplay, _React$Component);

    function UserSettingsDisplay(props) {
        (0, _classCallCheck3.default)(this, UserSettingsDisplay);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserSettingsDisplay.__proto__ || (0, _getPrototypeOf2.default)(UserSettingsDisplay)).call(this, props));

        _this.handleSubmit = function () {
            var userId = _user_store2.default.getCurrentId();

            var timePreference = {
                user_id: userId,
                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
                name: Preferences.USE_MILITARY_TIME,
                value: _this.state.militaryTime
            };
            var teammateNameDisplayPreference = {
                user_id: userId,
                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
                name: Preferences.NAME_NAME_FORMAT,
                value: _this.state.teammateNameDisplay
            };
            var channelDisplayModePreference = {
                user_id: userId,
                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
                name: Preferences.CHANNEL_DISPLAY_MODE,
                value: _this.state.channelDisplayMode
            };
            var messageDisplayPreference = {
                user_id: userId,
                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
                name: Preferences.MESSAGE_DISPLAY,
                value: _this.state.messageDisplay
            };
            var collapseDisplayPreference = {
                user_id: userId,
                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
                name: Preferences.COLLAPSE_DISPLAY,
                value: _this.state.collapseDisplay
            };
            var linkPreviewDisplayPreference = {
                user_id: userId,
                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
                name: Preferences.LINK_PREVIEW_DISPLAY,
                value: _this.state.linkPreviewDisplay
            };

            _this.setState({ isSaving: true });

            var preferences = [timePreference, channelDisplayModePreference, messageDisplayPreference, collapseDisplayPreference, linkPreviewDisplayPreference];
            if (_this.state.teammateNameDisplay === _this.props.configTeammateNameDisplay) {
                (0, _user_actions.deletePreferences)([teammateNameDisplayPreference]);
            } else {
                preferences.push(teammateNameDisplayPreference);
            }

            (0, _user_actions.savePreferences)(preferences, function () {
                _this.updateSection('');
            });
        };

        _this.handleClockRadio = function (militaryTime) {
            _this.setState({ militaryTime: militaryTime });
        };

        _this.handleTeammateNameDisplayRadio = function (teammateNameDisplay) {
            _this.setState({ teammateNameDisplay: teammateNameDisplay });
        };

        _this.updateSection = function (section) {
            _this.updateState();
            _this.props.updateSection(section);
        };

        _this.updateState = function () {
            var newState = getDisplayStateFromStores(_this.props);
            if (!Utils.areObjectsEqual(newState, _this.state)) {
                _this.setState(newState);
            }

            _this.setState({ isSaving: false });
        };

        _this.state = (0, _extends3.default)({}, getDisplayStateFromStores(props), {
            isSaving: false
        });

        if (props.timezones.length === 0) {
            props.actions.getSupportedTimezones();
        }

        _this.prevSections = {
            theme: 'dummySectionName', // dummy value that should never match any section name
            clock: 'theme',
            linkpreview: 'clock',
            message_display: 'linkpreview',
            channel_display_mode: 'message_display',
            languages: 'channel_display_mode'
        };
        return _this;
    }

    (0, _createClass3.default)(UserSettingsDisplay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                actions = _props.actions,
                enableTimezone = _props.enableTimezone,
                shouldAutoUpdateTimezone = _props.shouldAutoUpdateTimezone;


            if (enableTimezone && shouldAutoUpdateTimezone) {
                actions.autoUpdateTimezone((0, _timezone.getBrowserTimezone)());
            }
        }
    }, {
        key: 'handleChannelDisplayModeRadio',
        value: function handleChannelDisplayModeRadio(channelDisplayMode) {
            this.setState({ channelDisplayMode: channelDisplayMode });
        }
    }, {
        key: 'handlemessageDisplayRadio',
        value: function handlemessageDisplayRadio(messageDisplay) {
            this.setState({ messageDisplay: messageDisplay });
        }
    }, {
        key: 'handleCollapseRadio',
        value: function handleCollapseRadio(collapseDisplay) {
            this.setState({ collapseDisplay: collapseDisplay });
        }
    }, {
        key: 'handleLinkPreviewRadio',
        value: function handleLinkPreviewRadio(linkPreviewDisplay) {
            this.setState({ linkPreviewDisplay: linkPreviewDisplay });
        }
    }, {
        key: 'handleOnChange',
        value: function handleOnChange(display) {
            this.setState((0, _extends3.default)({}, display));
        }
    }, {
        key: 'createSection',
        value: function createSection(props) {
            var _this2 = this;

            var section = props.section,
                display = props.display,
                value = props.value,
                title = props.title,
                firstOption = props.firstOption,
                secondOption = props.secondOption,
                thirdOption = props.thirdOption,
                description = props.description;


            var firstMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: firstOption.radionButtonText.id,
                defaultMessage: firstOption.radionButtonText.message
            });

            var moreColon = void 0;
            var firstMessageMore = void 0;
            if (firstOption.radionButtonText.moreId) {
                moreColon = ': ';
                firstMessageMore = _react2.default.createElement(
                    'span',
                    { className: 'font-weight--normal' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: firstOption.radionButtonText.moreId,
                        defaultMessage: firstOption.radionButtonText.moreMessage
                    })
                );
            }

            var secondMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: secondOption.radionButtonText.id,
                defaultMessage: secondOption.radionButtonText.message
            });

            var secondMessageMore = void 0;
            if (secondOption.radionButtonText.moreId) {
                secondMessageMore = _react2.default.createElement(
                    'span',
                    { className: 'font-weight--normal' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: secondOption.radionButtonText.moreId,
                        defaultMessage: secondOption.radionButtonText.moreMessage
                    })
                );
            }

            var thirdMessage = void 0;
            if (thirdOption) {
                thirdMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: thirdOption.radionButtonText.id,
                    defaultMessage: thirdOption.radionButtonText.message
                });
            }

            var messageTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: title.id,
                defaultMessage: title.message
            });

            var messageDesc = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: description.id,
                defaultMessage: description.message
            });

            if (this.props.activeSection === section) {
                var format = [false, false, false];
                if (value === firstOption.value) {
                    format[0] = true;
                } else if (value === secondOption.value) {
                    format[1] = true;
                } else {
                    format[2] = true;
                }

                var name = section + 'Format';
                var key = section + 'UserDisplay';

                var firstDisplay = {};
                firstDisplay[display] = firstOption.value;

                var secondDisplay = {};
                secondDisplay[display] = secondOption.value;

                var thirdDisplay = {};
                if (thirdOption) {
                    thirdDisplay[display] = thirdOption.value;
                }

                var thirdSection = void 0;
                if (thirdMessage) {
                    thirdSection = _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: name + 'C',
                                type: 'radio',
                                name: name,
                                checked: format[2],
                                onChange: function onChange() {
                                    return _this2.handleOnChange(thirdDisplay);
                                }
                            }),
                            thirdMessage
                        ),
                        _react2.default.createElement('br', null)
                    );
                }

                var inputs = [_react2.default.createElement(
                    'div',
                    { key: key },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: name + 'A',
                                type: 'radio',
                                name: name,
                                checked: format[0],
                                onChange: function onChange() {
                                    return _this2.handleOnChange(firstDisplay);
                                }
                            }),
                            firstMessage,
                            moreColon,
                            firstMessageMore
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: name + 'B',
                                type: 'radio',
                                name: name,
                                checked: format[1],
                                onChange: function onChange() {
                                    return _this2.handleOnChange(secondDisplay);
                                }
                            }),
                            secondMessage,
                            moreColon,
                            secondMessageMore
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    thirdSection,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('br', null),
                        messageDesc
                    )
                )];

                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_setting_item_max2.default, {
                        title: messageTitle,
                        inputs: inputs,
                        submit: this.handleSubmit,
                        saving: this.state.isSaving,
                        server_error: this.state.serverError,
                        updateSection: this.updateSection
                    }),
                    _react2.default.createElement('div', { className: 'divider-dark' })
                );
            }

            var describe = void 0;
            if (value === firstOption.value) {
                describe = firstMessage;
            } else if (value === secondOption.value) {
                describe = secondMessage;
            } else {
                describe = thirdMessage;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_setting_item_min2.default, {
                    title: messageTitle,
                    describe: describe,
                    focused: this.props.prevActiveSection === this.prevSections[section],
                    section: section,
                    updateSection: this.updateSection
                }),
                _react2.default.createElement('div', { className: 'divider-dark' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var collapseSection = this.createSection({
                section: 'collapse',
                display: 'collapseDisplay',
                value: this.state.collapseDisplay,
                defaultDisplay: 'false',
                title: {
                    id: 'user.settings.display.collapseDisplay',
                    message: 'Default appearance of image link previews'
                },
                firstOption: {
                    value: 'false',
                    radionButtonText: {
                        id: 'user.settings.display.collapseOn',
                        message: 'On'
                    }
                },
                secondOption: {
                    value: 'true',
                    radionButtonText: {
                        id: 'user.settings.display.collapseOff',
                        message: 'Off'
                    }
                },
                description: {
                    id: 'user.settings.display.collapseDesc',
                    message: 'Set whether previews of image links show as expanded or collapsed by default. This setting can also be controlled using the slash commands /expand and /collapse.'
                }
            });

            var linkPreviewSection = null;

            if (this.props.enableLinkPreviews) {
                linkPreviewSection = this.createSection({
                    section: 'linkpreview',
                    display: 'linkPreviewDisplay',
                    value: this.state.linkPreviewDisplay,
                    defaultDisplay: 'true',
                    title: {
                        id: 'user.settings.display.linkPreviewDisplay',
                        message: 'Website Link Previews'
                    },
                    firstOption: {
                        value: 'true',
                        radionButtonText: {
                            id: 'user.settings.display.linkPreviewOn',
                            message: 'On'
                        }
                    },
                    secondOption: {
                        value: 'false',
                        radionButtonText: {
                            id: 'user.settings.display.linkPreviewOff',
                            message: 'Off'
                        }
                    },
                    description: {
                        id: 'user.settings.display.linkPreviewDesc',
                        message: 'When available, the first web link in a message will show a preview of the website content below the message.'
                    }
                });
                this.prevSections.message_display = 'linkpreview';
            } else {
                this.prevSections.message_display = this.prevSections.linkpreview;
            }

            var clockSection = this.createSection({
                section: 'clock',
                display: 'militaryTime',
                value: this.state.militaryTime,
                defaultDisplay: 'false',
                title: {
                    id: 'user.settings.display.clockDisplay',
                    message: 'Clock Display'
                },
                firstOption: {
                    value: 'false',
                    radionButtonText: {
                        id: 'user.settings.display.normalClock',
                        message: '12-hour clock (example: 4:00 PM)'
                    }
                },
                secondOption: {
                    value: 'true',
                    radionButtonText: {
                        id: 'user.settings.display.militaryClock',
                        message: '24-hour clock (example: 16:00)'
                    }
                },
                description: {
                    id: 'user.settings.display.preferTime',
                    message: 'Select how you prefer time displayed.'
                }
            });

            var teammateNameDisplaySection = this.createSection({
                section: Preferences.NAME_NAME_FORMAT,
                display: 'teammateNameDisplay',
                value: this.state.teammateNameDisplay,
                defaultDisplay: this.props.configTeammateNameDisplay,
                title: {
                    id: 'user.settings.display.teammateNameDisplayTitle',
                    message: 'Teammate Name Display'
                },
                firstOption: {
                    value: _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_USERNAME,
                    radionButtonText: {
                        id: 'user.settings.display.teammateNameDisplayUsername',
                        message: 'Show username'
                    }
                },
                secondOption: {
                    value: _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_NICKNAME_FULLNAME,
                    radionButtonText: {
                        id: 'user.settings.display.teammateNameDisplayNicknameFullname',
                        message: 'Show nickname if one exists, otherwise show first and last name'
                    }
                },
                thirdOption: {
                    value: _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_FULLNAME,
                    radionButtonText: {
                        id: 'user.settings.display.teammateNameDisplayFullname',
                        message: 'Show first and last name'
                    }
                },
                description: {
                    id: 'user.settings.display.teammateNameDisplayDescription',
                    message: 'Set how to display other user\'s names in posts and the Direct Messages list.'
                }
            });

            var timezoneSelection = void 0;
            if (this.props.enableTimezone && !this.props.shouldAutoUpdateTimezone) {
                var userTimezone = this.props.userTimezone;
                if (this.props.activeSection === 'timezone') {
                    timezoneSelection = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_manage_timezones2.default, {
                            user: this.props.user,
                            timezones: this.props.timezones,
                            useAutomaticTimezone: userTimezone.useAutomaticTimezone,
                            automaticTimezone: userTimezone.automaticTimezone,
                            manualTimezone: userTimezone.manualTimezone,
                            updateSection: this.updateSection
                        }),
                        _react2.default.createElement('div', { className: 'divider-dark' })
                    );
                } else {
                    timezoneSelection = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_setting_item_min2.default, {
                            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.display.timezone',
                                defaultMessage: 'Timezone'
                            }),
                            width: 'medium',
                            describe: (0, _timezone_utils.getTimezoneRegion)(this.props.currentUserTimezone),
                            section: 'timezone',
                            updateSection: this.updateSection
                        }),
                        _react2.default.createElement('div', { className: 'divider-dark' })
                    );
                }
            }

            var messageDisplaySection = this.createSection({
                section: Preferences.MESSAGE_DISPLAY,
                display: 'messageDisplay',
                value: this.state.messageDisplay,
                defaultDisplay: Preferences.MESSAGE_DISPLAY_CLEAN,
                title: {
                    id: 'user.settings.display.messageDisplayTitle',
                    message: 'Message Display'
                },
                firstOption: {
                    value: Preferences.MESSAGE_DISPLAY_CLEAN,
                    radionButtonText: {
                        id: 'user.settings.display.messageDisplayClean',
                        message: 'Standard',
                        moreId: 'user.settings.display.messageDisplayCleanDes',
                        moreMessage: 'Easy to scan and read.'
                    }
                },
                secondOption: {
                    value: Preferences.MESSAGE_DISPLAY_COMPACT,
                    radionButtonText: {
                        id: 'user.settings.display.messageDisplayCompact',
                        message: 'Compact',
                        moreId: 'user.settings.display.messageDisplayCompactDes',
                        moreMessage: 'Fit as many messages on the screen as we can.'
                    }
                },
                description: {
                    id: 'user.settings.display.messageDisplayDescription',
                    message: 'Select how messages in a channel should be displayed.'
                }
            });

            var channelDisplayModeSection = this.createSection({
                section: Preferences.CHANNEL_DISPLAY_MODE,
                display: 'channelDisplayMode',
                value: this.state.channelDisplayMode,
                defaultDisplay: Preferences.CHANNEL_DISPLAY_MODE_FULL_SCREEN,
                title: {
                    id: 'user.settings.display.channelDisplayTitle',
                    message: 'Channel Display Mode'
                },
                firstOption: {
                    value: Preferences.CHANNEL_DISPLAY_MODE_FULL_SCREEN,
                    radionButtonText: {
                        id: 'user.settings.display.fullScreen',
                        message: 'Full width'
                    }
                },
                secondOption: {
                    value: Preferences.CHANNEL_DISPLAY_MODE_CENTERED,
                    radionButtonText: {
                        id: 'user.settings.display.fixedWidthCentered',
                        message: 'Fixed width, centered'
                    }
                },
                description: {
                    id: 'user.settings.display.channeldisplaymode',
                    message: 'Select the width of the center channel.'
                }
            });

            var languagesSection = void 0;
            var userLocale = this.props.user.locale;
            if (this.props.activeSection === 'languages') {
                if (!I18n.isLanguageAvailable(userLocale)) {
                    userLocale = this.props.defaultClientLocale;
                }
                languagesSection = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_manage_languages2.default, {
                        user: this.props.user,
                        locale: userLocale,
                        updateSection: this.updateSection
                    }),
                    _react2.default.createElement('div', { className: 'divider-dark' })
                );
            } else {
                var locale = void 0;
                if (I18n.isLanguageAvailable(userLocale)) {
                    locale = I18n.getLanguageInfo(userLocale).name;
                } else {
                    locale = I18n.getLanguageInfo(this.props.defaultClientLocale).name;
                }

                languagesSection = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_setting_item_min2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.display.language',
                            defaultMessage: 'Language'
                        }),
                        width: 'medium',
                        describe: locale,
                        focused: this.props.prevActiveSection === this.prevSections.languages,
                        section: 'languages',
                        updateSection: this.updateSection
                    }),
                    _react2.default.createElement('div', { className: 'divider-dark' })
                );
            }

            if ((0, _keys2.default)(I18n.getLanguages()).length === 1) {
                languagesSection = null;
            }

            var themeSection = void 0;
            if (this.props.enableThemeSelection) {
                themeSection = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_user_settings_theme2.default, {
                        selected: this.props.activeSection === 'theme',
                        updateSection: this.updateSection,
                        setRequireConfirm: this.props.setRequireConfirm,
                        setEnforceFocus: this.props.setEnforceFocus,
                        allowCustomThemes: this.props.allowCustomThemes
                    }),
                    _react2.default.createElement('div', { className: 'divider-dark' })
                );
            }

            return _react2.default.createElement(
                'div',
                { id: 'displaySettings' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'closeButton',
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': 'Close',
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.display.title',
                            defaultMessage: 'Display Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'user-settings' },
                    _react2.default.createElement(
                        'h3',
                        {
                            id: 'displaySettingsTitle',
                            className: 'tab-header'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.display.title',
                            defaultMessage: 'Display Settings'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    themeSection,
                    clockSection,
                    teammateNameDisplaySection,
                    timezoneSelection,
                    linkPreviewSection,
                    collapseSection,
                    messageDisplaySection,
                    channelDisplayModeSection,
                    languagesSection
                )
            );
        }
    }]);
    return UserSettingsDisplay;
}(_react2.default.Component);

exports.default = UserSettingsDisplay;


UserSettingsDisplay.propTypes = {
    user: _propTypes2.default.object,
    updateSection: _propTypes2.default.func,
    activeSection: _propTypes2.default.string,
    prevActiveSection: _propTypes2.default.string,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    setRequireConfirm: _propTypes2.default.func.isRequired,
    setEnforceFocus: _propTypes2.default.func.isRequired,
    timezones: _propTypes2.default.array.isRequired,
    userTimezone: _propTypes2.default.object.isRequired,
    allowCustomThemes: _propTypes2.default.bool,
    enableLinkPreviews: _propTypes2.default.bool,
    defaultClientLocale: _propTypes2.default.string,
    enableThemeSelection: _propTypes2.default.bool,
    configTeammateNameDisplay: _propTypes2.default.string,
    currentUserTimezone: _propTypes2.default.string,
    enableTimezone: _propTypes2.default.bool,
    shouldAutoUpdateTimezone: _propTypes2.default.bool,
    actions: _propTypes2.default.shape({
        getSupportedTimezones: _propTypes2.default.func.isRequired,
        autoUpdateTimezone: _propTypes2.default.func.isRequired
    }).isRequired
};

/***/ }),

/***/ 2132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _timezone_utils = __webpack_require__(923);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _timezone = __webpack_require__(962);

var _suggestion_box = __webpack_require__(929);

var _suggestion_box2 = _interopRequireDefault(_suggestion_box);

var _suggestion_list = __webpack_require__(930);

var _suggestion_list2 = _interopRequireDefault(_suggestion_list);

var _timezone_provider = __webpack_require__(2133);

var _timezone_provider2 = _interopRequireDefault(_timezone_provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ManageTimezones = function (_React$PureComponent) {
    (0, _inherits3.default)(ManageTimezones, _React$PureComponent);

    function ManageTimezones(props) {
        (0, _classCallCheck3.default)(this, ManageTimezones);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageTimezones.__proto__ || (0, _getPrototypeOf2.default)(ManageTimezones)).call(this, props));

        _this.onChange = function (e) {
            _this.setState({ manualTimezoneInput: e.target.value });
        };

        _this.handleTimezoneSelected = function (selected) {
            if (!selected) {
                return;
            }

            _this.setState({
                manualTimezone: selected,
                manualTimezoneInput: selected
            });
        };

        _this.timezoneNotChanged = function () {
            var _this$state = _this.state,
                useAutomaticTimezone = _this$state.useAutomaticTimezone,
                automaticTimezone = _this$state.automaticTimezone,
                manualTimezone = _this$state.manualTimezone;
            var _this$props = _this.props,
                oldUseAutomaticTimezone = _this$props.useAutomaticTimezone,
                oldAutomaticTimezone = _this$props.automaticTimezone,
                oldManualTimezone = _this$props.manualTimezone;


            return useAutomaticTimezone === oldUseAutomaticTimezone && automaticTimezone === oldAutomaticTimezone && manualTimezone === oldManualTimezone;
        };

        _this.changeTimezone = function () {
            if (_this.timezoneNotChanged()) {
                _this.props.updateSection('');
                return;
            }

            _this.submitUser();
        };

        _this.submitUser = function () {
            var user = _this.props.user;
            var _this$state2 = _this.state,
                useAutomaticTimezone = _this$state2.useAutomaticTimezone,
                automaticTimezone = _this$state2.automaticTimezone,
                manualTimezone = _this$state2.manualTimezone;


            var timezone = {
                useAutomaticTimezone: useAutomaticTimezone.toString(),
                automaticTimezone: automaticTimezone,
                manualTimezone: manualTimezone
            };

            var updatedUser = (0, _extends3.default)({}, user, {
                timezone: timezone
            });

            (0, _user_actions.updateUser)(updatedUser, function () {
                return _this.props.updateSection('');
            }, function (err) {
                var serverError = void 0;
                if (err.message) {
                    serverError = err.message;
                } else {
                    serverError = err;
                }
                _this.setState({ serverError: serverError, isSaving: false });
            });
        };

        _this.handleAutomaticTimezone = function (e) {
            var useAutomaticTimezone = e.target.checked;
            var automaticTimezone = '';

            if (useAutomaticTimezone) {
                automaticTimezone = (0, _timezone.getBrowserTimezone)();
            }

            _this.setState({
                useAutomaticTimezone: useAutomaticTimezone,
                automaticTimezone: automaticTimezone
            });
        };

        _this.handleManualTimezone = function (e) {
            _this.setState({ manualTimezone: e.target.value });
        };

        _this.state = {
            useAutomaticTimezone: props.useAutomaticTimezone,
            automaticTimezone: props.automaticTimezone,
            manualTimezone: props.manualTimezone,
            manualTimezoneInput: props.manualTimezone,
            isSaving: false
        };
        return _this;
    }

    (0, _createClass3.default)(ManageTimezones, [{
        key: 'render',
        value: function render() {
            var timezones = this.props.timezones;
            var _state = this.state,
                useAutomaticTimezone = _state.useAutomaticTimezone,
                automaticTimezone = _state.automaticTimezone;


            var serverError = void 0;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'label',
                    { className: 'has-error' },
                    this.state.serverError
                );
            }

            var inputs = [];

            var timezoneRegion = _react2.default.createElement(
                'div',
                {
                    className: 'section-describe padding-top'
                },
                useAutomaticTimezone && (0, _timezone_utils.getTimezoneRegion)(automaticTimezone)
            );

            var noTimezonesFromServer = timezones.length === 0;
            var automaticTimezoneInput = _react2.default.createElement(
                'div',
                { className: 'checkbox' },
                _react2.default.createElement(
                    'label',
                    null,
                    _react2.default.createElement('input', {
                        id: 'automaticTimezoneInput',
                        type: 'checkbox',
                        checked: useAutomaticTimezone,
                        onChange: this.handleAutomaticTimezone,
                        disabled: noTimezonesFromServer
                    }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.timezones.automatic',
                        defaultMessage: 'Set automatically'
                    }),
                    timezoneRegion
                )
            );

            var providers = [new _timezone_provider2.default()];
            var manualTimezoneInput = _react2.default.createElement(
                'div',
                { key: 'changeTimezone' },
                _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.timezones.change',
                        defaultMessage: 'Change timezone'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'padding-top' },
                    _react2.default.createElement(_suggestion_box2.default, {
                        ref: this.setSwitchBoxRef,
                        className: 'form-control focused',
                        type: 'search',
                        onChange: this.onChange,
                        value: this.state.manualTimezoneInput,
                        onItemSelected: this.handleTimezoneSelected,
                        listComponent: _suggestion_list2.default,
                        maxLength: '64',
                        requiredCharacters: 0,
                        providers: providers,
                        listStyle: 'bottom',
                        completeOnTab: false,
                        renderDividers: false,
                        openOnFocus: true,
                        disabled: noTimezonesFromServer
                    }),
                    serverError
                )
            );

            inputs.push(automaticTimezoneInput);

            if (!useAutomaticTimezone) {
                inputs.push(manualTimezoneInput);
            }

            inputs.push(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('br', null),
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'user.settings.timezones.promote',
                    defaultMessage: 'Select the time zone used for timestamps in the user interface and email notifications.'
                })
            ));

            return _react2.default.createElement(_setting_item_max2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.display.timezone',
                    defaultMessage: 'Timezone'
                }),
                containerStyle: 'timezone-container',
                width: 'medium',
                submit: this.changeTimezone,
                saving: this.state.isSaving,
                inputs: inputs,
                updateSection: this.props.updateSection
            });
        }
    }]);
    return ManageTimezones;
}(_react2.default.PureComponent);

exports.default = ManageTimezones;


ManageTimezones.propTypes = {
    user: _propTypes2.default.object.isRequired,
    updateSection: _propTypes2.default.func.isRequired,
    useAutomaticTimezone: _propTypes2.default.bool.isRequired,
    automaticTimezone: _propTypes2.default.string.isRequired,
    manualTimezone: _propTypes2.default.string.isRequired,
    timezones: _propTypes2.default.array.isRequired
};

/***/ }),

/***/ 2133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _timezone_utils = __webpack_require__(923);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(29);

var _timezone = __webpack_require__(962);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimezoneSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(TimezoneSuggestion, _Suggestion);

    function TimezoneSuggestion() {
        (0, _classCallCheck3.default)(this, TimezoneSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (TimezoneSuggestion.__proto__ || (0, _getPrototypeOf2.default)(TimezoneSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(TimezoneSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;

            var timezone = item;

            var className = 'mentions__name';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: className
                },
                timezone
            );
        }
    }]);
    return TimezoneSuggestion;
}(_suggestion2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TimezoneProvider = function (_Provider) {
    (0, _inherits3.default)(TimezoneProvider, _Provider);

    function TimezoneProvider() {
        (0, _classCallCheck3.default)(this, TimezoneProvider);
        return (0, _possibleConstructorReturn3.default)(this, (TimezoneProvider.__proto__ || (0, _getPrototypeOf2.default)(TimezoneProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(TimezoneProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, timezonePrefix) {
            if (timezonePrefix.length === 0) {
                this.displayAllTimezones(suggestionId, timezonePrefix);
                return true;
            }

            if (timezonePrefix) {
                this.filterTimezones(suggestionId, timezonePrefix);
                return true;
            }

            return false;
        }
    }, {
        key: 'displayAllTimezones',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(suggestionId) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                setTimeout(function () {
                                    _app_dispatcher2.default.handleServerAction({
                                        type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                                        id: suggestionId,
                                        matchedPretext: '',
                                        terms: (0, _timezone.getSupportedTimezones)(),
                                        items: (0, _timezone.getSupportedTimezones)(),
                                        component: TimezoneSuggestion
                                    });
                                }, 0);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function displayAllTimezones(_x) {
                return _ref.apply(this, arguments);
            }

            return displayAllTimezones;
        }()
    }, {
        key: 'filterTimezones',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(suggestionId, timezonePrefix) {
                var filteredTimezones;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                filteredTimezones = (0, _timezone.getSupportedTimezones)().filter(function (t) {
                                    return (0, _timezone_utils.getTimezoneRegion)(t).toLowerCase().indexOf(timezonePrefix) >= 0 || t.toLowerCase().indexOf(timezonePrefix) >= 0;
                                });


                                setTimeout(function () {
                                    _app_dispatcher2.default.handleServerAction({
                                        type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                                        id: suggestionId,
                                        matchedPretext: timezonePrefix,
                                        terms: filteredTimezones,
                                        items: filteredTimezones,
                                        component: TimezoneSuggestion
                                    });
                                }, 0);

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function filterTimezones(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return filterTimezones;
        }()
    }]);
    return TimezoneProvider;
}(_provider2.default);

exports.default = TimezoneProvider;

/***/ }),

/***/ 2134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _user_actions = __webpack_require__(781);

var _i18n = __webpack_require__(924);

var I18n = _interopRequireWildcard(_i18n);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageLanguage = function (_React$Component) {
    (0, _inherits3.default)(ManageLanguage, _React$Component);

    function ManageLanguage(props) {
        (0, _classCallCheck3.default)(this, ManageLanguage);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageLanguage.__proto__ || (0, _getPrototypeOf2.default)(ManageLanguage)).call(this, props));

        _this.setLanguage = function (e) {
            _this.setState({ locale: e.target.value });
        };

        _this.changeLanguage = function () {
            if (_this.props.user.locale === _this.state.locale) {
                _this.props.updateSection('');
            } else {
                _this.submitUser((0, _extends3.default)({}, _this.props.user, {
                    locale: _this.state.locale
                }));
            }
        };

        _this.submitUser = function (user) {
            _this.setState({ isSaving: true });

            (0, _user_actions.updateUser)(user, function () {
                GlobalActions.newLocalizationSelected(user.locale);
            }, function (err) {
                var serverError = void 0;
                if (err.message) {
                    serverError = err.message;
                } else {
                    serverError = err;
                }
                _this.setState({ serverError: serverError, isSaving: false });
            });
        };

        _this.state = {
            locale: props.locale,
            isSaving: false
        };
        return _this;
    }

    (0, _createClass3.default)(ManageLanguage, [{
        key: 'render',
        value: function render() {
            var serverError = void 0;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'label',
                    { className: 'has-error' },
                    this.state.serverError
                );
            }

            var options = [];
            var locales = I18n.getLanguages();

            var languages = (0, _keys2.default)(locales).map(function (l) {
                return {
                    value: locales[l].value,
                    name: locales[l].name,
                    order: locales[l].order
                };
            }).sort(function (a, b) {
                return a.order - b.order;
            });

            languages.forEach(function (lang) {
                options.push(_react2.default.createElement(
                    'option',
                    {
                        key: lang.value,
                        value: lang.value
                    },
                    lang.name
                ));
            });

            var input = _react2.default.createElement(
                'div',
                { key: 'changeLanguage' },
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.languages.change',
                        defaultMessage: 'Change interface language'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'padding-top' },
                    _react2.default.createElement(
                        'select',
                        {
                            id: 'displayLanguage',
                            ref: 'language',
                            className: 'form-control',
                            value: this.state.locale,
                            onChange: this.setLanguage
                        },
                        options
                    ),
                    serverError
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'user.settings.languages.promote',
                        defaultMessage: 'Select which language Mattermost displays in the user interface.<br /><br />Would like to help with translations? Join the <a href="http://translate.mattermost.com/" target="_blank">Mattermost Translation Server</a> to contribute.'
                    })
                )
            );

            return _react2.default.createElement(_setting_item_max2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.display.language',
                    defaultMessage: 'Language'
                }),
                width: 'medium',
                submit: this.changeLanguage,
                saving: this.state.isSaving,
                inputs: [input],
                updateSection: this.props.updateSection
            });
        }
    }]);
    return ManageLanguage;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ManageLanguage;


ManageLanguage.propTypes = {
    user: _propTypes2.default.object.isRequired,
    locale: _propTypes2.default.string.isRequired,
    updateSection: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 2135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _user_settings_theme = __webpack_require__(2136);

var _user_settings_theme2 = _interopRequireDefault(_user_settings_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);

    var isLicensed = license.IsLicensed === 'true';
    var ldap = license.LDAP === 'true';

    return {
        isLicensed: isLicensed,
        ldap: ldap
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_user_settings_theme2.default);

/***/ }),

/***/ 2136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var UserActions = _interopRequireWildcard(_user_actions);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _custom_theme_chooser = __webpack_require__(2137);

var _custom_theme_chooser2 = _interopRequireDefault(_custom_theme_chooser);

var _premade_theme_chooser = __webpack_require__(2333);

var _premade_theme_chooser2 = _interopRequireDefault(_premade_theme_chooser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ThemeSetting = function (_React$Component) {
    (0, _inherits3.default)(ThemeSetting, _React$Component);

    function ThemeSetting(props) {
        (0, _classCallCheck3.default)(this, ThemeSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ThemeSetting.__proto__ || (0, _getPrototypeOf2.default)(ThemeSetting)).call(this, props));

        _this.onChange = function () {
            var newState = _this.getStateFromStores();

            if (!Utils.areObjectsEqual(_this.state, newState)) {
                _this.setState(newState);
            }

            _this.props.setEnforceFocus(true);
        };

        _this.submitTheme = function () {
            var teamId = _this.state.applyToAllTeams ? '' : _this.state.teamId;

            _this.setState({ isSaving: true });

            UserActions.saveTheme(teamId, _this.state.theme, function () {
                _this.props.setRequireConfirm(false);
                _this.originalTheme = (0, _assign2.default)({}, _this.state.theme);
                _this.scrollToTop();
                _this.props.updateSection('');
                _this.setState({ isSaving: false });
            });
        };

        _this.updateTheme = function (theme) {
            var themeChanged = _this.state.theme.length === theme.length;
            if (!themeChanged) {
                for (var field in theme) {
                    if (theme.hasOwnProperty(field)) {
                        if (_this.state.theme[field] !== theme[field]) {
                            themeChanged = true;
                            break;
                        }
                    }
                }
            }

            _this.props.setRequireConfirm(themeChanged);

            _this.setState({ theme: theme });
            Utils.applyTheme(theme);
        };

        _this.resetFields = function () {
            var state = _this.getStateFromStores();
            state.serverError = null;
            _this.setState(state);
            _this.scrollToTop();

            Utils.applyTheme(state.theme);

            _this.props.setRequireConfirm(false);
        };

        _this.handleImportModal = function () {
            _app_dispatcher2.default.handleViewAction({
                type: _constants.ActionTypes.TOGGLE_IMPORT_THEME_MODAL,
                value: true,
                callback: _this.updateTheme
            });

            _this.props.setEnforceFocus(false);
        };

        _this.handleUpdateSection = function (section) {
            _this.props.updateSection(section);
        };

        _this.state = (0, _extends3.default)({}, _this.getStateFromStores(), {
            isSaving: false
        });

        _this.originalTheme = (0, _assign2.default)({}, _this.state.theme);
        return _this;
    }

    (0, _createClass3.default)(ThemeSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addChangeListener(this.onChange);

            if (this.props.selected) {
                (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs[this.state.theme])).addClass('active-border');
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.selected) {
                (0, _jquery2.default)('.color-btn').removeClass('active-border');
                (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs[this.state.theme])).addClass('active-border');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.selected && !nextProps.selected) {
                this.resetFields();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeChangeListener(this.onChange);

            if (this.props.selected) {
                var state = this.getStateFromStores();
                Utils.applyTheme(state.theme);
            }
        }
    }, {
        key: 'getStateFromStores',
        value: function getStateFromStores() {
            var theme = _preference_store2.default.getTheme();
            if (!theme.codeTheme) {
                theme.codeTheme = _constants.Constants.DEFAULT_CODE_THEME;
            }

            var showAllTeamsCheckbox = false;
            var applyToAllTeams = true;

            if (this.props.isLicensed && this.props.ldap) {
                // show the "apply to all teams" checkbox if the user is on more than one team
                showAllTeamsCheckbox = (0, _keys2.default)(_team_store2.default.getAll()).length > 1;

                // check the "apply to all teams" checkbox by default if the user has any team-specific themes
                applyToAllTeams = _preference_store2.default.getCategory(_constants.Preferences.CATEGORY_THEME).size <= 1;
            }

            return {
                teamId: _team_store2.default.getCurrentId(),
                theme: theme,
                type: theme.type || 'premade',
                showAllTeamsCheckbox: showAllTeamsCheckbox,
                applyToAllTeams: applyToAllTeams
            };
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            (0, _jquery2.default)('.ps-container.modal-body').scrollTop(0);
        }
    }, {
        key: 'updateType',
        value: function updateType(type) {
            this.setState({ type: type });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var serverError;
            if (this.state.serverError) {
                serverError = this.state.serverError;
            }

            var displayCustom = this.state.type === 'custom';

            var custom = void 0;
            var premade = void 0;
            if (displayCustom && this.props.allowCustomThemes) {
                custom = _react2.default.createElement(
                    'div',
                    { key: 'customThemeChooser' },
                    _react2.default.createElement(_custom_theme_chooser2.default, {
                        theme: this.state.theme,
                        updateTheme: this.updateTheme
                    })
                );
            } else {
                premade = _react2.default.createElement(
                    'div',
                    { key: 'premadeThemeChooser' },
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_premade_theme_chooser2.default, {
                        theme: this.state.theme,
                        updateTheme: this.updateTheme
                    })
                );
            }

            var themeUI = void 0;
            if (this.props.selected) {
                var inputs = [];

                if (this.props.allowCustomThemes) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'radio',
                            key: 'premadeThemeColorLabel'
                        },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'standardThemes',
                                type: 'radio',
                                name: 'theme',
                                checked: !displayCustom,
                                onChange: this.updateType.bind(this, 'premade')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.display.theme.themeColors',
                                defaultMessage: 'Theme Colors'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ));
                }

                inputs.push(premade);

                if (this.props.allowCustomThemes) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'radio',
                            key: 'customThemeColorLabel'
                        },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'customThemes',
                                type: 'radio',
                                name: 'theme',
                                checked: displayCustom,
                                onChange: this.updateType.bind(this, 'custom')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.display.theme.customTheme',
                                defaultMessage: 'Custom Theme'
                            })
                        )
                    ));

                    inputs.push(custom);

                    inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'otherThemes' },
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'otherThemes',
                                href: 'http://docs.mattermost.com/help/settings/theme-colors.html#custom-theme-examples',
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.display.theme.otherThemes',
                                defaultMessage: 'See other themes'
                            })
                        )
                    ));

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'importSlackThemeButton',
                            className: 'padding-top'
                        },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'slackImportTheme',
                                className: 'theme',
                                onClick: this.handleImportModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.display.theme.import',
                                defaultMessage: 'Import theme colors from Slack'
                            })
                        )
                    ));
                }

                var allTeamsCheckbox = null;
                if (this.state.showAllTeamsCheckbox) {
                    allTeamsCheckbox = _react2.default.createElement(
                        'div',
                        { className: 'checkbox user-settings__submit-checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'applyThemeToAllTeams',
                                type: 'checkbox',
                                checked: this.state.applyToAllTeams,
                                onChange: function onChange(e) {
                                    return _this2.setState({ applyToAllTeams: e.target.checked });
                                }
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.display.theme.applyToAllTeams',
                                defaultMessage: 'Apply new theme to all my teams'
                            })
                        )
                    );
                }

                themeUI = _react2.default.createElement(_setting_item_max2.default, {
                    inputs: inputs,
                    submitExtra: allTeamsCheckbox,
                    submit: this.submitTheme,
                    saving: this.state.isSaving,
                    server_error: serverError,
                    width: 'full',
                    updateSection: this.handleUpdateSection
                });
            } else {
                themeUI = _react2.default.createElement(_setting_item_min2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.display.theme.title',
                        defaultMessage: 'Theme'
                    }),
                    describe: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.display.theme.describe',
                        defaultMessage: 'Open to manage your theme'
                    }),
                    section: 'theme',
                    updateSection: this.handleUpdateSection
                });
            }

            return themeUI;
        }
    }]);
    return ThemeSetting;
}(_react2.default.Component);

exports.default = ThemeSetting;


ThemeSetting.propTypes = {
    selected: _propTypes2.default.bool.isRequired,
    updateSection: _propTypes2.default.func.isRequired,
    setRequireConfirm: _propTypes2.default.func.isRequired,
    setEnforceFocus: _propTypes2.default.func.isRequired,
    allowCustomThemes: _propTypes2.default.bool,
    isLicensed: _propTypes2.default.bool.isRequired,
    ldap: _propTypes2.default.bool.isRequired
};

/***/ }),

/***/ 2137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(44);

var _extends4 = _interopRequireDefault(_extends3);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

__webpack_require__(2138);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _color_chooser = __webpack_require__(2178);

var _color_chooser2 = _interopRequireDefault(_color_chooser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
    sidebarBg: {
        id: 'user.settings.custom_theme.sidebarBg',
        defaultMessage: 'Sidebar BG'
    },
    sidebarText: {
        id: 'user.settings.custom_theme.sidebarText',
        defaultMessage: 'Sidebar Text'
    },
    sidebarHeaderBg: {
        id: 'user.settings.custom_theme.sidebarHeaderBg',
        defaultMessage: 'Sidebar Header BG'
    },
    sidebarHeaderTextColor: {
        id: 'user.settings.custom_theme.sidebarHeaderTextColor',
        defaultMessage: 'Sidebar Header Text'
    },
    sidebarUnreadText: {
        id: 'user.settings.custom_theme.sidebarUnreadText',
        defaultMessage: 'Sidebar Unread Text'
    },
    sidebarTextHoverBg: {
        id: 'user.settings.custom_theme.sidebarTextHoverBg',
        defaultMessage: 'Sidebar Text Hover BG'
    },
    sidebarTextActiveBorder: {
        id: 'user.settings.custom_theme.sidebarTextActiveBorder',
        defaultMessage: 'Sidebar Text Active Border'
    },
    sidebarTextActiveColor: {
        id: 'user.settings.custom_theme.sidebarTextActiveColor',
        defaultMessage: 'Sidebar Text Active Color'
    },
    onlineIndicator: {
        id: 'user.settings.custom_theme.onlineIndicator',
        defaultMessage: 'Online Indicator'
    },
    awayIndicator: {
        id: 'user.settings.custom_theme.awayIndicator',
        defaultMessage: 'Away Indicator'
    },
    dndIndicator: {
        id: 'user.settings.custom_theme.dndIndicator',
        defaultMessage: 'Do Not Disturb Indicator'
    },
    mentionBg: {
        id: 'user.settings.custom_theme.mentionBj',
        defaultMessage: 'Mention Jewel BG'
    },
    mentionColor: {
        id: 'user.settings.custom_theme.mentionColor',
        defaultMessage: 'Mention Jewel Text'
    },
    centerChannelBg: {
        id: 'user.settings.custom_theme.centerChannelBg',
        defaultMessage: 'Center Channel BG'
    },
    centerChannelColor: {
        id: 'user.settings.custom_theme.centerChannelColor',
        defaultMessage: 'Center Channel Text'
    },
    newMessageSeparator: {
        id: 'user.settings.custom_theme.newMessageSeparator',
        defaultMessage: 'New Message Separator'
    },
    linkColor: {
        id: 'user.settings.custom_theme.linkColor',
        defaultMessage: 'Link Color'
    },
    buttonBg: {
        id: 'user.settings.custom_theme.buttonBg',
        defaultMessage: 'Button BG'
    },
    buttonColor: {
        id: 'user.settings.custom_theme.buttonColor',
        defaultMessage: 'Button Text'
    },
    errorTextColor: {
        id: 'user.settings.custom_theme.errorTextColor',
        defaultMessage: 'Error Text Color'
    },
    mentionHighlightBg: {
        id: 'user.settings.custom_theme.mentionHighlightBg',
        defaultMessage: 'Mention Highlight BG'
    },
    mentionHighlightLink: {
        id: 'user.settings.custom_theme.mentionHighlightLink',
        defaultMessage: 'Mention Highlight Link'
    },
    codeTheme: {
        id: 'user.settings.custom_theme.codeTheme',
        defaultMessage: 'Code Theme'
    }
}); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CustomThemeChooser = function (_React$Component) {
    (0, _inherits3.default)(CustomThemeChooser, _React$Component);

    function CustomThemeChooser(props) {
        (0, _classCallCheck3.default)(this, CustomThemeChooser);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CustomThemeChooser.__proto__ || (0, _getPrototypeOf2.default)(CustomThemeChooser)).call(this, props));

        _initialiseProps.call(_this);

        var copyTheme = _this.setCopyTheme(_this.props.theme);

        _this.state = {
            copyTheme: copyTheme
        };
        return _this;
    }

    (0, _createClass3.default)(CustomThemeChooser, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _jquery2.default)('.group--code').on('change', this.onCodeThemeChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)('.group--code').off('change', this.onCodeThemeChange);
        }
    }, {
        key: 'setCopyTheme',
        value: function setCopyTheme(theme) {
            var copyTheme = (0, _assign2.default)({}, theme);
            delete copyTheme.type;
            delete copyTheme.image;

            return (0, _stringify2.default)(copyTheme);
        }
    }, {
        key: 'toggleSection',
        value: function toggleSection(node) {
            if (UserAgent.isIos()) {
                // iOS doesn't support jQuery animations
                (0, _jquery2.default)(node).toggleClass('open');
            } else {
                (0, _jquery2.default)(node).slideToggle();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var formatMessage = this.props.intl.formatMessage;

            var theme = this.props.theme;

            var sidebarElements = [];
            var centerChannelElements = [];
            var linkAndButtonElements = [];
            _constants2.default.THEME_ELEMENTS.forEach(function (element, index) {
                if (element.id === 'codeTheme') {
                    var codeThemeOptions = [];
                    var codeThemeURL = '';

                    element.themes.forEach(function (codeTheme, codeThemeIndex) {
                        if (codeTheme.id === theme[element.id]) {
                            codeThemeURL = codeTheme.iconURL;
                        }
                        codeThemeOptions.push(_react2.default.createElement(
                            'option',
                            {
                                key: 'code-theme-key' + codeThemeIndex,
                                value: codeTheme.id
                            },
                            codeTheme.uiName
                        ));
                    });

                    var popoverContent = _react2.default.createElement(
                        _reactBootstrap.Popover,
                        {
                            bsStyle: 'info',
                            id: 'code-popover',
                            className: 'code-popover'
                        },
                        _react2.default.createElement('img', {
                            width: '200',
                            src: codeThemeURL
                        })
                    );

                    centerChannelElements.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'col-sm-6 form-group',
                            key: 'custom-theme-key' + index
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'custom-label' },
                            formatMessage(messages[element.id])
                        ),
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'input-group theme-group group--code dropdown',
                                id: element.id
                            },
                            _react2.default.createElement(
                                'select',
                                {
                                    className: 'form-control',
                                    type: 'text',
                                    defaultValue: theme[element.id]
                                },
                                codeThemeOptions
                            ),
                            _react2.default.createElement(
                                _reactBootstrap.OverlayTrigger,
                                {
                                    trigger: ['hover', 'focus'],
                                    placement: 'top',
                                    overlay: popoverContent,
                                    ref: 'headerOverlay'
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'input-group-addon' },
                                    _react2.default.createElement('img', {
                                        src: codeThemeURL
                                    })
                                )
                            )
                        )
                    ));
                } else if (element.group === 'centerChannelElements') {
                    centerChannelElements.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'col-sm-6 form-group element',
                            key: 'custom-theme-key' + index
                        },
                        _react2.default.createElement(_color_chooser2.default, {
                            id: element.id,
                            label: formatMessage(messages[element.id]),
                            color: theme[element.id],
                            onChange: _this2.handleColorChange
                        })
                    ));
                } else if (element.group === 'sidebarElements') {
                    // Need to support old typo mentionBj element for mentionBg
                    var color = theme[element.id];
                    if (!color && element.id === 'mentionBg') {
                        color = theme.mentionBj;
                    }

                    sidebarElements.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'col-sm-6 form-group element',
                            key: 'custom-theme-key' + index
                        },
                        _react2.default.createElement(_color_chooser2.default, {
                            id: element.id,
                            label: formatMessage(messages[element.id]),
                            color: color,
                            onChange: _this2.handleColorChange
                        })
                    ));
                } else {
                    linkAndButtonElements.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'col-sm-6 form-group element',
                            key: 'custom-theme-key' + index
                        },
                        _react2.default.createElement(_color_chooser2.default, {
                            id: element.id,
                            label: formatMessage(messages[element.id]),
                            color: theme[element.id],
                            onChange: _this2.handleColorChange
                        })
                    ));
                }
            });

            var pasteBox = _react2.default.createElement(
                'div',
                { className: 'col-sm-12' },
                _react2.default.createElement(
                    'label',
                    { className: 'custom-label' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.custom_theme.copyPaste',
                        defaultMessage: 'Copy and paste to share theme colors:'
                    })
                ),
                _react2.default.createElement('textarea', {
                    ref: 'textarea',
                    className: 'form-control',
                    value: this.state.copyTheme,
                    onPaste: this.pasteBoxChange,
                    onChange: this.onChangeHandle,
                    onClick: this.selectTheme
                })
            );

            return _react2.default.createElement(
                'div',
                { className: 'appearance-section padding-top' },
                _react2.default.createElement(
                    'div',
                    { className: 'theme-elements row' },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'sidebarStylesHeader',
                            className: 'theme-elements__header',
                            onClick: this.toggleSidebarStyles
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.custom_theme.sidebarTitle',
                            defaultMessage: 'Sidebar Styles'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'header__icon' },
                            _react2.default.createElement('i', { className: 'fa fa-plus' }),
                            _react2.default.createElement('i', { className: 'fa fa-minus' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'sidebarStyles',
                            className: 'theme-elements__body'
                        },
                        sidebarElements
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'theme-elements row' },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'centerChannelStylesHeader',
                            className: 'theme-elements__header',
                            onClick: this.toggleCenterChannelStyles
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.custom_theme.centerChannelTitle',
                            defaultMessage: 'Center Channel Styles'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'header__icon' },
                            _react2.default.createElement('i', { className: 'fa fa-plus' }),
                            _react2.default.createElement('i', { className: 'fa fa-minus' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'centerChannelStyles',
                            className: 'theme-elements__body'
                        },
                        centerChannelElements
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'theme-elements row form-group' },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'linkAndButtonStylesHeader',
                            className: 'theme-elements__header',
                            onClick: this.toggleLinkAndButtonStyles
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.custom_theme.linkButtonTitle',
                            defaultMessage: 'Link and Button Styles'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'header__icon' },
                            _react2.default.createElement('i', { className: 'fa fa-plus' }),
                            _react2.default.createElement('i', { className: 'fa fa-minus' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'linkAndButtonStyles',
                            className: 'theme-elements__body'
                        },
                        linkAndButtonElements
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    pasteBox
                )
            );
        }
    }]);
    return CustomThemeChooser;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleColorChange = function (settingId, color) {
        var _props = _this3.props,
            updateTheme = _props.updateTheme,
            theme = _props.theme;

        if (theme[settingId] !== color) {
            var newTheme = (0, _extends4.default)({}, theme, (0, _defineProperty3.default)({
                type: 'custom'
            }, settingId, color));

            // For backwards compatability
            if (settingId === 'mentionBg') {
                newTheme.mentionBj = color;
            }

            updateTheme(newTheme);

            var copyTheme = _this3.setCopyTheme(newTheme);

            _this3.setState({
                copyTheme: copyTheme
            });
        }
    };

    this.pasteBoxChange = function (e) {
        var text = '';

        if (window.clipboardData && window.clipboardData.getData) {
            // IE
            text = window.clipboardData.getData('Text');
        } else {
            text = e.clipboardData.getData('Text'); //e.clipboardData.getData('text/plain');
        }

        if (text.length === 0) {
            return;
        }

        var theme = void 0;
        try {
            theme = JSON.parse(text);
        } catch (err) {
            return;
        }

        _this3.setState({
            copyTheme: (0, _stringify2.default)(theme)
        });

        theme.type = 'custom';
        _this3.props.updateTheme(theme);
    };

    this.onChangeHandle = function (e) {
        e.stopPropagation();
    };

    this.selectTheme = function () {
        var textarea = _this3.refs.textarea;
        textarea.focus();
        textarea.setSelectionRange(0, _this3.state.copyTheme.length);
    };

    this.toggleSidebarStyles = function (e) {
        e.preventDefault();

        (0, _jquery2.default)(_this3.refs.sidebarStylesHeader).toggleClass('open');
        _this3.toggleSection(_this3.refs.sidebarStyles);
    };

    this.toggleCenterChannelStyles = function (e) {
        e.preventDefault();

        (0, _jquery2.default)(_this3.refs.centerChannelStylesHeader).toggleClass('open');
        _this3.toggleSection(_this3.refs.centerChannelStyles);
    };

    this.toggleLinkAndButtonStyles = function (e) {
        e.preventDefault();

        (0, _jquery2.default)(_this3.refs.linkAndButtonStylesHeader).toggleClass('open');
        _this3.toggleSection(_this3.refs.linkAndButtonStyles);
    };

    this.onCodeThemeChange = function (e) {
        var theme = _this3.props.theme;
        theme.codeTheme = e.target.value;
        _this3.props.updateTheme(theme);
    };
};

CustomThemeChooser.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    theme: _propTypes2.default.object.isRequired,
    updateTheme: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(CustomThemeChooser);

/***/ }),

/***/ 2138:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Bootstrap Colorpicker v2.5.2
 * https://itsjavi.com/bootstrap-colorpicker/
 *
 * Originally written by (c) 2012 Stefan Petre
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0.txt
 *
 */

(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1054)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(jq) {
      return (factory(jq));
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else if (jQuery && !jQuery.fn.colorpicker) {
    factory(jQuery);
  }
}(this, function($) {
  'use strict';
  /**
   * Color manipulation helper class
   *
   * @param {Object|String} [val]
   * @param {Object} [predefinedColors]
   * @param {String|null} [fallbackColor]
   * @param {String|null} [fallbackFormat]
   * @param {Boolean} [hexNumberSignPrefix]
   * @constructor
   */
  var Color = function(
    val, predefinedColors, fallbackColor, fallbackFormat, hexNumberSignPrefix) {
    this.fallbackValue = fallbackColor ?
      (
        fallbackColor && (typeof fallbackColor.h !== 'undefined') ?
        fallbackColor :
        this.value = {
          h: 0,
          s: 0,
          b: 0,
          a: 1
        }
      ) :
      null;

    this.fallbackFormat = fallbackFormat ? fallbackFormat : 'rgba';

    this.hexNumberSignPrefix = hexNumberSignPrefix === true;

    this.value = this.fallbackValue;

    this.origFormat = null; // original string format

    this.predefinedColors = predefinedColors ? predefinedColors : {};

    // We don't want to share aliases across instances so we extend new object
    this.colors = $.extend({}, Color.webColors, this.predefinedColors);

    if (val) {
      if (typeof val.h !== 'undefined') {
        this.value = val;
      } else {
        this.setColor(String(val));
      }
    }

    if (!this.value) {
      // Initial value is always black if no arguments are passed or val is empty
      this.value = {
        h: 0,
        s: 0,
        b: 0,
        a: 1
      };
    }
  };

  Color.webColors = { // 140 predefined colors from the HTML Colors spec
    "aliceblue": "f0f8ff",
    "antiquewhite": "faebd7",
    "aqua": "00ffff",
    "aquamarine": "7fffd4",
    "azure": "f0ffff",
    "beige": "f5f5dc",
    "bisque": "ffe4c4",
    "black": "000000",
    "blanchedalmond": "ffebcd",
    "blue": "0000ff",
    "blueviolet": "8a2be2",
    "brown": "a52a2a",
    "burlywood": "deb887",
    "cadetblue": "5f9ea0",
    "chartreuse": "7fff00",
    "chocolate": "d2691e",
    "coral": "ff7f50",
    "cornflowerblue": "6495ed",
    "cornsilk": "fff8dc",
    "crimson": "dc143c",
    "cyan": "00ffff",
    "darkblue": "00008b",
    "darkcyan": "008b8b",
    "darkgoldenrod": "b8860b",
    "darkgray": "a9a9a9",
    "darkgreen": "006400",
    "darkkhaki": "bdb76b",
    "darkmagenta": "8b008b",
    "darkolivegreen": "556b2f",
    "darkorange": "ff8c00",
    "darkorchid": "9932cc",
    "darkred": "8b0000",
    "darksalmon": "e9967a",
    "darkseagreen": "8fbc8f",
    "darkslateblue": "483d8b",
    "darkslategray": "2f4f4f",
    "darkturquoise": "00ced1",
    "darkviolet": "9400d3",
    "deeppink": "ff1493",
    "deepskyblue": "00bfff",
    "dimgray": "696969",
    "dodgerblue": "1e90ff",
    "firebrick": "b22222",
    "floralwhite": "fffaf0",
    "forestgreen": "228b22",
    "fuchsia": "ff00ff",
    "gainsboro": "dcdcdc",
    "ghostwhite": "f8f8ff",
    "gold": "ffd700",
    "goldenrod": "daa520",
    "gray": "808080",
    "green": "008000",
    "greenyellow": "adff2f",
    "honeydew": "f0fff0",
    "hotpink": "ff69b4",
    "indianred": "cd5c5c",
    "indigo": "4b0082",
    "ivory": "fffff0",
    "khaki": "f0e68c",
    "lavender": "e6e6fa",
    "lavenderblush": "fff0f5",
    "lawngreen": "7cfc00",
    "lemonchiffon": "fffacd",
    "lightblue": "add8e6",
    "lightcoral": "f08080",
    "lightcyan": "e0ffff",
    "lightgoldenrodyellow": "fafad2",
    "lightgrey": "d3d3d3",
    "lightgreen": "90ee90",
    "lightpink": "ffb6c1",
    "lightsalmon": "ffa07a",
    "lightseagreen": "20b2aa",
    "lightskyblue": "87cefa",
    "lightslategray": "778899",
    "lightsteelblue": "b0c4de",
    "lightyellow": "ffffe0",
    "lime": "00ff00",
    "limegreen": "32cd32",
    "linen": "faf0e6",
    "magenta": "ff00ff",
    "maroon": "800000",
    "mediumaquamarine": "66cdaa",
    "mediumblue": "0000cd",
    "mediumorchid": "ba55d3",
    "mediumpurple": "9370d8",
    "mediumseagreen": "3cb371",
    "mediumslateblue": "7b68ee",
    "mediumspringgreen": "00fa9a",
    "mediumturquoise": "48d1cc",
    "mediumvioletred": "c71585",
    "midnightblue": "191970",
    "mintcream": "f5fffa",
    "mistyrose": "ffe4e1",
    "moccasin": "ffe4b5",
    "navajowhite": "ffdead",
    "navy": "000080",
    "oldlace": "fdf5e6",
    "olive": "808000",
    "olivedrab": "6b8e23",
    "orange": "ffa500",
    "orangered": "ff4500",
    "orchid": "da70d6",
    "palegoldenrod": "eee8aa",
    "palegreen": "98fb98",
    "paleturquoise": "afeeee",
    "palevioletred": "d87093",
    "papayawhip": "ffefd5",
    "peachpuff": "ffdab9",
    "peru": "cd853f",
    "pink": "ffc0cb",
    "plum": "dda0dd",
    "powderblue": "b0e0e6",
    "purple": "800080",
    "red": "ff0000",
    "rosybrown": "bc8f8f",
    "royalblue": "4169e1",
    "saddlebrown": "8b4513",
    "salmon": "fa8072",
    "sandybrown": "f4a460",
    "seagreen": "2e8b57",
    "seashell": "fff5ee",
    "sienna": "a0522d",
    "silver": "c0c0c0",
    "skyblue": "87ceeb",
    "slateblue": "6a5acd",
    "slategray": "708090",
    "snow": "fffafa",
    "springgreen": "00ff7f",
    "steelblue": "4682b4",
    "tan": "d2b48c",
    "teal": "008080",
    "thistle": "d8bfd8",
    "tomato": "ff6347",
    "turquoise": "40e0d0",
    "violet": "ee82ee",
    "wheat": "f5deb3",
    "white": "ffffff",
    "whitesmoke": "f5f5f5",
    "yellow": "ffff00",
    "yellowgreen": "9acd32",
    "transparent": "transparent"
  };

  Color.prototype = {
    constructor: Color,
    colors: {}, // merged web and predefined colors
    predefinedColors: {},
    /**
     * @return {Object}
     */
    getValue: function() {
      return this.value;
    },
    /**
     * @param {Object} val
     */
    setValue: function(val) {
      this.value = val;
    },
    _sanitizeNumber: function(val) {
      if (typeof val === 'number') {
        return val;
      }
      if (isNaN(val) || (val === null) || (val === '') || (val === undefined)) {
        return 1;
      }
      if (val === '') {
        return 0;
      }
      if (typeof val.toLowerCase !== 'undefined') {
        if (val.match(/^\./)) {
          val = "0" + val;
        }
        return Math.ceil(parseFloat(val) * 100) / 100;
      }
      return 1;
    },
    isTransparent: function(strVal) {
      if (!strVal || !(typeof strVal === 'string' || strVal instanceof String)) {
        return false;
      }
      strVal = strVal.toLowerCase().trim();
      return (strVal === 'transparent') || (strVal.match(/#?00000000/)) || (strVal.match(/(rgba|hsla)\(0,0,0,0?\.?0\)/));
    },
    rgbaIsTransparent: function(rgba) {
      return ((rgba.r === 0) && (rgba.g === 0) && (rgba.b === 0) && (rgba.a === 0));
    },
    // parse a string to HSB
    /**
     * @protected
     * @param {String} strVal
     * @returns {boolean} Returns true if it could be parsed, false otherwise
     */
    setColor: function(strVal) {
      strVal = strVal.toLowerCase().trim();
      if (strVal) {
        if (this.isTransparent(strVal)) {
          this.value = {
            h: 0,
            s: 0,
            b: 0,
            a: 0
          };
          return true;
        } else {
          var parsedColor = this.parse(strVal);
          if (parsedColor) {
            this.value = this.value = {
              h: parsedColor.h,
              s: parsedColor.s,
              b: parsedColor.b,
              a: parsedColor.a
            };
            if (!this.origFormat) {
              this.origFormat = parsedColor.format;
            }
          } else if (this.fallbackValue) {
            // if parser fails, defaults to fallbackValue if defined, otherwise the value won't be changed
            this.value = this.fallbackValue;
          }
        }
      }
      return false;
    },
    setHue: function(h) {
      this.value.h = 1 - h;
    },
    setSaturation: function(s) {
      this.value.s = s;
    },
    setBrightness: function(b) {
      this.value.b = 1 - b;
    },
    setAlpha: function(a) {
      this.value.a = Math.round((parseInt((1 - a) * 100, 10) / 100) * 100) / 100;
    },
    toRGB: function(h, s, b, a) {
      if (arguments.length === 0) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
        a = this.value.a;
      }

      h *= 360;
      var R, G, B, X, C;
      h = (h % 360) / 60;
      C = b * s;
      X = C * (1 - Math.abs(h % 2 - 1));
      R = G = B = b - C;

      h = ~~h;
      R += [C, X, 0, 0, X, C][h];
      G += [X, C, C, X, 0, 0][h];
      B += [0, 0, X, C, C, X][h];

      return {
        r: Math.round(R * 255),
        g: Math.round(G * 255),
        b: Math.round(B * 255),
        a: a
      };
    },
    toHex: function(ignoreFormat, h, s, b, a) {
      if (arguments.length <= 1) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
        a = this.value.a;
      }

      var prefix = '#';
      var rgb = this.toRGB(h, s, b, a);

      if (this.rgbaIsTransparent(rgb)) {
        return 'transparent';
      }

      if (!ignoreFormat) {
        prefix = (this.hexNumberSignPrefix ? '#' : '');
      }

      var hexStr = prefix + (
          (1 << 24) +
          (parseInt(rgb.r) << 16) +
          (parseInt(rgb.g) << 8) +
          parseInt(rgb.b))
        .toString(16)
        .slice(1);

      return hexStr;
    },
    toHSL: function(h, s, b, a) {
      if (arguments.length === 0) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
        a = this.value.a;
      }

      var H = h,
        L = (2 - s) * b,
        S = s * b;
      if (L > 0 && L <= 1) {
        S /= L;
      } else {
        S /= 2 - L;
      }
      L /= 2;
      if (S > 1) {
        S = 1;
      }
      return {
        h: isNaN(H) ? 0 : H,
        s: isNaN(S) ? 0 : S,
        l: isNaN(L) ? 0 : L,
        a: isNaN(a) ? 0 : a
      };
    },
    toAlias: function(r, g, b, a) {
      var c, rgb = (arguments.length === 0) ? this.toHex(true) : this.toHex(true, r, g, b, a);

      // support predef. colors in non-hex format too, as defined in the alias itself
      var original = this.origFormat === 'alias' ? rgb : this.toString(false, this.origFormat);

      for (var alias in this.colors) {
        c = this.colors[alias].toLowerCase().trim();
        if ((c === rgb) || (c === original)) {
          return alias;
        }
      }
      return false;
    },
    RGBtoHSB: function(r, g, b, a) {
      r /= 255;
      g /= 255;
      b /= 255;

      var H, S, V, C;
      V = Math.max(r, g, b);
      C = V - Math.min(r, g, b);
      H = (C === 0 ? null :
        V === r ? (g - b) / C :
        V === g ? (b - r) / C + 2 :
        (r - g) / C + 4
      );
      H = ((H + 360) % 6) * 60 / 360;
      S = C === 0 ? 0 : C / V;
      return {
        h: this._sanitizeNumber(H),
        s: S,
        b: V,
        a: this._sanitizeNumber(a)
      };
    },
    HueToRGB: function(p, q, h) {
      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
      if ((h * 6) < 1) {
        return p + (q - p) * h * 6;
      } else if ((h * 2) < 1) {
        return q;
      } else if ((h * 3) < 2) {
        return p + (q - p) * ((2 / 3) - h) * 6;
      } else {
        return p;
      }
    },
    HSLtoRGB: function(h, s, l, a) {
      if (s < 0) {
        s = 0;
      }
      var q;
      if (l <= 0.5) {
        q = l * (1 + s);
      } else {
        q = l + s - (l * s);
      }

      var p = 2 * l - q;

      var tr = h + (1 / 3);
      var tg = h;
      var tb = h - (1 / 3);

      var r = Math.round(this.HueToRGB(p, q, tr) * 255);
      var g = Math.round(this.HueToRGB(p, q, tg) * 255);
      var b = Math.round(this.HueToRGB(p, q, tb) * 255);
      return [r, g, b, this._sanitizeNumber(a)];
    },
    /**
     * @param {String} strVal
     * @returns {Object} Object containing h,s,b,a,format properties or FALSE if failed to parse
     */
    parse: function(strVal) {
      if (arguments.length === 0) {
        return false;
      }

      var that = this,
        result = false,
        isAlias = (typeof this.colors[strVal] !== 'undefined'),
        values, format;

      if (isAlias) {
        strVal = this.colors[strVal].toLowerCase().trim();
      }

      $.each(this.stringParsers, function(i, parser) {
        var match = parser.re.exec(strVal);
        values = match && parser.parse.apply(that, [match]);
        if (values) {
          result = {};
          format = (isAlias ? 'alias' : (parser.format ? parser.format : that.getValidFallbackFormat()));
          if (format.match(/hsla?/)) {
            result = that.RGBtoHSB.apply(that, that.HSLtoRGB.apply(that, values));
          } else {
            result = that.RGBtoHSB.apply(that, values);
          }
          if (result instanceof Object) {
            result.format = format;
          }
          return false; // stop iterating
        }
        return true;
      });
      return result;
    },
    getValidFallbackFormat: function() {
      var formats = [
        'rgba', 'rgb', 'hex', 'hsla', 'hsl'
      ];
      if (this.origFormat && (formats.indexOf(this.origFormat) !== -1)) {
        return this.origFormat;
      }
      if (this.fallbackFormat && (formats.indexOf(this.fallbackFormat) !== -1)) {
        return this.fallbackFormat;
      }

      return 'rgba'; // By default, return a format that will not lose the alpha info
    },
    /**
     *
     * @param {string} [format] (default: rgba)
     * @param {boolean} [translateAlias] Return real color for pre-defined (non-standard) aliases (default: false)
     * @param {boolean} [forceRawValue] Forces hashtag prefix when getting hex color (default: false)
     * @returns {String}
     */
    toString: function(forceRawValue, format, translateAlias) {
      format = format || this.origFormat || this.fallbackFormat;
      translateAlias = translateAlias || false;

      var c = false;

      switch (format) {
        case 'rgb':
          {
            c = this.toRGB();
            if (this.rgbaIsTransparent(c)) {
              return 'transparent';
            }
            return 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')';
          }
          break;
        case 'rgba':
          {
            c = this.toRGB();
            return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + c.a + ')';
          }
          break;
        case 'hsl':
          {
            c = this.toHSL();
            return 'hsl(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%)';
          }
          break;
        case 'hsla':
          {
            c = this.toHSL();
            return 'hsla(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%,' + c.a + ')';
          }
          break;
        case 'hex':
          {
            return this.toHex(forceRawValue);
          }
          break;
        case 'alias':
          {
            c = this.toAlias();

            if (c === false) {
              return this.toString(forceRawValue, this.getValidFallbackFormat());
            }

            if (translateAlias && !(c in Color.webColors) && (c in this.predefinedColors)) {
              return this.predefinedColors[c];
            }

            return c;
          }
        default:
          {
            return c;
          }
          break;
      }
    },
    // a set of RE's that can match strings and generate color tuples.
    // from John Resig color plugin
    // https://github.com/jquery/jquery-color/
    stringParsers: [{
      re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
      format: 'rgb',
      parse: function(execResult) {
        return [
          execResult[1],
          execResult[2],
          execResult[3],
          1
        ];
      }
    }, {
      re: /rgb\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,
      format: 'rgb',
      parse: function(execResult) {
        return [
          2.55 * execResult[1],
          2.55 * execResult[2],
          2.55 * execResult[3],
          1
        ];
      }
    }, {
      re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
      format: 'rgba',
      parse: function(execResult) {
        return [
          execResult[1],
          execResult[2],
          execResult[3],
          execResult[4]
        ];
      }
    }, {
      re: /rgba\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
      format: 'rgba',
      parse: function(execResult) {
        return [
          2.55 * execResult[1],
          2.55 * execResult[2],
          2.55 * execResult[3],
          execResult[4]
        ];
      }
    }, {
      re: /hsl\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,
      format: 'hsl',
      parse: function(execResult) {
        return [
          execResult[1] / 360,
          execResult[2] / 100,
          execResult[3] / 100,
          execResult[4]
        ];
      }
    }, {
      re: /hsla\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
      format: 'hsla',
      parse: function(execResult) {
        return [
          execResult[1] / 360,
          execResult[2] / 100,
          execResult[3] / 100,
          execResult[4]
        ];
      }
    }, {
      re: /#?([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
      format: 'hex',
      parse: function(execResult) {
        return [
          parseInt(execResult[1], 16),
          parseInt(execResult[2], 16),
          parseInt(execResult[3], 16),
          1
        ];
      }
    }, {
      re: /#?([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
      format: 'hex',
      parse: function(execResult) {
        return [
          parseInt(execResult[1] + execResult[1], 16),
          parseInt(execResult[2] + execResult[2], 16),
          parseInt(execResult[3] + execResult[3], 16),
          1
        ];
      }
    }],
    colorNameToHex: function(name) {
      if (typeof this.colors[name.toLowerCase()] !== 'undefined') {
        return this.colors[name.toLowerCase()];
      }
      return false;
    }
  };

  /*
   * Default plugin options
   */
  var defaults = {
    horizontal: false, // horizontal mode layout ?
    inline: false, //forces to show the colorpicker as an inline element
    color: false, //forces a color
    format: false, //forces a format
    input: 'input', // children input selector
    container: false, // container selector
    component: '.add-on, .input-group-addon', // children component selector
    fallbackColor: false, // fallback color value. null = keeps current color.
    fallbackFormat: 'hex', // fallback color format
    hexNumberSignPrefix: true, // put a '#' (number sign) before hex strings
    sliders: {
      saturation: {
        maxLeft: 100,
        maxTop: 100,
        callLeft: 'setSaturation',
        callTop: 'setBrightness'
      },
      hue: {
        maxLeft: 0,
        maxTop: 100,
        callLeft: false,
        callTop: 'setHue'
      },
      alpha: {
        maxLeft: 0,
        maxTop: 100,
        callLeft: false,
        callTop: 'setAlpha'
      }
    },
    slidersHorz: {
      saturation: {
        maxLeft: 100,
        maxTop: 100,
        callLeft: 'setSaturation',
        callTop: 'setBrightness'
      },
      hue: {
        maxLeft: 100,
        maxTop: 0,
        callLeft: 'setHue',
        callTop: false
      },
      alpha: {
        maxLeft: 100,
        maxTop: 0,
        callLeft: 'setAlpha',
        callTop: false
      }
    },
    template: '<div class="colorpicker dropdown-menu">' +
      '<div class="colorpicker-saturation"><i><b></b></i></div>' +
      '<div class="colorpicker-hue"><i></i></div>' +
      '<div class="colorpicker-alpha"><i></i></div>' +
      '<div class="colorpicker-color"><div /></div>' +
      '<div class="colorpicker-selectors"></div>' +
      '</div>',
    align: 'right',
    customClass: null, // custom class added to the colorpicker element
    colorSelectors: null // custom color aliases
  };

  /**
   * Colorpicker component class
   *
   * @param {Object|String} element
   * @param {Object} options
   * @constructor
   */
  var Colorpicker = function(element, options) {
    this.element = $(element).addClass('colorpicker-element');
    this.options = $.extend(true, {}, defaults, this.element.data(), options);
    this.component = this.options.component;
    this.component = (this.component !== false) ? this.element.find(this.component) : false;
    if (this.component && (this.component.length === 0)) {
      this.component = false;
    }
    this.container = (this.options.container === true) ? this.element : this.options.container;
    this.container = (this.container !== false) ? $(this.container) : false;

    // Is the element an input? Should we search inside for any input?
    this.input = this.element.is('input') ? this.element : (this.options.input ?
      this.element.find(this.options.input) : false);
    if (this.input && (this.input.length === 0)) {
      this.input = false;
    }
    // Set HSB color
    this.color = this.createColor(this.options.color !== false ? this.options.color : this.getValue());

    this.format = this.options.format !== false ? this.options.format : this.color.origFormat;

    if (this.options.color !== false) {
      this.updateInput(this.color);
      this.updateData(this.color);
    }

    this.disabled = false;

    // Setup picker
    var $picker = this.picker = $(this.options.template);
    if (this.options.customClass) {
      $picker.addClass(this.options.customClass);
    }
    if (this.options.inline) {
      $picker.addClass('colorpicker-inline colorpicker-visible');
    } else {
      $picker.addClass('colorpicker-hidden');
    }
    if (this.options.horizontal) {
      $picker.addClass('colorpicker-horizontal');
    }
    if (
      (['rgba', 'hsla', 'alias'].indexOf(this.format) !== -1) ||
      this.options.format === false ||
      this.getValue() === 'transparent'
    ) {
      $picker.addClass('colorpicker-with-alpha');
    }
    if (this.options.align === 'right') {
      $picker.addClass('colorpicker-right');
    }
    if (this.options.inline === true) {
      $picker.addClass('colorpicker-no-arrow');
    }
    if (this.options.colorSelectors) {
      var colorpicker = this,
        selectorsContainer = colorpicker.picker.find('.colorpicker-selectors');

      if (selectorsContainer.length > 0) {
        $.each(this.options.colorSelectors, function(name, color) {
          var $btn = $('<i />')
            .addClass('colorpicker-selectors-color')
            .css('background-color', color)
            .data('class', name).data('alias', name);

          $btn.on('mousedown.colorpicker touchstart.colorpicker', function(event) {
            event.preventDefault();
            colorpicker.setValue(
              colorpicker.format === 'alias' ? $(this).data('alias') : $(this).css('background-color')
            );
          });
          selectorsContainer.append($btn);
        });
        selectorsContainer.show().addClass('colorpicker-visible');
      }
    }

    // Prevent closing the colorpicker when clicking on itself
    $picker.on('mousedown.colorpicker touchstart.colorpicker', $.proxy(function(e) {
      if (e.target === e.currentTarget) {
        e.preventDefault();
      }
    }, this));

    // Bind click/tap events on the sliders
    $picker.find('.colorpicker-saturation, .colorpicker-hue, .colorpicker-alpha')
      .on('mousedown.colorpicker touchstart.colorpicker', $.proxy(this.mousedown, this));

    $picker.appendTo(this.container ? this.container : $('body'));

    // Bind other events
    if (this.input !== false) {
      this.input.on({
        'keyup.colorpicker': $.proxy(this.keyup, this)
      });
      this.input.on({
        'change.colorpicker': $.proxy(this.change, this)
      });
      if (this.component === false) {
        this.element.on({
          'focus.colorpicker': $.proxy(this.show, this)
        });
      }
      if (this.options.inline === false) {
        this.element.on({
          'focusout.colorpicker': $.proxy(this.hide, this)
        });
      }
    }

    if (this.component !== false) {
      this.component.on({
        'click.colorpicker': $.proxy(this.show, this)
      });
    }

    if ((this.input === false) && (this.component === false)) {
      this.element.on({
        'click.colorpicker': $.proxy(this.show, this)
      });
    }

    // for HTML5 input[type='color']
    if ((this.input !== false) && (this.component !== false) && (this.input.attr('type') === 'color')) {

      this.input.on({
        'click.colorpicker': $.proxy(this.show, this),
        'focus.colorpicker': $.proxy(this.show, this)
      });
    }
    this.update();

    $($.proxy(function() {
      this.element.trigger('create');
    }, this));
  };

  Colorpicker.Color = Color;

  Colorpicker.prototype = {
    constructor: Colorpicker,
    destroy: function() {
      this.picker.remove();
      this.element.removeData('colorpicker', 'color').off('.colorpicker');
      if (this.input !== false) {
        this.input.off('.colorpicker');
      }
      if (this.component !== false) {
        this.component.off('.colorpicker');
      }
      this.element.removeClass('colorpicker-element');
      this.element.trigger({
        type: 'destroy'
      });
    },
    reposition: function() {
      if (this.options.inline !== false || this.options.container) {
        return false;
      }
      var type = this.container && this.container[0] !== window.document.body ? 'position' : 'offset';
      var element = this.component || this.element;
      var offset = element[type]();
      if (this.options.align === 'right') {
        offset.left -= this.picker.outerWidth() - element.outerWidth();
      }
      this.picker.css({
        top: offset.top + element.outerHeight(),
        left: offset.left
      });
    },
    show: function(e) {
      if (this.isDisabled()) {
        // Don't show the widget if it's disabled (the input)
        return;
      }
      this.picker.addClass('colorpicker-visible').removeClass('colorpicker-hidden');
      this.reposition();
      $(window).on('resize.colorpicker', $.proxy(this.reposition, this));
      if (e && (!this.hasInput() || this.input.attr('type') === 'color')) {
        if (e.stopPropagation && e.preventDefault) {
          e.stopPropagation();
          e.preventDefault();
        }
      }
      if ((this.component || !this.input) && (this.options.inline === false)) {
        $(window.document).on({
          'mousedown.colorpicker': $.proxy(this.hide, this)
        });
      }
      this.element.trigger({
        type: 'showPicker',
        color: this.color
      });
    },
    hide: function(e) {
      if ((typeof e !== 'undefined') && e.target) {
        // Prevent hide if triggered by an event and an element inside the colorpicker has been clicked/touched
        if (
          $(e.currentTarget).parents('.colorpicker').length > 0 ||
          $(e.target).parents('.colorpicker').length > 0
        ) {
          return false;
        }
      }
      this.picker.addClass('colorpicker-hidden').removeClass('colorpicker-visible');
      $(window).off('resize.colorpicker', this.reposition);
      $(window.document).off({
        'mousedown.colorpicker': this.hide
      });
      this.update();
      this.element.trigger({
        type: 'hidePicker',
        color: this.color
      });
    },
    updateData: function(val) {
      val = val || this.color.toString(false, this.format);
      this.element.data('color', val);
      return val;
    },
    updateInput: function(val) {
      val = val || this.color.toString(false, this.format);
      if (this.input !== false) {
        this.input.prop('value', val);
        this.input.trigger('change');
      }
      return val;
    },
    updatePicker: function(val) {
      if (typeof val !== 'undefined') {
        this.color = this.createColor(val);
      }
      var sl = (this.options.horizontal === false) ? this.options.sliders : this.options.slidersHorz;
      var icns = this.picker.find('i');
      if (icns.length === 0) {
        return;
      }
      if (this.options.horizontal === false) {
        sl = this.options.sliders;
        icns.eq(1).css('top', sl.hue.maxTop * (1 - this.color.value.h)).end()
          .eq(2).css('top', sl.alpha.maxTop * (1 - this.color.value.a));
      } else {
        sl = this.options.slidersHorz;
        icns.eq(1).css('left', sl.hue.maxLeft * (1 - this.color.value.h)).end()
          .eq(2).css('left', sl.alpha.maxLeft * (1 - this.color.value.a));
      }
      icns.eq(0).css({
        'top': sl.saturation.maxTop - this.color.value.b * sl.saturation.maxTop,
        'left': this.color.value.s * sl.saturation.maxLeft
      });

      this.picker.find('.colorpicker-saturation')
        .css('backgroundColor', this.color.toHex(true, this.color.value.h, 1, 1, 1));

      this.picker.find('.colorpicker-alpha')
        .css('backgroundColor', this.color.toHex(true));

      this.picker.find('.colorpicker-color, .colorpicker-color div')
        .css('backgroundColor', this.color.toString(true, this.format));

      return val;
    },
    updateComponent: function(val) {
      var color;

      if (typeof val !== 'undefined') {
        color = this.createColor(val);
      } else {
        color = this.color;
      }

      if (this.component !== false) {
        var icn = this.component.find('i').eq(0);
        if (icn.length > 0) {
          icn.css({
            'backgroundColor': color.toString(true, this.format)
          });
        } else {
          this.component.css({
            'backgroundColor': color.toString(true, this.format)
          });
        }
      }

      return color.toString(false, this.format);
    },
    update: function(force) {
      var val;
      if ((this.getValue(false) !== false) || (force === true)) {
        // Update input/data only if the current value is not empty
        val = this.updateComponent();
        this.updateInput(val);
        this.updateData(val);
        this.updatePicker(); // only update picker if value is not empty
      }
      return val;

    },
    setValue: function(val) { // set color manually
      this.color = this.createColor(val);
      this.update(true);
      this.element.trigger({
        type: 'changeColor',
        color: this.color,
        value: val
      });
    },
    /**
     * Creates a new color using the instance options
     * @protected
     * @param {String} val
     * @returns {Color}
     */
    createColor: function(val) {
      return new Color(
        val ? val : null,
        this.options.colorSelectors,
        this.options.fallbackColor ? this.options.fallbackColor : this.color,
        this.options.fallbackFormat,
        this.options.hexNumberSignPrefix
      );
    },
    getValue: function(defaultValue) {
      defaultValue = (typeof defaultValue === 'undefined') ? this.options.fallbackColor : defaultValue;
      var val;
      if (this.hasInput()) {
        val = this.input.val();
      } else {
        val = this.element.data('color');
      }
      if ((val === undefined) || (val === '') || (val === null)) {
        // if not defined or empty, return default
        val = defaultValue;
      }
      return val;
    },
    hasInput: function() {
      return (this.input !== false);
    },
    isDisabled: function() {
      return this.disabled;
    },
    disable: function() {
      if (this.hasInput()) {
        this.input.prop('disabled', true);
      }
      this.disabled = true;
      this.element.trigger({
        type: 'disable',
        color: this.color,
        value: this.getValue()
      });
      return true;
    },
    enable: function() {
      if (this.hasInput()) {
        this.input.prop('disabled', false);
      }
      this.disabled = false;
      this.element.trigger({
        type: 'enable',
        color: this.color,
        value: this.getValue()
      });
      return true;
    },
    currentSlider: null,
    mousePointer: {
      left: 0,
      top: 0
    },
    mousedown: function(e) {
      if (!e.pageX && !e.pageY && e.originalEvent && e.originalEvent.touches) {
        e.pageX = e.originalEvent.touches[0].pageX;
        e.pageY = e.originalEvent.touches[0].pageY;
      }
      e.stopPropagation();
      e.preventDefault();

      var target = $(e.target);

      //detect the slider and set the limits and callbacks
      var zone = target.closest('div');
      var sl = this.options.horizontal ? this.options.slidersHorz : this.options.sliders;
      if (!zone.is('.colorpicker')) {
        if (zone.is('.colorpicker-saturation')) {
          this.currentSlider = $.extend({}, sl.saturation);
        } else if (zone.is('.colorpicker-hue')) {
          this.currentSlider = $.extend({}, sl.hue);
        } else if (zone.is('.colorpicker-alpha')) {
          this.currentSlider = $.extend({}, sl.alpha);
        } else {
          return false;
        }
        var offset = zone.offset();
        //reference to guide's style
        this.currentSlider.guide = zone.find('i')[0].style;
        this.currentSlider.left = e.pageX - offset.left;
        this.currentSlider.top = e.pageY - offset.top;
        this.mousePointer = {
          left: e.pageX,
          top: e.pageY
        };
        //trigger mousemove to move the guide to the current position
        $(window.document).on({
          'mousemove.colorpicker': $.proxy(this.mousemove, this),
          'touchmove.colorpicker': $.proxy(this.mousemove, this),
          'mouseup.colorpicker': $.proxy(this.mouseup, this),
          'touchend.colorpicker': $.proxy(this.mouseup, this)
        }).trigger('mousemove');
      }
      return false;
    },
    mousemove: function(e) {
      if (!e.pageX && !e.pageY && e.originalEvent && e.originalEvent.touches) {
        e.pageX = e.originalEvent.touches[0].pageX;
        e.pageY = e.originalEvent.touches[0].pageY;
      }
      e.stopPropagation();
      e.preventDefault();
      var left = Math.max(
        0,
        Math.min(
          this.currentSlider.maxLeft,
          this.currentSlider.left + ((e.pageX || this.mousePointer.left) - this.mousePointer.left)
        )
      );
      var top = Math.max(
        0,
        Math.min(
          this.currentSlider.maxTop,
          this.currentSlider.top + ((e.pageY || this.mousePointer.top) - this.mousePointer.top)
        )
      );
      this.currentSlider.guide.left = left + 'px';
      this.currentSlider.guide.top = top + 'px';
      if (this.currentSlider.callLeft) {
        this.color[this.currentSlider.callLeft].call(this.color, left / this.currentSlider.maxLeft);
      }
      if (this.currentSlider.callTop) {
        this.color[this.currentSlider.callTop].call(this.color, top / this.currentSlider.maxTop);
      }
      // Change format dynamically
      // Only occurs if user choose the dynamic format by
      // setting option format to false
      if (
        this.options.format === false &&
        (this.currentSlider.callTop === 'setAlpha' ||
          this.currentSlider.callLeft === 'setAlpha')
      ) {

        // Converting from hex / rgb to rgba
        if (this.color.value.a !== 1) {
          this.format = 'rgba';
          this.color.origFormat = 'rgba';
        }

        // Converting from rgba to hex
        else {
          this.format = 'hex';
          this.color.origFormat = 'hex';
        }
      }
      this.update(true);

      this.element.trigger({
        type: 'changeColor',
        color: this.color
      });
      return false;
    },
    mouseup: function(e) {
      e.stopPropagation();
      e.preventDefault();
      $(window.document).off({
        'mousemove.colorpicker': this.mousemove,
        'touchmove.colorpicker': this.mousemove,
        'mouseup.colorpicker': this.mouseup,
        'touchend.colorpicker': this.mouseup
      });
      return false;
    },
    change: function(e) {
      this.keyup(e);
    },
    keyup: function(e) {
      if ((e.keyCode === 38)) {
        if (this.color.value.a < 1) {
          this.color.value.a = Math.round((this.color.value.a + 0.01) * 100) / 100;
        }
        this.update(true);
      } else if ((e.keyCode === 40)) {
        if (this.color.value.a > 0) {
          this.color.value.a = Math.round((this.color.value.a - 0.01) * 100) / 100;
        }
        this.update(true);
      } else {
        this.color = this.createColor(this.input.val());
        // Change format dynamically
        // Only occurs if user choose the dynamic format by
        // setting option format to false
        if (this.color.origFormat && this.options.format === false) {
          this.format = this.color.origFormat;
        }
        if (this.getValue(false) !== false) {
          this.updateData();
          this.updateComponent();
          this.updatePicker();
        }
      }
      this.element.trigger({
        type: 'changeColor',
        color: this.color,
        value: this.input.val()
      });
    }
  };

  $.colorpicker = Colorpicker;

  $.fn.colorpicker = function(option) {
    var apiArgs = Array.prototype.slice.call(arguments, 1),
      isSingleElement = (this.length === 1),
      returnValue = null;

    var $jq = this.each(function() {
      var $this = $(this),
        inst = $this.data('colorpicker'),
        options = ((typeof option === 'object') ? option : {});

      if (!inst) {
        inst = new Colorpicker(this, options);
        $this.data('colorpicker', inst);
      }

      if (typeof option === 'string') {
        if ($.isFunction(inst[option])) {
          returnValue = inst[option].apply(inst, apiArgs);
        } else { // its a property ?
          if (apiArgs.length) {
            // set property
            inst[option] = apiArgs[0];
          }
          returnValue = inst[option];
        }
      } else {
        returnValue = $this;
      }
    });
    return isSingleElement ? returnValue : $jq;
  };

  $.fn.colorpicker.constructor = Colorpicker;

}));


/***/ }),

/***/ 2139:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return Object.getPrototypeOf;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2140:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1055)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( class2type ) {
	"use strict";

	return class2type.toString;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2141:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1342)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( fnToString ) {
	"use strict";

	return fnToString.call( Object );
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2142:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(2143)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, Sizzle ) {

"use strict";

jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2143:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

// EXPOSE
var _sizzle = window.Sizzle;

Sizzle.noConflict = function() {
	if ( window.Sizzle === Sizzle ) {
		window.Sizzle = _sizzle;
	}

	return Sizzle;
};

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return Sizzle; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
// Sizzle requires that there be a global window in Common-JS like environments
} else if ( typeof module !== "undefined" && module.exports ) {
	module.exports = Sizzle;
} else {
	window.Sizzle = Sizzle;
}
// EXPOSE

})( window );


/***/ }),

/***/ 2144:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2145:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

return function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2146:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

return function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2147:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(910)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2148:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(890),
	__webpack_require__(850),
	__webpack_require__(1355)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, dataPriv, dataUser ) {

"use strict";

//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2149:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1066),
	__webpack_require__(1067) // Delay is optional because of this dependency
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};

return jQuery.fn.delay;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2150:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(850),
	__webpack_require__(1356)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, dataPriv, isHiddenWithinTree ) {

"use strict";

var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );

return showHide;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2151:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(813),
	__webpack_require__(889)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document, support ) {

"use strict";

( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2152:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(934)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2153:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(2154),
	__webpack_require__(1364),
	__webpack_require__(2155),
	__webpack_require__(2156)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Return jQuery for attributes-only inclusion
return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2154:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(890),
	__webpack_require__(868),
	__webpack_require__(1068),
	__webpack_require__(867),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, nodeName, support, rnothtmlwhite ) {

"use strict";

var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2155:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1069),
	__webpack_require__(867),
	__webpack_require__(850),
	__webpack_require__(839)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, stripAndCollapse, rnothtmlwhite, dataPriv ) {

"use strict";

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2156:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1069),
	__webpack_require__(1068),
	__webpack_require__(868),

	__webpack_require__(839)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, stripAndCollapse, support, nodeName ) {

"use strict";

var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2157:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),

	__webpack_require__(912),
	__webpack_require__(1070)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2158:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(850),
	__webpack_require__(2159),

	__webpack_require__(912),
	__webpack_require__(1070)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, dataPriv, support ) {

"use strict";

// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2159:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(889)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2160:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(913)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};

return jQuery._evalUrl;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2161:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return window.location;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2162:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};

return jQuery.parseXML;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2163:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(839),
	__webpack_require__(978), // clone
	__webpack_require__(911) // parent, contents
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2164:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2165:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(889),
	__webpack_require__(913)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, support ) {

"use strict";

jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2166:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(913)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document ) {

"use strict";

// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2167:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1365),
	__webpack_require__(1366),
	__webpack_require__(913)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, nonce, rquery ) {

"use strict";

var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2168:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1069),
	__webpack_require__(2169),
	__webpack_require__(913),
	__webpack_require__(911),
	__webpack_require__(978),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, stripAndCollapse ) {

"use strict";

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2169:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(1350),
	__webpack_require__(1363),

	// This is the only module that needs core/support
	__webpack_require__(2170)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, rsingleTag, buildFragment, support ) {

"use strict";

// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};

return jQuery.parseHTML;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2170:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(813),
	__webpack_require__(889)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document, support ) {

"use strict";

// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();

return support;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2171:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(912)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2172:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(820),
	__webpack_require__(1067)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2173:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(890),
	__webpack_require__(813),
	__webpack_require__(1063),
	__webpack_require__(1061),
	__webpack_require__(1347),
	__webpack_require__(1349),
	__webpack_require__(1062),
	__webpack_require__(868),

	__webpack_require__(839),
	__webpack_require__(934),
	__webpack_require__(820) // contains
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, document, documentElement, rnumnonpx,
             curCSS, addGetHookIf, support, nodeName ) {

"use strict";

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2174:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(890),
	__webpack_require__(934)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access ) {

"use strict";

// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2175:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(868)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, nodeName ) {

"use strict";

jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2176:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 2177:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, noGlobal ) {

"use strict";

var

	// Map over jQuery in case of overwrite
	_jQuery = __webpack_provided_window_dot_jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && __webpack_provided_window_dot_jQuery === jQuery ) {
		__webpack_provided_window_dot_jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	__webpack_provided_window_dot_jQuery = window.$ = jQuery;
}

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1054)))

/***/ }),

/***/ 2178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color_input = __webpack_require__(2179);

var _color_input2 = _interopRequireDefault(_color_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorChooser = function (_React$Component) {
    (0, _inherits3.default)(ColorChooser, _React$Component);

    function ColorChooser() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ColorChooser);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColorChooser.__proto__ || (0, _getPrototypeOf2.default)(ColorChooser)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (newColor) {
            var _this$props = _this.props,
                id = _this$props.id,
                handleChange = _this$props.onChange;

            if (handleChange) {
                handleChange(id, newColor);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ColorChooser, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                color = _props.color;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'custom-label' },
                    label
                ),
                _react2.default.createElement(_color_input2.default, {
                    color: color,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return ColorChooser;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ColorChooser.propTypes = {

    /*
     * The id of setting that we will change
     */
    id: _propTypes2.default.string.isRequired,

    /*
     * The label of setting that we will choose
     */
    label: _propTypes2.default.string.isRequired,

    /*
     * Selected color
     */
    color: _propTypes2.default.string.isRequired,

    /*
     * Function called when color changed takes 2 arguments: Id of changing setting and new color
     */
    onChange: _propTypes2.default.func
};
exports.default = ColorChooser;

/***/ }),

/***/ 2179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactColor = __webpack_require__(1368);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ColorInput = function (_React$Component) {
    (0, _inherits3.default)(ColorInput, _React$Component);

    function ColorInput(props) {
        (0, _classCallCheck3.default)(this, ColorInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ColorInput.__proto__ || (0, _getPrototypeOf2.default)(ColorInput)).call(this, props));

        _this.checkClick = function (e) {
            var colorPickerDOMNode = _reactDom2.default.findDOMNode(_this.colorPicker);
            if (!colorPickerDOMNode || !colorPickerDOMNode.contains(e.target)) {
                _this.setState({ isOpened: false });
            }
        };

        _this.togglePicker = function () {
            _this.setState({ isOpened: !_this.state.isOpened });
        };

        _this.handleChange = function (newColorData) {
            var hex = newColorData.hex;
            var handleChange = _this.props.onChange;


            if (handleChange) {
                handleChange(hex);
            }
        };

        _this.getColorPicker = function (node) {
            _this.colorPicker = node;
        };

        _this.state = {
            idOpened: false
        };
        return _this;
    }

    (0, _createClass3.default)(ColorInput, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var prevIsOpened = prevState.isOpened;
            var isOpened = this.state.isOpened;


            if (isOpened !== prevIsOpened) {
                if (isOpened) {
                    document.addEventListener('click', this.checkClick);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var color = this.props.color;
            var isOpened = this.state.isOpened;


            return _react2.default.createElement(
                'div',
                { className: 'color-input input-group' },
                _react2.default.createElement('input', {
                    className: 'form-control',
                    type: 'text',
                    value: color,
                    readOnly: true
                }),
                _react2.default.createElement(
                    'span',
                    {
                        className: 'input-group-addon',
                        onClick: this.togglePicker
                    },
                    _react2.default.createElement('i', {
                        className: 'color-icon',
                        style: {
                            backgroundColor: color
                        }
                    })
                ),
                isOpened && _react2.default.createElement(
                    'div',
                    {
                        ref: this.getColorPicker,
                        className: 'color-popover'
                    },
                    _react2.default.createElement(_reactColor.ChromePicker, {
                        color: color,
                        onChange: this.handleChange
                    })
                )
            );
        }
    }]);
    return ColorInput;
}(_react2.default.Component);

ColorInput.propTypes = {

    /*
     * Selected color
     */
    color: _propTypes2.default.string.isRequired,

    /*
     * Function called when color changed. Takes hex format of color Ex: #ffeec0
     */
    onChange: _propTypes2.default.func
};
exports.default = ColorInput;

/***/ }),

/***/ 2333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _premade_theme_chooser = __webpack_require__(2334);

var _premade_theme_chooser2 = _interopRequireDefault(_premade_theme_chooser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var allowedThemes = config.AllowedThemes && config.AllowedThemes.split(',') || [];

    return {
        allowedThemes: allowedThemes
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_premade_theme_chooser2.default);

/***/ }),

/***/ 2334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PremadeThemeChooser = function (_React$Component) {
    (0, _inherits3.default)(PremadeThemeChooser, _React$Component);

    function PremadeThemeChooser() {
        (0, _classCallCheck3.default)(this, PremadeThemeChooser);
        return (0, _possibleConstructorReturn3.default)(this, (PremadeThemeChooser.__proto__ || (0, _getPrototypeOf2.default)(PremadeThemeChooser)).apply(this, arguments));
    }

    (0, _createClass3.default)(PremadeThemeChooser, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var theme = this.props.theme;

            var premadeThemes = [];
            var allowedThemes = this.props.allowedThemes;
            var hasAllowedThemes = allowedThemes.length > 1 || allowedThemes[0] && allowedThemes[0].trim().length > 0;

            for (var k in _constants2.default.THEMES) {
                if (_constants2.default.THEMES.hasOwnProperty(k)) {
                    var _ret = function () {
                        if (hasAllowedThemes && allowedThemes.indexOf(k) < 0) {
                            return 'continue';
                        }

                        var premadeTheme = _jquery2.default.extend(true, {}, _constants2.default.THEMES[k]);

                        var activeClass = '';
                        if (premadeTheme.type === theme.type) {
                            activeClass = 'active';
                        }

                        premadeThemes.push(_react2.default.createElement(
                            'div',
                            {
                                className: 'col-xs-6 col-sm-3 premade-themes',
                                key: 'premade-theme-key' + k
                            },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: activeClass,
                                    onClick: function onClick() {
                                        return _this2.props.updateTheme(premadeTheme);
                                    }
                                },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('img', {
                                        className: 'img-responsive',
                                        src: premadeTheme.image
                                    }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'theme-label' },
                                        Utils.toTitleCase(premadeTheme.type)
                                    )
                                )
                            )
                        ));
                    }();

                    if (_ret === 'continue') continue;
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'row appearance-section' },
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    premadeThemes
                )
            );
        }
    }]);
    return PremadeThemeChooser;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = PremadeThemeChooser;


PremadeThemeChooser.propTypes = {
    theme: _propTypes2.default.object.isRequired,
    updateTheme: _propTypes2.default.func.isRequired,
    allowedThemes: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

PremadeThemeChooser.defaultProps = {
    allowedThemes: []
};

/***/ }),

/***/ 2335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _general = __webpack_require__(113);

var _user_settings_general = __webpack_require__(2336);

var _user_settings_general2 = _interopRequireDefault(_user_settings_general);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var sendEmailNotifications = config.SendEmailNotifications === 'true';
    var requireEmailVerification = config.RequireEmailVerification === 'true';
    var maxFileSize = parseInt(config.MaxFileSize, 10);
    var ldapFirstNameAttributeSet = config.LdapFirstNameAttributeSet === 'true';
    var ldapLastNameAttributeSet = config.LdapLastNameAttributeSet === 'true';
    var samlFirstNameAttributeSet = config.SamlFirstNameAttributeSet === 'true';
    var samlLastNameAttributeSet = config.SamlLastNameAttributeSet === 'true';
    var ldapNicknameAttributeSet = config.LdapNicknameAttributeSet === 'true';
    var samlNicknameAttributeSet = config.SamlNicknameAttributeSet === 'true';
    var positionAttributeSet = config.PositionAttributeSet === 'true';

    return {
        sendEmailNotifications: sendEmailNotifications,
        requireEmailVerification: requireEmailVerification,
        maxFileSize: maxFileSize,
        ldapFirstNameAttributeSet: ldapFirstNameAttributeSet,
        ldapLastNameAttributeSet: ldapLastNameAttributeSet,
        samlFirstNameAttributeSet: samlFirstNameAttributeSet,
        samlLastNameAttributeSet: samlLastNameAttributeSet,
        ldapNicknameAttributeSet: ldapNicknameAttributeSet,
        samlNicknameAttributeSet: samlNicknameAttributeSet,
        positionAttributeSet: positionAttributeSet
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getMe: _users.getMe
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_user_settings_general2.default);

/***/ }),

/***/ 2336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _diagnostics_actions = __webpack_require__(804);

var _user_actions = __webpack_require__(781);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _setting_picture = __webpack_require__(1337);

var _setting_picture2 = _interopRequireDefault(_setting_picture);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var holders = (0, _reactIntl.defineMessages)({
    usernameReserved: {
        id: 'user.settings.general.usernameReserved',
        defaultMessage: 'This username is reserved, please choose a new one.'
    },
    usernameRestrictions: {
        id: 'user.settings.general.usernameRestrictions',
        defaultMessage: "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-', and '_'."
    },
    validEmail: {
        id: 'user.settings.general.validEmail',
        defaultMessage: 'Please enter a valid email address.'
    },
    emailMatch: {
        id: 'user.settings.general.emailMatch',
        defaultMessage: 'The new emails you entered do not match.'
    },
    checkEmail: {
        id: 'user.settings.general.checkEmail',
        defaultMessage: 'Check your email at {email} to verify the address.'
    },
    validImage: {
        id: 'user.settings.general.validImage',
        defaultMessage: 'Only BMP, JPG or PNG images may be used for profile pictures'
    },
    imageTooLarge: {
        id: 'user.settings.general.imageTooLarge',
        defaultMessage: 'Unable to upload profile image. File is too large.'
    },
    uploadImage: {
        id: 'user.settings.general.uploadImage',
        defaultMessage: "Click 'Edit' to upload an image."
    },
    uploadImageMobile: {
        id: 'user.settings.general.mobile.uploadImage',
        defaultMessage: 'Click to upload an image.'
    },
    fullName: {
        id: 'user.settings.general.fullName',
        defaultMessage: 'Full Name'
    },
    nickname: {
        id: 'user.settings.general.nickname',
        defaultMessage: 'Nickname'
    },
    username: {
        id: 'user.settings.general.username',
        defaultMessage: 'Username'
    },
    profilePicture: {
        id: 'user.settings.general.profilePicture',
        defaultMessage: 'Profile Picture'
    },
    close: {
        id: 'user.settings.general.close',
        defaultMessage: 'Close'
    },
    position: {
        id: 'user.settings.general.position',
        defaultMessage: 'Position'
    }
});

var prevSections = {
    name: 'dummySectionName', // dummy value that should never match any section name
    username: 'name',
    nickname: 'username',
    position: 'nickname',
    email: 'position',
    picture: 'email'
};

var ACCEPTED_PROFILE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/bmp'];

var UserSettingsGeneralTab = function (_React$Component) {
    (0, _inherits3.default)(UserSettingsGeneralTab, _React$Component);

    function UserSettingsGeneralTab(props) {
        (0, _classCallCheck3.default)(this, UserSettingsGeneralTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserSettingsGeneralTab.__proto__ || (0, _getPrototypeOf2.default)(UserSettingsGeneralTab)).call(this, props));

        _this.submitUsername = function () {
            var user = (0, _assign2.default)({}, _this.props.user);
            var username = _this.state.username.trim().toLowerCase();

            var formatMessage = _this.props.intl.formatMessage;

            var usernameError = Utils.isValidUsername(username);
            if (usernameError === 'Cannot use a reserved word as a username.') {
                _this.setState({ clientError: formatMessage(holders.usernameReserved), serverError: '' });
                return;
            } else if (usernameError) {
                _this.setState({ clientError: formatMessage(holders.usernameRestrictions, { min: _constants2.default.MIN_USERNAME_LENGTH, max: _constants2.default.MAX_USERNAME_LENGTH }), serverError: '' });
                return;
            }

            if (user.username === username) {
                _this.updateSection('');
                return;
            }

            user.username = username;

            (0, _diagnostics_actions.trackEvent)('settings', 'user_settings_update', { field: 'username' });

            _this.submitUser(user, false);
        };

        _this.submitNickname = function () {
            var user = (0, _assign2.default)({}, _this.props.user);
            var nickname = _this.state.nickname.trim();

            if (user.nickname === nickname) {
                _this.updateSection('');
                return;
            }

            user.nickname = nickname;

            (0, _diagnostics_actions.trackEvent)('settings', 'user_settings_update', { field: 'username' });

            _this.submitUser(user, false);
        };

        _this.submitName = function () {
            var user = (0, _assign2.default)({}, _this.props.user);
            var firstName = _this.state.firstName.trim();
            var lastName = _this.state.lastName.trim();

            if (user.first_name === firstName && user.last_name === lastName) {
                _this.updateSection('');
                return;
            }

            user.first_name = firstName;
            user.last_name = lastName;

            (0, _diagnostics_actions.trackEvent)('settings', 'user_settings_update', { field: 'fullname' });

            _this.submitUser(user, false);
        };

        _this.submitEmail = function () {
            var user = (0, _assign2.default)({}, _this.props.user);
            var email = _this.state.email.trim().toLowerCase();
            var confirmEmail = _this.state.confirmEmail.trim().toLowerCase();

            var formatMessage = _this.props.intl.formatMessage;


            if (email === user.email && (confirmEmail === '' || confirmEmail === user.email)) {
                _this.updateSection('');
                return;
            }

            if (email === '' || !Utils.isEmail(email)) {
                _this.setState({ emailError: formatMessage(holders.validEmail), clientError: '', serverError: '' });
                return;
            }

            if (email !== confirmEmail) {
                _this.setState({ emailError: formatMessage(holders.emailMatch), clientError: '', serverError: '' });
                return;
            }

            user.email = email;
            (0, _diagnostics_actions.trackEvent)('settings', 'user_settings_update', { field: 'email' });
            _this.submitUser(user, true);
        };

        _this.submitUser = function (user, emailUpdated) {
            _this.setState({ sectionIsSaving: true });

            (0, _user_actions.updateUser)(user, function () {
                _this.updateSection('');
                _this.props.actions.getMe();
                var verificationEnabled = _this.props.sendEmailNotifications && _this.props.requireEmailVerification && emailUpdated;

                if (verificationEnabled) {
                    _error_store2.default.storeLastError({ message: _this.props.intl.formatMessage(holders.checkEmail, { email: user.email }) });
                    _error_store2.default.emitChange();
                    _this.setState({ emailChangeInProgress: true });
                }
            }, function (err) {
                var serverError = void 0;
                if (err.message) {
                    serverError = err.message;
                } else {
                    serverError = err;
                }
                _this.setState({ serverError: serverError, emailError: '', clientError: '', sectionIsSaving: false });
            });
        };

        _this.submitPicture = function (e) {
            e.preventDefault();

            if (!_this.state.pictureFile) {
                return;
            }

            if (!_this.submitActive) {
                return;
            }

            (0, _diagnostics_actions.trackEvent)('settings', 'user_settings_update', { field: 'picture' });

            var formatMessage = _this.props.intl.formatMessage;

            var file = _this.state.pictureFile;

            if (!ACCEPTED_PROFILE_IMAGE_TYPES.includes(file.type)) {
                _this.setState({ clientError: formatMessage(holders.validImage), serverError: '' });
                return;
            } else if (file.size > _this.props.maxFileSize) {
                _this.setState({ clientError: formatMessage(holders.imageTooLarge), serverError: '' });
                return;
            }

            _this.setState({ loadingPicture: true });

            (0, _user_actions.uploadProfileImage)(file, function () {
                _this.updateSection('');
                _this.submitActive = false;
            }, function (err) {
                var state = _this.setupInitialState(_this.props);
                state.serverError = err.message;
                _this.setState(state);
            });
        };

        _this.submitPosition = function () {
            var user = (0, _assign2.default)({}, _this.props.user);
            var position = _this.state.position.trim();

            if (user.position === position) {
                _this.updateSection('');
                return;
            }

            user.position = position;

            (0, _diagnostics_actions.trackEvent)('settings', 'user_settings_update', { field: 'position' });

            _this.submitUser(user, false);
        };

        _this.updateUsername = function (e) {
            _this.setState({ username: e.target.value });
        };

        _this.updateFirstName = function (e) {
            _this.setState({ firstName: e.target.value });
        };

        _this.updateLastName = function (e) {
            _this.setState({ lastName: e.target.value });
        };

        _this.updateNickname = function (e) {
            _this.setState({ nickname: e.target.value });
        };

        _this.updatePosition = function (e) {
            _this.setState({ position: e.target.value });
        };

        _this.updateEmail = function (e) {
            _this.setState({ email: e.target.value });
        };

        _this.updateConfirmEmail = function (e) {
            _this.setState({ confirmEmail: e.target.value });
        };

        _this.updatePicture = function (e) {
            if (e.target.files && e.target.files[0]) {
                _this.setState({ pictureFile: e.target.files[0] });

                _this.submitActive = true;
                _this.setState({ clientError: null });
            } else {
                _this.setState({ pictureFile: null });
            }
        };

        _this.updateSection = function (section) {
            var emailChangeInProgress = _this.state.emailChangeInProgress;
            _this.setState((0, _assign2.default)({}, _this.setupInitialState(_this.props), { emailChangeInProgress: emailChangeInProgress, clientError: '', serverError: '', emailError: '', sectionIsSaving: false }));
            _this.submitActive = false;
            _this.props.updateSection(section);
        };

        _this.submitActive = false;

        _this.state = _this.setupInitialState(props);
        return _this;
    }

    (0, _createClass3.default)(UserSettingsGeneralTab, [{
        key: 'setupInitialState',
        value: function setupInitialState(props) {
            var user = props.user;

            return {
                username: user.username,
                firstName: user.first_name,
                lastName: user.last_name,
                nickname: user.nickname,
                position: user.position,
                originalEmail: user.email,
                email: '',
                confirmEmail: '',
                pictureFile: null,
                loadingPicture: false,
                emailChangeInProgress: false,
                sectionIsSaving: false
            };
        }
    }, {
        key: 'createEmailSection',
        value: function createEmailSection() {
            var emailSection = void 0;

            if (this.props.activeSection === 'email') {
                var emailEnabled = this.props.sendEmailNotifications;
                var emailVerificationEnabled = this.props.requireEmailVerification;
                var inputs = [];

                var helpText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.general.emailHelp1',
                    defaultMessage: 'Email is used for sign-in, notifications, and password reset. Email requires verification if changed.'
                });

                if (!emailEnabled) {
                    helpText = _react2.default.createElement(
                        'div',
                        { className: 'setting-list__hint col-sm-12 text-danger' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.emailHelp2',
                            defaultMessage: 'Email has been disabled by your System Administrator. No notification emails will be sent until it is enabled.'
                        })
                    );
                } else if (!emailVerificationEnabled) {
                    helpText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.emailHelp3',
                        defaultMessage: 'Email is used for sign-in, notifications, and password reset.'
                    });
                } else if (this.state.emailChangeInProgress) {
                    var newEmail = _user_store2.default.getCurrentUser().email;
                    if (newEmail) {
                        helpText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.emailHelp4',
                            defaultMessage: 'A verification email was sent to {email}.',
                            values: {
                                email: newEmail
                            }
                        });
                    }
                }

                var submit = null;

                if (this.props.user.auth_service === '') {
                    inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'currentEmailSetting' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { className: 'col-sm-5 control-label' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.general.currentEmail',
                                    defaultMessage: 'Current Email'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-7' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    this.state.originalEmail
                                )
                            )
                        )
                    ));

                    inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'emailSetting' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { className: 'col-sm-5 control-label' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.general.newEmail',
                                    defaultMessage: 'New Email'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-7' },
                                _react2.default.createElement('input', {
                                    autoFocus: true,
                                    id: 'primaryEmail',
                                    className: 'form-control',
                                    type: 'email',
                                    onChange: this.updateEmail,
                                    value: this.state.email
                                })
                            )
                        )
                    ));

                    inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'confirmEmailSetting' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { className: 'col-sm-5 control-label' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.general.confirmEmail',
                                    defaultMessage: 'Confirm Email'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-7' },
                                _react2.default.createElement('input', {
                                    id: 'confirmEmail',
                                    className: 'form-control',
                                    type: 'email',
                                    onChange: this.updateConfirmEmail,
                                    value: this.state.confirmEmail
                                })
                            )
                        ),
                        helpText
                    ));

                    submit = this.submitEmail;
                } else if (this.props.user.auth_service === _constants2.default.GITLAB_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.emailGitlabCantUpdate',
                                defaultMessage: 'Login occurs through GitLab. Email cannot be updated. Email address used for notifications is {email}.',
                                values: {
                                    email: this.state.originalEmail
                                }
                            })
                        ),
                        helpText
                    ));
                } else if (this.props.user.auth_service === _constants2.default.GOOGLE_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.emailGoogleCantUpdate',
                                defaultMessage: 'Login occurs through Google Apps. Email cannot be updated. Email address used for notifications is {email}.',
                                values: {
                                    email: this.state.originalEmail
                                }
                            })
                        ),
                        helpText
                    ));
                } else if (this.props.user.auth_service === _constants2.default.OFFICE365_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.emailOffice365CantUpdate',
                                defaultMessage: 'Login occurs through Office 365. Email cannot be updated. Email address used for notifications is {email}.',
                                values: {
                                    email: this.state.originalEmail
                                }
                            })
                        ),
                        helpText
                    ));
                } else if (this.props.user.auth_service === _constants2.default.LDAP_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'padding-bottom'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.emailLdapCantUpdate',
                                defaultMessage: 'Login occurs through AD/LDAP. Email cannot be updated. Email address used for notifications is {email}.',
                                values: {
                                    email: this.state.originalEmail
                                }
                            })
                        )
                    ));
                } else if (this.props.user.auth_service === _constants2.default.SAML_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'padding-bottom'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.emailSamlCantUpdate',
                                defaultMessage: 'Login occurs through SAML. Email cannot be updated. Email address used for notifications is {email}.',
                                values: {
                                    email: this.state.originalEmail
                                }
                            })
                        ),
                        helpText
                    ));
                }

                emailSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.email',
                        defaultMessage: 'Email'
                    }),
                    inputs: inputs,
                    submit: submit,
                    saving: this.state.sectionIsSaving,
                    serverError: this.state.serverError,
                    clientError: this.state.emailError,
                    updateSection: this.updateSection
                });
            } else {
                var describe = '';
                if (this.props.user.auth_service === '') {
                    if (this.state.emailChangeInProgress) {
                        var _newEmail = _user_store2.default.getCurrentUser().email;
                        if (_newEmail) {
                            describe = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'user.settings.general.newAddress',
                                defaultMessage: 'New Address: {email}<br />Check your email to verify the above address.',
                                values: {
                                    email: _newEmail
                                }
                            });
                        } else {
                            describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.checkEmailNoAddress',
                                defaultMessage: 'Check your email to verify your new address'
                            });
                        }
                    } else {
                        describe = _user_store2.default.getCurrentUser().email;
                    }
                } else if (this.props.user.auth_service === _constants2.default.GITLAB_SERVICE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.loginGitlab',
                        defaultMessage: 'Login done through GitLab ({email})',
                        values: {
                            email: this.state.originalEmail
                        }
                    });
                } else if (this.props.user.auth_service === _constants2.default.GOOGLE_SERVICE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.loginGoogle',
                        defaultMessage: 'Login done through Google Apps ({email})',
                        values: {
                            email: this.state.originalEmail
                        }
                    });
                } else if (this.props.user.auth_service === _constants2.default.OFFICE365_SERVICE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.loginOffice365',
                        defaultMessage: 'Login done through Office 365 ({email})',
                        values: {
                            email: this.state.originalEmail
                        }
                    });
                } else if (this.props.user.auth_service === _constants2.default.LDAP_SERVICE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.loginLdap',
                        defaultMessage: 'Login done through AD/LDAP ({email})',
                        values: {
                            email: this.state.originalEmail
                        }
                    });
                } else if (this.props.user.auth_service === _constants2.default.SAML_SERVICE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.loginSaml',
                        defaultMessage: 'Login done through SAML ({email})',
                        values: {
                            email: this.state.originalEmail
                        }
                    });
                }

                emailSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.email',
                        defaultMessage: 'Email'
                    }),
                    describe: describe,
                    focused: this.props.prevActiveSection === prevSections.email,
                    section: 'email',
                    updateSection: this.updateSection
                });
            }

            return emailSection;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var user = this.props.user;
            var formatMessage = this.props.intl.formatMessage;


            var clientError = null;
            if (this.state.clientError) {
                clientError = this.state.clientError;
            }
            var serverError = null;
            if (this.state.serverError) {
                serverError = this.state.serverError;
            }

            var nameSection = void 0;
            var inputs = [];

            if (this.props.activeSection === 'name') {
                var extraInfo = void 0;
                var submit = null;
                if (this.props.user.auth_service === 'ldap' && (this.props.ldapFirstNameAttributeSet || this.props.ldapLastNameAttributeSet) || this.props.user.auth_service === _constants2.default.SAML_SERVICE && (this.props.samlFirstNameAttributeSet || this.props.samlLastNameAttributeSet)) {
                    extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.field_handled_externally',
                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so through your login provider.'
                        })
                    );
                } else {
                    var notifClick = function notifClick(e) {
                        e.preventDefault();
                        this.updateSection('');
                        this.props.updateTab('notifications');
                    };

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'firstNameSetting',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.firstName',
                                defaultMessage: 'First Name'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'firstName',
                                autoFocus: true,
                                className: 'form-control',
                                type: 'text',
                                onChange: this.updateFirstName,
                                value: this.state.firstName
                            })
                        )
                    ));

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'lastNameSetting',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.general.lastName',
                                defaultMessage: 'Last Name'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'lastName',
                                className: 'form-control',
                                type: 'text',
                                onChange: this.updateLastName,
                                value: this.state.lastName
                            })
                        )
                    ));

                    var notifLink = _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            onClick: notifClick.bind(this)
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.notificationsLink',
                            defaultMessage: 'Notifications'
                        })
                    );

                    extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.notificationsExtra',
                            defaultMessage: 'By default, you will receive mention notifications when someone types your first name. Go to {notify} settings to change this default.',
                            values: {
                                notify: notifLink
                            }
                        })
                    );

                    submit = this.submitName;
                }

                nameSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: formatMessage(holders.fullName),
                    inputs: inputs,
                    submit: submit,
                    saving: this.state.sectionIsSaving,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.updateSection,
                    extraInfo: extraInfo
                });
            } else {
                var describe = '';

                if (user.first_name && user.last_name) {
                    describe = user.first_name + ' ' + user.last_name;
                } else if (user.first_name) {
                    describe = user.first_name;
                } else if (user.last_name) {
                    describe = user.last_name;
                } else {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.emptyName',
                        defaultMessage: 'Click \'Edit\' to add your full name'
                    });
                    if (Utils.isMobile()) {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.mobile.emptyName',
                            defaultMessage: 'Click to add your full name'
                        });
                    }
                }

                nameSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: formatMessage(holders.fullName),
                    describe: describe,
                    focused: this.props.prevActiveSection === prevSections.name,
                    section: 'name',
                    updateSection: this.updateSection
                });
            }

            var nicknameSection = void 0;
            if (this.props.activeSection === 'nickname') {
                var _extraInfo = void 0;
                var _submit = null;
                if (this.props.user.auth_service === 'ldap' && this.props.ldapNicknameAttributeSet || this.props.user.auth_service === _constants2.default.SAML_SERVICE && this.props.samlNicknameAttributeSet) {
                    _extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.field_handled_externally',
                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so though your login provider.'
                        })
                    );
                } else {
                    var nicknameLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.nickname',
                        defaultMessage: 'Nickname'
                    });
                    if (Utils.isMobile()) {
                        nicknameLabel = '';
                    }

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'nicknameSetting',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            nicknameLabel
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'nickname',
                                autoFocus: true,
                                className: 'form-control',
                                type: 'text',
                                onChange: this.updateNickname,
                                value: this.state.nickname,
                                maxLength: _constants2.default.MAX_NICKNAME_LENGTH,
                                autoCapitalize: 'off'
                            })
                        )
                    ));

                    _extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.nicknameExtra',
                            defaultMessage: 'Use Nickname for a name you might be called that is different from your first name and username. This is most often used when two or more people have similar sounding names and usernames.'
                        })
                    );

                    _submit = this.submitNickname;
                }

                nicknameSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: formatMessage(holders.nickname),
                    inputs: inputs,
                    submit: _submit,
                    saving: this.state.sectionIsSaving,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.updateSection,
                    extraInfo: _extraInfo
                });
            } else {
                var _describe = '';
                if (user.nickname) {
                    _describe = user.nickname;
                } else {
                    _describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.emptyNickname',
                        defaultMessage: 'Click \'Edit\' to add a nickname'
                    });
                    if (Utils.isMobile()) {
                        _describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.mobile.emptyNickname',
                            defaultMessage: 'Click to add a nickname'
                        });
                    }
                }

                nicknameSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: formatMessage(holders.nickname),
                    describe: _describe,
                    focused: this.props.prevActiveSection === prevSections.nickname,
                    section: 'nickname',
                    updateSection: this.updateSection
                });
            }

            var usernameSection = void 0;
            if (this.props.activeSection === 'username') {
                var _extraInfo2 = void 0;
                var _submit2 = null;
                if (this.props.user.auth_service === '') {
                    var usernameLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.username',
                        defaultMessage: 'Username'
                    });
                    if (Utils.isMobile()) {
                        usernameLabel = '';
                    }

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'usernameSetting',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            usernameLabel
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'username',
                                autoFocus: true,
                                maxLength: _constants2.default.MAX_USERNAME_LENGTH,
                                className: 'form-control',
                                type: 'text',
                                onChange: this.updateUsername,
                                value: this.state.username,
                                autoCapitalize: 'off'
                            })
                        )
                    ));

                    _extraInfo2 = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.usernameInfo',
                            defaultMessage: 'Pick something easy for teammates to recognize and recall.'
                        })
                    );

                    _submit2 = this.submitUsername;
                } else {
                    _extraInfo2 = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.field_handled_externally',
                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so though your login provider.'
                        })
                    );
                }

                usernameSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: formatMessage(holders.username),
                    inputs: inputs,
                    submit: _submit2,
                    saving: this.state.sectionIsSaving,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.updateSection,
                    extraInfo: _extraInfo2
                });
            } else {
                usernameSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: formatMessage(holders.username),
                    describe: _user_store2.default.getCurrentUser().username,
                    focused: this.props.prevActiveSection === prevSections.username,
                    section: 'username',
                    updateSection: this.updateSection
                });
            }

            var positionSection = void 0;
            if (this.props.activeSection === 'position') {
                var _extraInfo3 = void 0;
                var _submit3 = null;
                if ((this.props.user.auth_service === 'ldap' || this.props.user.auth_service === _constants2.default.SAML_SERVICE) && this.props.positionAttributeSet) {
                    _extraInfo3 = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.field_handled_externally',
                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so though your login provider.'
                        })
                    );
                } else {
                    var positionLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.position',
                        defaultMessage: 'Position'
                    });
                    if (Utils.isMobile()) {
                        positionLabel = '';
                    }

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'positionSetting',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            positionLabel
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'position',
                                autoFocus: true,
                                className: 'form-control',
                                type: 'text',
                                onChange: this.updatePosition,
                                value: this.state.position,
                                maxLength: _constants2.default.MAX_POSITION_LENGTH,
                                autoCapitalize: 'off'
                            })
                        )
                    ));

                    _extraInfo3 = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.positionExtra',
                            defaultMessage: 'Use Position for your role or job title. This will be shown in your profile popover.'
                        })
                    );

                    _submit3 = this.submitPosition;
                }

                positionSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: formatMessage(holders.position),
                    inputs: inputs,
                    submit: _submit3,
                    saving: this.state.sectionIsSaving,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.updateSection,
                    extraInfo: _extraInfo3
                });
            } else {
                var _describe2 = '';
                if (user.position) {
                    _describe2 = user.position;
                } else {
                    _describe2 = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.emptyPosition',
                        defaultMessage: 'Click \'Edit\' to add your job title / position'
                    });
                    if (Utils.isMobile()) {
                        _describe2 = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.mobile.emptyPosition',
                            defaultMessage: 'Click to add your job title / position'
                        });
                    }
                }

                positionSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: formatMessage(holders.position),
                    describe: _describe2,
                    focused: this.props.prevActiveSection === prevSections.position,
                    section: 'position',
                    updateSection: this.updateSection
                });
            }

            var emailSection = this.createEmailSection();

            var pictureSection = void 0;
            if (this.props.activeSection === 'picture') {
                pictureSection = _react2.default.createElement(_setting_picture2.default, {
                    title: formatMessage(holders.profilePicture),
                    submit: this.submitPicture,
                    src: Utils.imageURLForUser(user),
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: function updateSection(e) {
                        _this2.updateSection('');
                        e.preventDefault();
                    },
                    file: this.state.pictureFile,
                    onFileChange: this.updatePicture,
                    submitActive: this.submitActive,
                    loadingPicture: this.state.loadingPicture
                });
            } else {
                var minMessage = formatMessage(holders.uploadImage);
                if (Utils.isMobile()) {
                    minMessage = formatMessage(holders.uploadImageMobile);
                }
                if (user.last_picture_update) {
                    minMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.general.imageUpdated',
                        defaultMessage: 'Image last updated {date}',
                        values: {
                            date: _react2.default.createElement(_reactIntl.FormattedDate, {
                                value: new Date(user.last_picture_update),
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            })
                        }
                    });
                }
                pictureSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: formatMessage(holders.profilePicture),
                    describe: minMessage,
                    focused: this.props.prevActiveSection === prevSections.picture,
                    section: 'picture',
                    updateSection: this.updateSection
                });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'closeUserSettings',
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': formatMessage(holders.close),
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.title',
                            defaultMessage: 'General Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'user-settings' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.general.title',
                            defaultMessage: 'General Settings'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    nameSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    usernameSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    nicknameSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    positionSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    emailSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    pictureSection,
                    _react2.default.createElement('div', { className: 'divider-dark' })
                )
            );
        }
    }]);
    return UserSettingsGeneralTab;
}(_react2.default.Component);

UserSettingsGeneralTab.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    user: _propTypes2.default.object.isRequired,
    updateSection: _propTypes2.default.func.isRequired,
    updateTab: _propTypes2.default.func.isRequired,
    activeSection: _propTypes2.default.string.isRequired,
    prevActiveSection: _propTypes2.default.string.isRequired,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    actions: _propTypes2.default.shape({
        getMe: _propTypes2.default.func.isRequired
    }).isRequired,
    sendEmailNotifications: _propTypes2.default.bool,
    requireEmailVerification: _propTypes2.default.bool,
    maxFileSize: _propTypes2.default.number,
    ldapFirstNameAttributeSet: _propTypes2.default.bool,
    ldapLastNameAttributeSet: _propTypes2.default.bool,
    samlFirstNameAttributeSet: _propTypes2.default.bool,
    samlLastNameAttributeSet: _propTypes2.default.bool,
    ldapNicknameAttributeSet: _propTypes2.default.bool,
    samlNicknameAttributeSet: _propTypes2.default.bool,
    positionAttributeSet: _propTypes2.default.bool
};
exports.default = (0, _reactIntl.injectIntl)(UserSettingsGeneralTab);

/***/ }),

/***/ 2337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _user_settings_notifications = __webpack_require__(2338);

var _user_settings_notifications2 = _interopRequireDefault(_user_settings_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var sendEmailNotifications = config.SendEmailNotifications === 'true';
    var enableEmailBatching = config.EnableEmailBatching === 'true';
    var siteName = config.SiteName;
    var sendPushNotifications = config.SendPushNotifications === 'true';

    return {
        sendEmailNotifications: sendEmailNotifications,
        enableEmailBatching: enableEmailBatching,
        siteName: siteName,
        sendPushNotifications: sendPushNotifications
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_user_settings_notifications2.default);

/***/ }),

/***/ 2338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _desktop_notification_settings = __webpack_require__(2339);

var _desktop_notification_settings2 = _interopRequireDefault(_desktop_notification_settings);

var _email_notification_setting = __webpack_require__(2340);

var _email_notification_setting2 = _interopRequireDefault(_email_notification_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNotificationsStateFromStores() {
    var user = _user_store2.default.getCurrentUser();

    var desktop = _constants.NotificationLevels.MENTION;
    var sound = 'true';
    var desktopDuration = '5';
    var comments = 'never';
    var enableEmail = 'true';
    var pushActivity = _constants.NotificationLevels.MENTION;
    var pushStatus = _constants2.default.UserStatuses.AWAY;

    if (user.notify_props) {
        if (user.notify_props.desktop) {
            desktop = user.notify_props.desktop;
        }
        if (user.notify_props.desktop_sound) {
            sound = user.notify_props.desktop_sound;
        }
        if (user.notify_props.desktop_duration) {
            desktopDuration = user.notify_props.desktop_duration;
        }
        if (user.notify_props.comments) {
            comments = user.notify_props.comments;
        }
        if (user.notify_props.email) {
            enableEmail = user.notify_props.email;
        }
        if (user.notify_props.push) {
            pushActivity = user.notify_props.push;
        }
        if (user.notify_props.push_status) {
            pushStatus = user.notify_props.push_status;
        }
    }

    var usernameKey = false;
    var customKeys = '';
    var firstNameKey = false;
    var channelKey = false;

    if (user.notify_props) {
        if (user.notify_props.mention_keys) {
            var keys = user.notify_props.mention_keys.split(',');

            if (keys.indexOf(user.username) === -1) {
                usernameKey = false;
            } else {
                usernameKey = true;
                keys.splice(keys.indexOf(user.username), 1);
                if (keys.indexOf('@' + user.username) !== -1) {
                    keys.splice(keys.indexOf('@' + user.username), 1);
                }
            }

            customKeys = keys.join(',');
        }

        if (user.notify_props.first_name) {
            firstNameKey = user.notify_props.first_name === 'true';
        }

        if (user.notify_props.channel) {
            channelKey = user.notify_props.channel === 'true';
        }
    }

    return {
        desktopActivity: desktop,
        desktopDuration: desktopDuration,
        enableEmail: enableEmail,
        pushActivity: pushActivity,
        pushStatus: pushStatus,
        desktopSound: sound,
        usernameKey: usernameKey,
        customKeys: customKeys,
        customKeysChecked: customKeys.length > 0,
        firstNameKey: firstNameKey,
        channelKey: channelKey,
        notifyCommentsLevel: comments,
        isSaving: false
    };
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var prevSections = {
    desktop: 'dummySectionName', // dummy value that should never match any section name
    email: 'desktop',
    push: 'email',
    keys: 'push',
    comments: 'keys'
};

var NotificationsTab = function (_React$Component) {
    (0, _inherits3.default)(NotificationsTab, _React$Component);

    function NotificationsTab(props) {
        (0, _classCallCheck3.default)(this, NotificationsTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationsTab.__proto__ || (0, _getPrototypeOf2.default)(NotificationsTab)).call(this, props));

        _this.handleSubmit = function () {
            var enableEmail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.enableEmail;

            var data = {};
            data.user_id = _this.props.user.id;
            data.email = enableEmail;
            data.desktop_sound = _this.state.desktopSound;
            data.desktop = _this.state.desktopActivity;
            data.desktop_duration = _this.state.desktopDuration;
            data.push = _this.state.pushActivity;
            data.push_status = _this.state.pushStatus;
            data.comments = _this.state.notifyCommentsLevel;

            var mentionKeys = [];
            if (_this.state.usernameKey) {
                mentionKeys.push(_this.props.user.username);
            }

            var stringKeys = mentionKeys.join(',');
            if (_this.state.customKeys.length > 0 && _this.state.customKeysChecked) {
                stringKeys += ',' + _this.state.customKeys;
            }

            data.mention_keys = stringKeys;
            data.first_name = _this.state.firstNameKey.toString();
            data.channel = _this.state.channelKey.toString();

            _this.setState({ isSaving: true });

            (0, _user_actions.updateUserNotifyProps)(data, function () {
                _this.props.updateSection('');
            }, function (err) {
                _this.setState({ serverError: err.message, isSaving: false });
            });
        };

        _this.handleCancel = function (e) {
            if (e) {
                e.preventDefault();
            }
            _this.updateState();
        };

        _this.handleUpdateSection = function (section) {
            if (section) {
                _this.props.updateSection(section);
            } else {
                _this.props.updateSection('');
                _this.handleCancel();
            }
        };

        _this.setStateValue = function (key, value) {
            var data = {};
            data[key] = value;
            _this.setState(data);
        };

        _this.updateSection = function (section) {
            _this.updateState();
            _this.props.updateSection(section);
        };

        _this.updateState = function () {
            var newState = getNotificationsStateFromStores();
            if (!Utils.areObjectsEqual(newState, _this.state)) {
                _this.setState(newState);
            }

            _this.setState({ isSaving: false });
        };

        _this.onListenerChange = function () {
            _this.updateState();
        };

        _this.handleEmailRadio = function (enableEmail) {
            _this.setState({ enableEmail: enableEmail });
            _this.refs.wrapper.focus();
        };

        _this.updateUsernameKey = function (val) {
            _this.setState({ usernameKey: val });
        };

        _this.updateFirstNameKey = function (val) {
            _this.setState({ firstNameKey: val });
        };

        _this.updateChannelKey = function (val) {
            _this.setState({ channelKey: val });
        };

        _this.updateCustomMentionKeys = function () {
            var checked = _this.refs.customcheck.checked;

            if (checked) {
                var text = _this.refs.custommentions.value;

                // remove all spaces and split string into individual keys
                _this.setState({ customKeys: text.replace(/ /g, ''), customKeysChecked: true });
            } else {
                _this.setState({ customKeys: '', customKeysChecked: false });
            }
        };

        _this.onCustomChange = function () {
            _this.refs.customcheck.checked = true;
            _this.updateCustomMentionKeys();
        };

        _this.createPushNotificationSection = function () {
            if (_this.props.activeSection === 'push') {
                var inputs = [];
                var extraInfo = null;
                var submit = null;

                if (_this.props.sendPushNotifications) {
                    var pushActivityRadio = [false, false, false];
                    if (_this.state.pushActivity === _constants.NotificationLevels.ALL) {
                        pushActivityRadio[0] = true;
                    } else if (_this.state.pushActivity === _constants.NotificationLevels.NONE) {
                        pushActivityRadio[2] = true;
                    } else {
                        pushActivityRadio[1] = true;
                    }

                    var pushStatusRadio = [false, false, false];
                    if (_this.state.pushStatus === _constants2.default.UserStatuses.ONLINE) {
                        pushStatusRadio[0] = true;
                    } else if (_this.state.pushStatus === _constants2.default.UserStatuses.AWAY) {
                        pushStatusRadio[1] = true;
                    } else {
                        pushStatusRadio[2] = true;
                    }

                    var pushStatusSettings = void 0;
                    if (_this.state.pushActivity !== _constants.NotificationLevels.NONE) {
                        pushStatusSettings = _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('hr', null),
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.notifications.push_notification.status',
                                    defaultMessage: 'Trigger push notifications when'
                                })
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'div',
                                { className: 'radio' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'pushNotificationOnline',
                                        type: 'radio',
                                        name: 'pushNotificationStatus',
                                        checked: pushStatusRadio[0],
                                        onChange: _this.handlePushStatusRadio.bind(_this, _constants2.default.UserStatuses.ONLINE)
                                    }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'user.settings.push_notification.online',
                                        defaultMessage: 'Online, away or offline'
                                    })
                                ),
                                _react2.default.createElement('br', null)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'radio' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'pushNotificationAway',
                                        type: 'radio',
                                        name: 'pushNotificationStatus',
                                        checked: pushStatusRadio[1],
                                        onChange: _this.handlePushStatusRadio.bind(_this, _constants2.default.UserStatuses.AWAY)
                                    }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'user.settings.push_notification.away',
                                        defaultMessage: 'Away or offline'
                                    })
                                ),
                                _react2.default.createElement('br', null)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'radio' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'pushNotificationOffline',
                                        type: 'radio',
                                        name: 'pushNotificationStatus',
                                        checked: pushStatusRadio[2],
                                        onChange: _this.handlePushStatusRadio.bind(_this, _constants2.default.UserStatuses.OFFLINE)
                                    }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'user.settings.push_notification.offline',
                                        defaultMessage: 'Offline'
                                    })
                                )
                            )
                        );

                        extraInfo = _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.push_notification.status_info',
                                defaultMessage: 'Notification alerts are only pushed to your mobile device when your online status matches the selection above.'
                            })
                        );
                    }

                    inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'userNotificationLevelOption' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.push_notification.send',
                                defaultMessage: 'Send mobile push notifications'
                            })
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'pushNotificationAllActivity',
                                    type: 'radio',
                                    name: 'pushNotificationLevel',
                                    checked: pushActivityRadio[0],
                                    onChange: _this.handlePushRadio.bind(_this, _constants.NotificationLevels.ALL)
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.push_notification.allActivity',
                                    defaultMessage: 'For all activity'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'pushNotificationMentions',
                                    type: 'radio',
                                    name: 'pushNotificationLevel',
                                    checked: pushActivityRadio[1],
                                    onChange: _this.handlePushRadio.bind(_this, _constants.NotificationLevels.MENTION)
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.push_notification.onlyMentions',
                                    defaultMessage: 'For mentions and direct messages'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'pushNotificationNever',
                                    type: 'radio',
                                    name: 'pushNotificationLevel',
                                    checked: pushActivityRadio[2],
                                    onChange: _this.handlePushRadio.bind(_this, _constants.NotificationLevels.NONE)
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.notifications.never',
                                    defaultMessage: 'Never'
                                })
                            )
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.push_notification.info',
                                defaultMessage: 'Notification alerts are pushed to your mobile device when there is activity in Mattermost.'
                            })
                        ),
                        pushStatusSettings
                    ));

                    submit = _this.handleSubmit;
                } else {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'padding-top'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.push_notification.disabled_long',
                            defaultMessage: 'Push Notifications are not enabled. Contact your System Administrator.'
                        })
                    ));
                }

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('user.settings.notifications.push', 'Mobile push notifications'),
                    extraInfo: extraInfo,
                    inputs: inputs,
                    submit: submit,
                    server_error: _this.state.serverError,
                    updateSection: _this.handleUpdateSection
                });
            }

            var describe = '';
            if (_this.state.pushActivity === _constants.NotificationLevels.ALL) {
                if (_this.state.pushStatus === _constants2.default.UserStatuses.AWAY) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.push_notification.allActivityAway',
                        defaultMessage: 'For all activity when away or offline'
                    });
                } else if (_this.state.pushStatus === _constants2.default.UserStatuses.OFFLINE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.push_notification.allActivityOffline',
                        defaultMessage: 'For all activity when offline'
                    });
                } else {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.push_notification.allActivityOnline',
                        defaultMessage: 'For all activity when online, away or offline'
                    });
                }
            } else if (_this.state.pushActivity === _constants.NotificationLevels.NONE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.notifications.never',
                    defaultMessage: 'Never'
                });
            } else if (_this.props.sendPushNotifications) {
                if (_this.state.pushStatus === _constants2.default.UserStatuses.AWAY) {
                    //eslint-disable-line no-lonely-if
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.push_notification.onlyMentionsAway',
                        defaultMessage: 'For mentions and direct messages when away or offline'
                    });
                } else if (_this.state.pushStatus === _constants2.default.UserStatuses.OFFLINE) {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.push_notification.onlyMentionsOffline',
                        defaultMessage: 'For mentions and direct messages when offline'
                    });
                } else {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.push_notification.onlyMentionsOnline',
                        defaultMessage: 'For mentions and direct messages when online, away or offline'
                    });
                }
            } else {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.push_notification.disabled',
                    defaultMessage: 'Disabled by System Administrator'
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: Utils.localizeMessage('user.settings.notifications.push', 'Mobile push notifications'),
                describe: describe,
                focused: _this.props.prevActiveSection === prevSections.push,
                section: 'push',
                updateSection: _this.handleUpdateSection
            });
        };

        _this.state = getNotificationsStateFromStores();
        return _this;
    }

    (0, _createClass3.default)(NotificationsTab, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addChangeListener(this.onListenerChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeChangeListener(this.onListenerChange);
        }
    }, {
        key: 'handleNotifyCommentsRadio',
        value: function handleNotifyCommentsRadio(notifyCommentsLevel) {
            this.setState({ notifyCommentsLevel: notifyCommentsLevel });
            this.refs.wrapper.focus();
        }
    }, {
        key: 'handlePushRadio',
        value: function handlePushRadio(pushActivity) {
            this.setState({ pushActivity: pushActivity });
            this.refs.wrapper.focus();
        }
    }, {
        key: 'handlePushStatusRadio',
        value: function handlePushStatusRadio(pushStatus) {
            this.setState({ pushStatus: pushStatus });
            this.refs.wrapper.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var serverError = this.state.serverError;
            var user = this.props.user;

            var keysSection = void 0;
            if (this.props.activeSection === 'keys') {
                var inputs = [];

                if (user.first_name) {
                    var handleUpdateFirstNameKey = function handleUpdateFirstNameKey(e) {
                        _this2.updateFirstNameKey(e.target.checked);
                    };
                    inputs.push(_react2.default.createElement(
                        'div',
                        { key: 'userNotificationFirstNameOption' },
                        _react2.default.createElement(
                            'div',
                            { className: 'checkbox' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'notificationTriggerFirst',
                                    type: 'checkbox',
                                    checked: this.state.firstNameKey,
                                    onChange: handleUpdateFirstNameKey
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.notifications.sensitiveName',
                                    defaultMessage: 'Your case sensitive first name "{first_name}"',
                                    values: {
                                        first_name: user.first_name
                                    }
                                })
                            )
                        )
                    ));
                }

                var handleUpdateUsernameKey = function handleUpdateUsernameKey(e) {
                    _this2.updateUsernameKey(e.target.checked);
                };
                inputs.push(_react2.default.createElement(
                    'div',
                    { key: 'userNotificationUsernameOption' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'notificationTriggerUsername',
                                type: 'checkbox',
                                checked: this.state.usernameKey,
                                onChange: handleUpdateUsernameKey
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.sensitiveUsername',
                                defaultMessage: 'Your non-case sensitive username "{username}"',
                                values: {
                                    username: user.username
                                }
                            })
                        )
                    )
                ));

                var handleUpdateChannelKey = function handleUpdateChannelKey(e) {
                    _this2.updateChannelKey(e.target.checked);
                };
                inputs.push(_react2.default.createElement(
                    'div',
                    { key: 'userNotificationChannelOption' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'notificationTriggerShouts',
                                type: 'checkbox',
                                checked: this.state.channelKey,
                                onChange: handleUpdateChannelKey
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.channelWide',
                                defaultMessage: 'Channel-wide mentions "@channel", "@all", "@here"'
                            })
                        )
                    )
                ));

                inputs.push(_react2.default.createElement(
                    'div',
                    { key: 'userNotificationCustomOption' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'notificationTriggerCustom',
                                ref: 'customcheck',
                                type: 'checkbox',
                                checked: this.state.customKeysChecked,
                                onChange: this.updateCustomMentionKeys
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.sensitiveWords',
                                defaultMessage: 'Other non-case sensitive words, separated by commas:'
                            })
                        )
                    ),
                    _react2.default.createElement('input', {
                        id: 'notificationTriggerCustomText',
                        autoFocus: this.state.customKeysChecked,
                        ref: 'custommentions',
                        className: 'form-control mentions-input',
                        type: 'text',
                        defaultValue: this.state.customKeys,
                        onChange: this.onCustomChange
                    })
                ));

                var extraInfo = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.mentionsInfo',
                        defaultMessage: 'Mentions trigger when someone sends a message that includes your username (@{username}) or any of the options selected above.',
                        values: {
                            username: user.username
                        }
                    })
                );

                keysSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('user.settings.notifications.wordsTrigger', 'Words that trigger mentions'),
                    inputs: inputs,
                    submit: this.handleSubmit,
                    saving: this.state.isSaving,
                    server_error: serverError,
                    updateSection: this.handleUpdateSection,
                    extraInfo: extraInfo
                });
            } else {
                var keys = ['@' + user.username];
                if (this.state.firstNameKey) {
                    keys.push(user.first_name);
                }
                if (this.state.usernameKey) {
                    keys.push(user.username);
                }

                if (this.state.channelKey) {
                    keys.push('@channel');
                    keys.push('@all');
                    keys.push('@here');
                }
                if (this.state.customKeys.length > 0) {
                    keys = keys.concat(this.state.customKeys.split(','));
                }

                var describe = '';
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i] !== '') {
                        describe += '"' + keys[i] + '", ';
                    }
                }

                if (describe.length > 0) {
                    describe = describe.substring(0, describe.length - 2);
                } else {
                    describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.noWords',
                        defaultMessage: 'No words configured'
                    });
                }

                keysSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('user.settings.notifications.wordsTrigger', 'Words that trigger mentions'),
                    describe: describe,
                    focused: this.props.prevActiveSection === prevSections.keys,
                    section: 'keys',
                    updateSection: this.handleUpdateSection
                });
            }

            var commentsSection = void 0;
            if (this.props.activeSection === 'comments') {
                var commentsActive = [false, false, false];
                if (this.state.notifyCommentsLevel === 'never') {
                    commentsActive[2] = true;
                } else if (this.state.notifyCommentsLevel === 'root') {
                    commentsActive[1] = true;
                } else {
                    commentsActive[0] = true;
                }

                var _inputs = [];

                _inputs.push(_react2.default.createElement(
                    'div',
                    { key: 'userNotificationLevelOption' },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'notificationCommentsAny',
                                type: 'radio',
                                name: 'commentsNotificationLevel',
                                checked: commentsActive[0],
                                onChange: this.handleNotifyCommentsRadio.bind(this, 'any')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.commentsAny',
                                defaultMessage: 'Mention any comments in a thread you participated in (This will include both mentions to your root post and any comments after you commented on a post)'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'notificationCommentsRoot',
                                type: 'radio',
                                name: 'commentsNotificationLevel',
                                checked: commentsActive[1],
                                onChange: this.handleNotifyCommentsRadio.bind(this, 'root')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.commentsRoot',
                                defaultMessage: 'Mention any comments on your post'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'notificationCommentsNever',
                                type: 'radio',
                                name: 'commentsNotificationLevel',
                                checked: commentsActive[2],
                                onChange: this.handleNotifyCommentsRadio.bind(this, 'never')
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.commentsNever',
                                defaultMessage: 'No mentions for comments'
                            })
                        )
                    )
                ));

                var _extraInfo = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.commentsInfo',
                        defaultMessage: 'In addition to notifications for when you\'re mentioned, select if you would like to receive notifications on reply threads.'
                    })
                );

                commentsSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('user.settings.notifications.comments', 'Reply notifications'),
                    extraInfo: _extraInfo,
                    inputs: _inputs,
                    submit: this.handleSubmit,
                    saving: this.state.isSaving,
                    server_error: serverError,
                    updateSection: this.handleUpdateSection
                });
            } else {
                var _describe = '';
                if (this.state.notifyCommentsLevel === 'never') {
                    _describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.commentsNever',
                        defaultMessage: 'Do not trigger notifications on messages in reply threads unless I\'m mentioned'
                    });
                } else if (this.state.notifyCommentsLevel === 'root') {
                    _describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.commentsRoot',
                        defaultMessage: 'Trigger notifications on messages in threads that I start'
                    });
                } else {
                    _describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.commentsAny',
                        defaultMessage: 'Trigger notifications on messages in reply threads that I start or participate in'
                    });
                }

                commentsSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('user.settings.notifications.comments', 'Reply notifications'),
                    describe: _describe,
                    focused: this.props.prevActiveSection === prevSections.comments,
                    section: 'comments',
                    updateSection: this.handleUpdateSection
                });
            }

            var pushNotificationSection = this.createPushNotificationSection();
            var enableEmail = this.state.enableEmail === 'true';

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'closeButton',
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.title',
                            defaultMessage: 'Notification Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'wrapper',
                        className: 'user-settings'
                    },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.header',
                            defaultMessage: 'Notifications'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    _react2.default.createElement(_desktop_notification_settings2.default, {
                        activity: this.state.desktopActivity,
                        sound: this.state.desktopSound,
                        duration: this.state.desktopDuration,
                        updateSection: this.updateSection,
                        setParentState: this.setStateValue,
                        submit: this.handleSubmit,
                        saving: this.state.isSaving,
                        cancel: this.handleCancel,
                        error: this.state.serverError,
                        active: this.props.activeSection === 'desktop',
                        focused: this.props.prevActiveSection === prevSections.desktop
                    }),
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    _react2.default.createElement(_email_notification_setting2.default, {
                        activeSection: this.props.activeSection,
                        updateSection: this.props.updateSection,
                        enableEmail: enableEmail,
                        emailInterval: Utils.getEmailInterval(this.props.enableEmailBatching, enableEmail),
                        onSubmit: this.handleSubmit,
                        onCancel: this.handleCancel,
                        saving: this.state.isSaving,
                        serverError: this.state.serverError,
                        focused: this.props.prevActiveSection === prevSections.email,
                        sendEmailNotifications: this.props.sendEmailNotifications,
                        enableEmailBatching: this.props.enableEmailBatching,
                        siteName: this.props.siteName
                    }),
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    pushNotificationSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    keysSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    commentsSection,
                    _react2.default.createElement('div', { className: 'divider-dark' })
                )
            );
        }
    }]);
    return NotificationsTab;
}(_react2.default.Component);

exports.default = NotificationsTab;


NotificationsTab.propTypes = {
    user: _propTypes2.default.object,
    updateSection: _propTypes2.default.func,
    updateTab: _propTypes2.default.func,
    activeSection: _propTypes2.default.string,
    prevActiveSection: _propTypes2.default.string,
    activeTab: _propTypes2.default.string,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    sendEmailNotifications: _propTypes2.default.bool,
    enableEmailBatching: _propTypes2.default.bool,
    siteName: _propTypes2.default.string,
    sendPushNotifications: _propTypes2.default.bool
};

NotificationsTab.defaultProps = {
    user: null,
    activeSection: '',
    prevActiveSection: '',
    activeTab: ''
};

/***/ }),

/***/ 2339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesktopNotificationSettings = function (_React$Component) {
    (0, _inherits3.default)(DesktopNotificationSettings, _React$Component);

    function DesktopNotificationSettings() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DesktopNotificationSettings);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DesktopNotificationSettings.__proto__ || (0, _getPrototypeOf2.default)(DesktopNotificationSettings)).call.apply(_ref, [this].concat(args))), _this), _this.handleMinUpdateSection = function (section) {
            _this.props.updateSection(section);

            _this.props.cancel();
        }, _this.handleMaxUpdateSection = function (section) {
            _this.props.updateSection(section);
        }, _this.handleOnChange = function (e) {
            var key = e.currentTarget.getAttribute('data-key');
            var value = e.currentTarget.getAttribute('data-value');
            _this.props.setParentState(key, value);
        }, _this.buildMaximizedSetting = function () {
            var inputs = [];
            var extraInfo = null;

            var activityRadio = [false, false, false];
            if (_this.props.activity === _constants.NotificationLevels.MENTION) {
                activityRadio[1] = true;
            } else if (_this.props.activity === _constants.NotificationLevels.NONE) {
                activityRadio[2] = true;
            } else {
                activityRadio[0] = true;
            }

            var soundSection = void 0;
            var durationSection = void 0;
            if (_this.props.activity !== _constants.NotificationLevels.NONE) {
                var soundRadio = [false, false];
                if (_this.props.sound === 'false') {
                    soundRadio[1] = true;
                } else {
                    soundRadio[0] = true;
                }

                if (Utils.hasSoundOptions()) {
                    soundSection = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.desktop.sound',
                                defaultMessage: 'Notification sound'
                            })
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'soundOn',
                                    type: 'radio',
                                    name: 'notificationSounds',
                                    checked: soundRadio[0],
                                    'data-key': 'desktopSound',
                                    'data-value': 'true',
                                    onChange: _this.handleOnChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.notifications.on',
                                    defaultMessage: 'On'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'soundOff',
                                    type: 'radio',
                                    name: 'notificationSounds',
                                    checked: soundRadio[1],
                                    'data-key': 'desktopSound',
                                    'data-value': 'false',
                                    onChange: _this.handleOnChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.notifications.off',
                                    defaultMessage: 'Off'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.sounds_info',
                                defaultMessage: 'Notification sounds are available on IE11, Safari, Chrome and Mattermost Desktop Apps.'
                            })
                        )
                    );
                } else {
                    soundSection = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.desktop.sound',
                                defaultMessage: 'Notification sound'
                            })
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.soundConfig',
                            defaultMessage: 'Please configure notification sounds in your browser settings'
                        })
                    );
                }

                var durationRadio = [false, false, false, false];
                if (_this.props.duration === '3') {
                    durationRadio[0] = true;
                } else if (_this.props.duration === '10') {
                    durationRadio[2] = true;
                } else if (_this.props.duration === '0') {
                    durationRadio[3] = true;
                } else {
                    durationRadio[1] = true;
                }

                durationSection = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.duration',
                            defaultMessage: 'Notification duration'
                        })
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'soundDuration3',
                                type: 'radio',
                                name: 'desktopDuration',
                                checked: durationRadio[0],
                                'data-key': 'desktopDuration',
                                'data-value': '3',
                                onChange: _this.handleOnChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.desktop.seconds',
                                defaultMessage: '{seconds} seconds',
                                values: {
                                    seconds: '3'
                                }
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'soundDuration5',
                                type: 'radio',
                                name: 'desktopDuration',
                                checked: durationRadio[1],
                                'data-key': 'desktopDuration',
                                'data-value': '5',
                                onChange: _this.handleOnChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.desktop.seconds',
                                defaultMessage: '{seconds} seconds',
                                values: {
                                    seconds: '5'
                                }
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'soundDuration10',
                                type: 'radio',
                                name: 'desktopDuration',
                                checked: durationRadio[2],
                                'data-key': 'desktopDuration',
                                'data-value': '10',
                                onChange: _this.handleOnChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.desktop.seconds',
                                defaultMessage: '{seconds} seconds',
                                values: {
                                    seconds: '10'
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'soundDurationUnlimited',
                                type: 'radio',
                                name: 'desktopDuration',
                                checked: durationRadio[3],
                                'data-key': 'desktopDuration',
                                'data-value': '0',
                                onChange: _this.handleOnChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.desktop.unlimited',
                                defaultMessage: 'Unlimited'
                            })
                        )
                    )
                );

                extraInfo = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.desktop.durationInfo',
                        defaultMessage: 'Sets how long desktop notifications will remain on screen when using Firefox or Chrome. Desktop notifications in Edge, Safari and Mattermost Desktop Apps can only stay on screen for a maximum of 5 seconds.'
                    })
                );
            }

            inputs.push(_react2.default.createElement(
                'div',
                { key: 'userNotificationLevelOption' },
                _react2.default.createElement(
                    'label',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.desktop',
                        defaultMessage: 'Send desktop notifications'
                    })
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            id: 'desktopNotificationAllActivity',
                            type: 'radio',
                            name: 'desktopNotificationLevel',
                            checked: activityRadio[0],
                            'data-key': 'desktopActivity',
                            'data-value': _constants.NotificationLevels.ALL,
                            onChange: _this.handleOnChange
                        }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.allActivity',
                            defaultMessage: 'For all activity'
                        })
                    ),
                    _react2.default.createElement('br', null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            id: 'desktopNotificationMentions',
                            type: 'radio',
                            name: 'desktopNotificationLevel',
                            checked: activityRadio[1],
                            'data-key': 'desktopActivity',
                            'data-value': _constants.NotificationLevels.MENTION,
                            onChange: _this.handleOnChange
                        }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.onlyMentions',
                            defaultMessage: 'Only for mentions and direct messages'
                        })
                    ),
                    _react2.default.createElement('br', null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            id: 'desktopNotificationNever',
                            type: 'radio',
                            name: 'desktopNotificationLevel',
                            checked: activityRadio[2],
                            'data-key': 'desktopActivity',
                            'data-value': _constants.NotificationLevels.NONE,
                            onChange: _this.handleOnChange
                        }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.never',
                            defaultMessage: 'Never'
                        })
                    )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.info',
                        defaultMessage: 'Desktop notifications are available on Edge, Firefox, Safari, Chrome and Mattermost Desktop Apps.'
                    })
                ),
                soundSection,
                durationSection
            ));

            return _react2.default.createElement(_setting_item_max2.default, {
                title: Utils.localizeMessage('user.settings.notifications.desktop.title', 'Desktop notifications'),
                extraInfo: extraInfo,
                inputs: inputs,
                submit: _this.props.submit,
                saving: _this.props.saving,
                server_error: _this.props.error,
                updateSection: _this.handleMaxUpdateSection
            });
        }, _this.buildMinimizedSetting = function () {
            var describe = '';
            if (_this.props.activity === _constants.NotificationLevels.MENTION) {
                if (Utils.hasSoundOptions() && _this.props.sound !== 'false') {
                    if (_this.props.duration === '0') {
                        //eslint-disable-line no-lonely-if
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.mentionsSoundForever',
                            defaultMessage: 'For mentions and direct messages, with sound, shown indefinitely'
                        });
                    } else {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.mentionsSoundTimed',
                            defaultMessage: 'For mentions and direct messages, with sound, shown for {seconds} seconds',
                            values: {
                                seconds: _this.props.duration
                            }
                        });
                    }
                } else if (Utils.hasSoundOptions() && _this.props.sound === 'false') {
                    if (_this.props.duration === '0') {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.mentionsNoSoundForever',
                            defaultMessage: 'For mentions and direct messages, without sound, shown indefinitely'
                        });
                    } else {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.mentionsNoSoundTimed',
                            defaultMessage: 'For mentions and direct messages, without sound, shown for {seconds} seconds',
                            values: {
                                seconds: _this.props.duration
                            }
                        });
                    }
                } else {
                    if (_this.props.duration === '0') {
                        //eslint-disable-line no-lonely-if
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.mentionsSoundHiddenForever',
                            defaultMessage: 'For mentions and direct messages, shown indefinitely'
                        });
                    } else {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.mentionsSoundHiddenTimed',
                            defaultMessage: 'For mentions and direct messages, shown for {seconds} seconds',
                            values: {
                                seconds: _this.props.duration
                            }
                        });
                    }
                }
            } else if (_this.props.activity === _constants.NotificationLevels.NONE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.notifications.off',
                    defaultMessage: 'Off'
                });
            } else {
                if (Utils.hasSoundOptions() && _this.props.sound !== 'false') {
                    //eslint-disable-line no-lonely-if
                    if (_this.props.duration === '0') {
                        //eslint-disable-line no-lonely-if
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.allSoundForever',
                            defaultMessage: 'For all activity, with sound, shown indefinitely'
                        });
                    } else {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.allSoundTimed',
                            defaultMessage: 'For all activity, with sound, shown for {seconds} seconds',
                            values: {
                                seconds: _this.props.duration
                            }
                        });
                    }
                } else if (Utils.hasSoundOptions() && _this.props.sound === 'false') {
                    if (_this.props.duration === '0') {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.allNoSoundForever',
                            defaultMessage: 'For all activity, without sound, shown indefinitely'
                        });
                    } else {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.allNoSoundTimed',
                            defaultMessage: 'For all activity, without sound, shown for {seconds} seconds',
                            values: {
                                seconds: _this.props.duration
                            }
                        });
                    }
                } else {
                    if (_this.props.duration === '0') {
                        //eslint-disable-line no-lonely-if
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.allSoundHiddenForever',
                            defaultMessage: 'For all activity, shown indefinitely'
                        });
                    } else {
                        describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.desktop.allSoundHiddenTimed',
                            defaultMessage: 'For all activity, shown for {seconds} seconds',
                            values: {
                                seconds: _this.props.duration
                            }
                        });
                    }
                }
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: Utils.localizeMessage('user.settings.notifications.desktop.title', 'Desktop notifications'),
                describe: describe,
                focused: _this.props.focused,
                section: 'desktop',
                updateSection: _this.handleMinUpdateSection
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DesktopNotificationSettings, [{
        key: 'render',
        value: function render() {
            if (this.props.active) {
                return this.buildMaximizedSetting();
            }

            return this.buildMinimizedSetting();
        }
    }]);
    return DesktopNotificationSettings;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = DesktopNotificationSettings;


DesktopNotificationSettings.propTypes = {
    activity: _propTypes2.default.string.isRequired,
    sound: _propTypes2.default.string.isRequired,
    duration: _propTypes2.default.string.isRequired,
    updateSection: _propTypes2.default.func,
    setParentState: _propTypes2.default.func,
    submit: _propTypes2.default.func,
    cancel: _propTypes2.default.func,
    error: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    saving: _propTypes2.default.bool,
    focused: _propTypes2.default.bool
};

/***/ }),

/***/ 2340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmailNotificationSetting = function (_React$Component) {
    (0, _inherits3.default)(EmailNotificationSetting, _React$Component);

    function EmailNotificationSetting(props) {
        (0, _classCallCheck3.default)(this, EmailNotificationSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmailNotificationSetting.__proto__ || (0, _getPrototypeOf2.default)(EmailNotificationSetting)).call(this, props));

        _this.handleChange = function (e) {
            var enableEmail = e.currentTarget.getAttribute('data-enable-email');
            var emailInterval = parseInt(e.currentTarget.getAttribute('data-email-interval'), 10);
            _this.setState({
                enableEmail: enableEmail,
                emailInterval: emailInterval
            });
        };

        _this.handleSubmit = function () {
            var _this$state = _this.state,
                enableEmail = _this$state.enableEmail,
                emailInterval = _this$state.emailInterval;

            if (_this.props.enableEmail !== enableEmail || _this.props.emailInterval !== emailInterval) {
                // until the rest of the notification settings are moved to preferences, we have to do this separately
                (0, _user_actions.savePreference)(_constants.Preferences.CATEGORY_NOTIFICATIONS, _constants.Preferences.EMAIL_INTERVAL, emailInterval.toString());

                _this.props.onSubmit(enableEmail);
            } else {
                _this.props.updateSection('');
            }
        };

        _this.handleUpdateSection = function (section) {
            if (section) {
                _this.props.updateSection(section);
            } else {
                _this.props.updateSection('');

                _this.setState({
                    enableEmail: _this.props.enableEmail,
                    emailInterval: _this.props.emailInterval
                });
                _this.props.onCancel();
            }
        };

        _this.state = {
            enableEmail: props.enableEmail,
            emailInterval: props.emailInterval
        };
        return _this;
    }

    (0, _createClass3.default)(EmailNotificationSetting, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.saving && (nextProps.enableEmail !== this.props.enableEmail || nextProps.emailInterval !== this.props.emailInterval)) {
                this.setState({
                    enableEmail: nextProps.enableEmail,
                    emailInterval: nextProps.emailInterval
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.sendEmailNotifications && this.props.activeSection === 'email') {
                var inputs = [];

                inputs.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'oauthEmailInfo',
                        className: 'padding-top'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.email.disabled_long',
                        defaultMessage: 'Email notifications have been disabled by your System Administrator.'
                    })
                ));

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: (0, _utils.localizeMessage)('user.settings.notifications.emailNotifications', 'Email notifications'),
                    inputs: inputs,
                    server_error: this.state.serverError,
                    section: 'email',
                    updateSection: this.handleUpdateSection
                });
            }

            if (this.props.activeSection !== 'email') {
                var description = void 0;

                if (!this.props.sendEmailNotifications) {
                    description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.email.disabled',
                        defaultMessage: 'Disabled by System Administrator'
                    });
                } else if (this.props.enableEmail) {
                    switch (this.state.emailInterval) {
                        case _constants.Preferences.INTERVAL_IMMEDIATE:
                            description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.immediately',
                                defaultMessage: 'Immediately'
                            });
                            break;
                        case _constants.Preferences.INTERVAL_HOUR:
                            description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.everyHour',
                                defaultMessage: 'Every hour'
                            });
                            break;
                        default:
                            description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.everyXMinutes',
                                defaultMessage: 'Every {count, plural, one {minute} other {{count, number} minutes}}',
                                values: { count: this.state.emailInterval / 60 }
                            });
                    }
                } else {
                    description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.notifications.email.never',
                        defaultMessage: 'Never'
                    });
                }

                return _react2.default.createElement(_setting_item_min2.default, {
                    title: (0, _utils.localizeMessage)('user.settings.notifications.emailNotifications', 'Email notifications'),
                    describe: description,
                    focused: this.props.focused,
                    section: 'email',
                    updateSection: this.handleUpdateSection
                });
            }

            var batchingOptions = null;
            var batchingInfo = null;
            if (this.props.enableEmailBatching) {
                batchingOptions = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'emailNotificationMinutes',
                                type: 'radio',
                                name: 'emailNotifications',
                                checked: this.state.emailInterval === _constants.Preferences.INTERVAL_FIFTEEN_MINUTES,
                                'data-enable-email': 'true',
                                'data-email-interval': _constants.Preferences.INTERVAL_FIFTEEN_MINUTES,
                                onChange: this.handleChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.everyXMinutes',
                                defaultMessage: 'Every {count} minutes',
                                values: { count: _constants.Preferences.INTERVAL_FIFTEEN_MINUTES / 60 }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'emailNotificationHour',
                                type: 'radio',
                                name: 'emailNotifications',
                                checked: this.state.emailInterval === _constants.Preferences.INTERVAL_HOUR,
                                'data-enable-email': 'true',
                                'data-email-interval': _constants.Preferences.INTERVAL_HOUR,
                                onChange: this.handleChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.everyHour',
                                defaultMessage: 'Every hour'
                            })
                        )
                    )
                );

                batchingInfo = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.notifications.emailBatchingInfo',
                    defaultMessage: 'Notifications received over the time period selected are combined and sent in a single email.'
                });
            }

            return _react2.default.createElement(_setting_item_max2.default, {
                title: (0, _utils.localizeMessage)('user.settings.notifications.emailNotifications', 'Email notifications'),
                inputs: [_react2.default.createElement(
                    'div',
                    { key: 'userNotificationEmailOptions' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.email.send',
                            defaultMessage: 'Send email notifications'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'emailNotificationImmediately',
                                type: 'radio',
                                name: 'emailNotifications',
                                checked: this.state.emailInterval === _constants.Preferences.INTERVAL_IMMEDIATE,
                                'data-enable-email': 'true',
                                'data-email-interval': _constants.Preferences.INTERVAL_IMMEDIATE,
                                onChange: this.handleChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.immediately',
                                defaultMessage: 'Immediately'
                            })
                        )
                    ),
                    batchingOptions,
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'emailNotificationNever',
                                type: 'radio',
                                name: 'emailNotifications',
                                checked: this.state.emailInterval === _constants.Preferences.INTERVAL_NEVER,
                                'data-enable-email': 'false',
                                'data-email-interval': _constants.Preferences.INTERVAL_NEVER,
                                onChange: this.handleChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.notifications.email.never',
                                defaultMessage: 'Never'
                            })
                        )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.notifications.emailInfo',
                            defaultMessage: 'Email notifications are sent for mentions and direct messages when you are offline or away from {siteName} for more than 5 minutes.',
                            values: {
                                siteName: this.props.siteName
                            }
                        }),
                        ' ',
                        batchingInfo
                    )
                )],
                submit: this.handleSubmit,
                saving: this.props.saving,
                server_error: this.props.serverError,
                updateSection: this.handleUpdateSection
            });
        }
    }]);
    return EmailNotificationSetting;
}(_react2.default.Component);

EmailNotificationSetting.propTypes = {
    activeSection: _propTypes2.default.string.isRequired,
    updateSection: _propTypes2.default.func.isRequired,
    enableEmail: _propTypes2.default.bool.isRequired,
    emailInterval: _propTypes2.default.number.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    serverError: _propTypes2.default.string,
    saving: _propTypes2.default.bool,
    focused: _propTypes2.default.bool,
    sendEmailNotifications: _propTypes2.default.bool,
    enableEmailBatching: _propTypes2.default.bool,
    siteName: _propTypes2.default.string
};
exports.default = EmailNotificationSetting;

/***/ }),

/***/ 2341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _user_utils = __webpack_require__(175);

var UserUtils = _interopRequireWildcard(_user_utils);

var _general = __webpack_require__(113);

var _utils = __webpack_require__(762);

var _user_settings_security = __webpack_require__(2342);

var _user_settings_security2 = _interopRequireDefault(_user_settings_security);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function mapStateToProps(state, ownProps) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var tokensEnabled = config.EnableUserAccessTokens === 'true';
    var userHasTokenRole = UserUtils.hasUserAccessTokenRole(ownProps.user.roles) || UserUtils.isSystemAdmin(ownProps.user.roles);

    var isLicensed = license && license.IsLicensed === 'true';
    var mfaLicensed = license && license.MFA === 'true';

    var enableOAuthServiceProvider = config.EnableOAuthServiceProvider === 'true';
    var enableMultifactorAuthentication = config.EnableMultifactorAuthentication === 'true';
    var enforceMultifactorAuthentication = config.EnforceMultifactorAuthentication === 'true';
    var enableSignUpWithEmail = config.EnableSignUpWithEmail === 'true';
    var enableSignUpWithGitLab = config.EnableSignUpWithGitLab === 'true';
    var enableSignUpWithGoogle = config.EnableSignUpWithGoogle === 'true';
    var enableLdap = config.EnableLdap === 'true';
    var enableSaml = config.EnableSaml === 'true';
    var enableSignUpWithOffice365 = config.EnableSignUpWithOffice365 === 'true';
    var experimentalEnableAuthenticationTransfer = config.ExperimentalEnableAuthenticationTransfer === 'true';

    return {
        userAccessTokens: state.entities.users.myUserAccessTokens,
        canUseAccessTokens: tokensEnabled && userHasTokenRole,
        isLicensed: isLicensed,
        mfaLicensed: mfaLicensed,
        enableOAuthServiceProvider: enableOAuthServiceProvider,
        enableMultifactorAuthentication: enableMultifactorAuthentication,
        enforceMultifactorAuthentication: enforceMultifactorAuthentication,
        enableSignUpWithEmail: enableSignUpWithEmail,
        enableSignUpWithGitLab: enableSignUpWithGitLab,
        enableSignUpWithGoogle: enableSignUpWithGoogle,
        enableLdap: enableLdap,
        enableSaml: enableSaml,
        enableSignUpWithOffice365: enableSignUpWithOffice365,
        experimentalEnableAuthenticationTransfer: experimentalEnableAuthenticationTransfer,
        passwordConfig: (0, _utils.getPasswordConfig)(license, config)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getMe: _users.getMe,
            getUserAccessTokensForUser: _users.getUserAccessTokensForUser,
            createUserAccessToken: _users.createUserAccessToken,
            revokeUserAccessToken: _users.revokeUserAccessToken,
            enableUserAccessToken: _users.enableUserAccessToken,
            disableUserAccessToken: _users.disableUserAccessToken,
            clearUserAccessTokens: _users.clearUserAccessTokens
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_user_settings_security2.default);

/***/ }),

/***/ 2342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _user_utils = __webpack_require__(175);

var UserUtils = _interopRequireWildcard(_user_utils);

var _browser_history = __webpack_require__(273);

var _diagnostics_actions = __webpack_require__(804);

var _user_actions = __webpack_require__(781);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _icon50x = __webpack_require__(1035);

var _icon50x2 = _interopRequireDefault(_icon50x);

var _access_history_modal = __webpack_require__(2343);

var _access_history_modal2 = _interopRequireDefault(_access_history_modal);

var _activity_log_modal = __webpack_require__(2345);

var _activity_log_modal2 = _interopRequireDefault(_activity_log_modal);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _toggle_modal_button = __webpack_require__(977);

var _toggle_modal_button2 = _interopRequireDefault(_toggle_modal_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOKEN_CREATING = 'creating'; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TOKEN_CREATED = 'created';
var TOKEN_NOT_CREATING = 'not_creating';
var SECTION_MFA = 'mfa';
var SECTION_PASSWORD = 'password';
var SECTION_SIGNIN = 'signin';
var SECTION_APPS = 'apps';
var SECTION_TOKENS = 'tokens';

var SecurityTab = function (_React$Component) {
    (0, _inherits3.default)(SecurityTab, _React$Component);

    function SecurityTab(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, SecurityTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SecurityTab.__proto__ || (0, _getPrototypeOf2.default)(SecurityTab)).call(this, props));

        _this.submitPassword = function () {
            var user = _this.props.user;
            var currentPassword = _this.state.currentPassword;
            var newPassword = _this.state.newPassword;
            var confirmPassword = _this.state.confirmPassword;

            if (currentPassword === '') {
                _this.setState({ passwordError: Utils.localizeMessage('user.settings.security.currentPasswordError', 'Please enter your current password.'), serverError: '' });
                return;
            }

            var passwordErr = Utils.isValidPassword(newPassword, _this.props.passwordConfig);
            if (passwordErr !== '') {
                _this.setState({
                    passwordError: passwordErr,
                    serverError: ''
                });
                return;
            }

            if (newPassword !== confirmPassword) {
                var defaultState = (0, _assign2.default)(_this.getDefaultState(), { passwordError: Utils.localizeMessage('user.settings.security.passwordMatchError', 'The new passwords you entered do not match.'), serverError: '' });
                _this.setState(defaultState);
                return;
            }

            _this.setState({ savingPassword: true });

            (0, _user_actions.updatePassword)(user.id, currentPassword, newPassword, function () {
                _this.props.updateSection('');
                _this.props.actions.getMe();
                _this.setState(_this.getDefaultState());
            }, function (err) {
                var state = _this.getDefaultState();
                if (err.message) {
                    state.serverError = err.message;
                } else {
                    state.serverError = err;
                }
                state.passwordError = '';
                _this.setState(state);
            });
        };

        _this.setupMfa = function (e) {
            e.preventDefault();
            _browser_history.browserHistory.push('/mfa/setup');
        };

        _this.removeMfa = function () {
            (0, _user_actions.deactivateMfa)(function () {
                if (_this.props.mfaLicensed && _this.props.enableMultifactorAuthentication && _this.props.enforceMultifactorAuthentication) {
                    window.location.href = '/mfa/setup';
                    return;
                }

                _this.props.updateSection('');
                _this.setState(_this.getDefaultState());
            }, function (err) {
                var state = _this.getDefaultState();
                if (err.message) {
                    state.serverError = err.message;
                } else {
                    state.serverError = err;
                }
                _this.setState(state);
            });
        };

        _this.updateCurrentPassword = function (e) {
            _this.setState({ currentPassword: e.target.value });
        };

        _this.updateNewPassword = function (e) {
            _this.setState({ newPassword: e.target.value });
        };

        _this.updateConfirmPassword = function (e) {
            _this.setState({ confirmPassword: e.target.value });
        };

        _this.deauthorizeApp = function (e) {
            e.preventDefault();
            var appId = e.currentTarget.getAttribute('data-app');
            (0, _user_actions.deauthorizeOAuthApp)(appId, function () {
                var authorizedApps = _this.state.authorizedApps.filter(function (app) {
                    return app.id !== appId;
                });

                _this.setState({ authorizedApps: authorizedApps, serverError: null });
            }, function (err) {
                _this.setState({ serverError: err.message });
            });
        };

        _this.handleUpdateSection = function (section) {
            if (section) {
                _this.props.updateSection(section);
            } else {
                switch (_this.props.activeSection) {
                    case SECTION_MFA:
                    case SECTION_SIGNIN:
                    case SECTION_APPS:
                        _this.setState({
                            serverError: null
                        });
                        break;
                    case SECTION_PASSWORD:
                        _this.setState({
                            currentPassword: '',
                            newPassword: '',
                            confirmPassword: '',
                            serverError: null,
                            passwordError: null
                        });
                        break;
                    case SECTION_TOKENS:
                        _this.setState({
                            newToken: null,
                            tokenCreationState: TOKEN_NOT_CREATING,
                            serverError: null,
                            tokenError: ''
                        });
                        break;
                    default:
                }

                _this.props.updateSection('');
            }
        };

        _this.createMfaSection = function () {
            if (_this.props.activeSection === SECTION_MFA) {
                var content = void 0;
                var extraInfo = void 0;
                if (_this.props.user.mfa_active) {
                    var mfaRemoveHelp = void 0;
                    var mfaButtonText = void 0;

                    if (_this.props.enforceMultifactorAuthentication) {
                        mfaRemoveHelp = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.mfa.requiredHelp',
                            defaultMessage: 'Multi-factor authentication is required on this server. Resetting is only recommended when you need to switch code generation to a new mobile device. You will be required to set it up again immediately.'
                        });

                        mfaButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.mfa.reset',
                            defaultMessage: 'Reset MFA on your account'
                        });
                    } else {
                        mfaRemoveHelp = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.mfa.removeHelp',
                            defaultMessage: 'Removing multi-factor authentication means you will no longer require a phone-based passcode to sign-in to your account.'
                        });

                        mfaButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.mfa.remove',
                            defaultMessage: 'Remove MFA from your account'
                        });
                    }

                    content = _react2.default.createElement(
                        'div',
                        { key: 'mfaQrCode' },
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'btn btn-primary',
                                href: '#',
                                onClick: _this.removeMfa
                            },
                            mfaButtonText
                        ),
                        _react2.default.createElement('br', null)
                    );

                    extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        mfaRemoveHelp
                    );
                } else {
                    content = _react2.default.createElement(
                        'div',
                        { key: 'mfaQrCode' },
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'btn btn-primary',
                                href: '#',
                                onClick: _this.setupMfa
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.mfa.add',
                                defaultMessage: 'Add MFA to your account'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    );

                    extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.mfa.addHelp',
                            defaultMessage: 'Adding multi-factor authentication will make your account more secure by requiring a code from your mobile phone each time you sign in.'
                        })
                    );
                }

                var inputs = [];
                inputs.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'mfaSetting',
                        className: 'padding-top'
                    },
                    content
                ));

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('user.settings.mfa.title', 'Multi-factor Authentication'),
                    inputs: inputs,
                    extraInfo: extraInfo,
                    serverError: _this.state.serverError,
                    updateSection: _this.handleUpdateSection,
                    width: 'medium'
                });
            }

            var describe = void 0;
            if (_this.props.user.mfa_active) {
                describe = Utils.localizeMessage('user.settings.security.active', 'Active');
            } else {
                describe = Utils.localizeMessage('user.settings.security.inactive', 'Inactive');
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: Utils.localizeMessage('user.settings.mfa.title', 'Multi-factor Authentication'),
                describe: describe,
                section: SECTION_MFA,
                updateSection: _this.handleUpdateSection
            });
        };

        _this.createPasswordSection = function () {
            if (_this.props.activeSection === SECTION_PASSWORD) {
                var inputs = [];
                var submit = void 0;

                if (_this.props.user.auth_service === '') {
                    submit = _this.submitPassword;

                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'currentPasswordUpdateForm',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.currentPassword',
                                defaultMessage: 'Current Password'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'currentPassword',
                                autoFocus: true,
                                className: 'form-control',
                                type: 'password',
                                onChange: _this.updateCurrentPassword,
                                value: _this.state.currentPassword
                            })
                        )
                    ));
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'newPasswordUpdateForm',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.newPassword',
                                defaultMessage: 'New Password'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'newPassword',
                                className: 'form-control',
                                type: 'password',
                                onChange: _this.updateNewPassword,
                                value: _this.state.newPassword
                            })
                        )
                    ));
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'retypeNewPasswordUpdateForm',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'label',
                            { className: 'col-sm-5 control-label' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.retypePassword',
                                defaultMessage: 'Retype New Password'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-7' },
                            _react2.default.createElement('input', {
                                id: 'confirmPassword',
                                className: 'form-control',
                                type: 'password',
                                onChange: _this.updateConfirmPassword,
                                value: _this.state.confirmPassword
                            })
                        )
                    ));
                } else if (_this.props.user.auth_service === _constants2.default.GITLAB_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.passwordGitlabCantUpdate',
                                defaultMessage: 'Login occurs through GitLab. Password cannot be updated.'
                            })
                        )
                    ));
                } else if (_this.props.user.auth_service === _constants2.default.LDAP_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.passwordLdapCantUpdate',
                                defaultMessage: 'Login occurs through AD/LDAP. Password cannot be updated.'
                            })
                        )
                    ));
                } else if (_this.props.user.auth_service === _constants2.default.SAML_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.passwordSamlCantUpdate',
                                defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so through your login provider.'
                            })
                        )
                    ));
                } else if (_this.props.user.auth_service === _constants2.default.GOOGLE_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.passwordGoogleCantUpdate',
                                defaultMessage: 'Login occurs through Google Apps. Password cannot be updated.'
                            })
                        )
                    ));
                } else if (_this.props.user.auth_service === _constants2.default.OFFICE365_SERVICE) {
                    inputs.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'oauthEmailInfo',
                            className: 'form-group'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.passwordOffice365CantUpdate',
                                defaultMessage: 'Login occurs through Office 365. Password cannot be updated.'
                            })
                        )
                    ));
                }

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.security.password',
                        defaultMessage: 'Password'
                    }),
                    inputs: inputs,
                    submit: submit,
                    saving: _this.state.savingPassword,
                    serverError: _this.state.serverError,
                    clientError: _this.state.passwordError,
                    updateSection: _this.handleUpdateSection
                });
            }

            var describe = void 0;

            if (_this.props.user.auth_service === '') {
                var d = new Date(_this.props.user.last_password_update);
                var hours12 = !_preference_store2.default.getBool(_constants2.default.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants2.default.Preferences.USE_MILITARY_TIME, false);

                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.lastUpdated',
                    defaultMessage: 'Last updated {date} at {time}',
                    values: {
                        date: _react2.default.createElement(_reactIntl.FormattedDate, {
                            value: d,
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                        }),
                        time: _react2.default.createElement(_reactIntl.FormattedTime, {
                            value: d,
                            hour12: hours12,
                            hour: '2-digit',
                            minute: '2-digit'
                        })
                    }
                });
            } else if (_this.props.user.auth_service === _constants2.default.GITLAB_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.loginGitlab',
                    defaultMessage: 'Login done through GitLab'
                });
            } else if (_this.props.user.auth_service === _constants2.default.LDAP_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.loginLdap',
                    defaultMessage: 'Login done through AD/LDAP'
                });
            } else if (_this.props.user.auth_service === _constants2.default.SAML_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.loginSaml',
                    defaultMessage: 'Login done through SAML'
                });
            } else if (_this.props.user.auth_service === _constants2.default.GOOGLE_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.loginGoogle',
                    defaultMessage: 'Login done through Google Apps'
                });
            } else if (_this.props.user.auth_service === _constants2.default.OFFICE365_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.loginOffice365',
                    defaultMessage: 'Login done through Office 365'
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.password',
                    defaultMessage: 'Password'
                }),
                describe: describe,
                section: SECTION_PASSWORD,
                updateSection: _this.handleUpdateSection
            });
        };

        _this.createSignInSection = function () {
            var user = _this.props.user;

            if (_this.props.activeSection === SECTION_SIGNIN) {
                var emailOption = void 0;
                var gitlabOption = void 0;
                var googleOption = void 0;
                var office365Option = void 0;
                var ldapOption = void 0;
                var samlOption = void 0;

                if (user.auth_service === '') {
                    if (_this.props.enableSignUpWithGitLab) {
                        gitlabOption = _react2.default.createElement(
                            'div',
                            { className: 'padding-bottom x2' },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-primary',
                                    to: '/claim/email_to_oauth?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service + '&new_type=' + _constants2.default.GITLAB_SERVICE
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.security.switchGitlab',
                                    defaultMessage: 'Switch to using GitLab SSO'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        );
                    }

                    if (_this.props.enableSignUpWithGoogle) {
                        googleOption = _react2.default.createElement(
                            'div',
                            { className: 'padding-bottom x2' },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-primary',
                                    to: '/claim/email_to_oauth?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service + '&new_type=' + _constants2.default.GOOGLE_SERVICE
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.security.switchGoogle',
                                    defaultMessage: 'Switch to using Google SSO'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        );
                    }

                    if (_this.props.enableSignUpWithOffice365) {
                        office365Option = _react2.default.createElement(
                            'div',
                            { className: 'padding-bottom x2' },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-primary',
                                    to: '/claim/email_to_oauth?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service + '&new_type=' + _constants2.default.OFFICE365_SERVICE
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.security.switchOffice365',
                                    defaultMessage: 'Switch to using Office 365 SSO'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        );
                    }

                    if (_this.props.enableLdap) {
                        ldapOption = _react2.default.createElement(
                            'div',
                            { className: 'padding-bottom x2' },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-primary',
                                    to: '/claim/email_to_ldap?email=' + encodeURIComponent(user.email)
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.security.switchLdap',
                                    defaultMessage: 'Switch to using AD/LDAP'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        );
                    }

                    if (_this.props.enableSaml) {
                        samlOption = _react2.default.createElement(
                            'div',
                            { className: 'padding-bottom x2' },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-primary',
                                    to: '/claim/email_to_oauth?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service + '&new_type=' + _constants2.default.SAML_SERVICE
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.security.switchSaml',
                                    defaultMessage: 'Switch to using SAML SSO'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        );
                    }
                } else if (_this.props.enableSignUpWithEmail) {
                    var link = void 0;
                    if (user.auth_service === _constants2.default.LDAP_SERVICE) {
                        link = '/claim/ldap_to_email?email=' + encodeURIComponent(user.email);
                    } else {
                        link = '/claim/oauth_to_email?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service;
                    }

                    emailOption = _react2.default.createElement(
                        'div',
                        { className: 'padding-bottom x2' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                className: 'btn btn-primary',
                                to: link
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.switchEmail',
                                defaultMessage: 'Switch to using email and password'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    );
                }

                var inputs = [];
                inputs.push(_react2.default.createElement(
                    'div',
                    { key: 'userSignInOption' },
                    emailOption,
                    gitlabOption,
                    googleOption,
                    office365Option,
                    ldapOption,
                    samlOption
                ));

                var extraInfo = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.security.oneSignin',
                        defaultMessage: 'You may only have one sign-in method at a time. Switching sign-in method will send an email notifying you if the change was successful.'
                    })
                );

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('user.settings.security.method', 'Sign-in Method'),
                    extraInfo: extraInfo,
                    inputs: inputs,
                    serverError: _this.state.serverError,
                    updateSection: _this.handleUpdateSection
                });
            }

            var describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'user.settings.security.emailPwd',
                defaultMessage: 'Email and Password'
            });
            if (_this.props.user.auth_service === _constants2.default.GITLAB_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.gitlab',
                    defaultMessage: 'GitLab'
                });
            } else if (_this.props.user.auth_service === _constants2.default.GOOGLE_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.google',
                    defaultMessage: 'Google'
                });
            } else if (_this.props.user.auth_service === _constants2.default.OFFICE365_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.office365',
                    defaultMessage: 'Office 365'
                });
            } else if (_this.props.user.auth_service === _constants2.default.LDAP_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.ldap',
                    defaultMessage: 'AD/LDAP'
                });
            } else if (_this.props.user.auth_service === _constants2.default.SAML_SERVICE) {
                describe = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.saml',
                    defaultMessage: 'SAML'
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: Utils.localizeMessage('user.settings.security.method', 'Sign-in Method'),
                describe: describe,
                section: SECTION_SIGNIN,
                updateSection: _this.handleUpdateSection
            });
        };

        _this.createOAuthAppsSection = function () {
            if (_this.props.activeSection === SECTION_APPS) {
                var apps = void 0;
                if (_this.state.authorizedApps && _this.state.authorizedApps.length > 0) {
                    apps = _this.state.authorizedApps.map(function (app) {
                        var homepage = _react2.default.createElement(
                            'a',
                            {
                                href: app.homepage,
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            },
                            app.homepage
                        );

                        return _react2.default.createElement(
                            'div',
                            {
                                key: app.id,
                                className: 'padding-bottom x2 authorized-app'
                            },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-10' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'authorized-app__name' },
                                    app.name,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'authorized-app__url' },
                                        ' -',
                                        ' ',
                                        homepage
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'authorized-app__description' },
                                    app.description
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'authorized-app__deauthorize' },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            href: '#',
                                            'data-app': app.id,
                                            onClick: _this.deauthorizeApp
                                        },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'user.settings.security.deauthorize',
                                            defaultMessage: 'Deauthorize'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-2 pull-right' },
                                _react2.default.createElement('img', {
                                    alt: app.name,
                                    src: app.icon_url || _icon50x2.default
                                })
                            ),
                            _react2.default.createElement('br', null)
                        );
                    });
                } else {
                    apps = _react2.default.createElement(
                        'div',
                        { className: 'padding-bottom x2 authorized-app' },
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-list__hint' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.security.noApps',
                                defaultMessage: 'No OAuth 2.0 Applications are authorized.'
                            })
                        )
                    );
                }

                var inputs = [];
                var wrapperClass = void 0;
                var helpText = void 0;
                if (Array.isArray(apps)) {
                    wrapperClass = 'authorized-apps__wrapper';

                    helpText = _react2.default.createElement(
                        'div',
                        { className: 'authorized-apps__help' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.security.oauthAppsHelp',
                            defaultMessage: 'Applications act on your behalf to access your data based on the permissions you grant them.'
                        })
                    );
                }

                inputs.push(_react2.default.createElement(
                    'div',
                    {
                        className: wrapperClass,
                        key: 'authorizedApps'
                    },
                    apps
                ));

                var title = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.security.oauthApps',
                        defaultMessage: 'OAuth 2.0 Applications'
                    }),
                    helpText
                );

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: title,
                    inputs: inputs,
                    serverError: _this.state.serverError,
                    updateSection: _this.handleUpdateSection,
                    width: 'full',
                    cancelButtonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.security.close',
                        defaultMessage: 'Close'
                    })
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: Utils.localizeMessage('user.settings.security.oauthApps', 'OAuth 2.0 Applications'),
                describe: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.security.oauthAppsDescription',
                    defaultMessage: 'Click \'Edit\' to manage your OAuth 2.0 Applications'
                }),
                section: SECTION_APPS,
                updateSection: _this.handleUpdateSection
            });
        };

        _this.startCreatingToken = function () {
            _this.setState({ tokenCreationState: TOKEN_CREATING });
        };

        _this.stopCreatingToken = function () {
            _this.setState({ tokenCreationState: TOKEN_NOT_CREATING });
        };

        _this.handleCreateToken = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var description, userId, _ref2, data, error;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.handleCancelConfirm();

                            description = _this.refs.newtokendescription ? _this.refs.newtokendescription.value : '';

                            if (!(description === '')) {
                                _context.next = 5;
                                break;
                            }

                            _this.setState({ tokenError: Utils.localizeMessage('user.settings.tokens.nameRequired', 'Please enter a description.') });
                            return _context.abrupt('return');

                        case 5:

                            _this.setState({ tokenError: '' });

                            userId = _this.props.user ? _this.props.user.id : '';
                            _context.next = 9;
                            return _this.props.actions.createUserAccessToken(userId, description);

                        case 9:
                            _ref2 = _context.sent;
                            data = _ref2.data;
                            error = _ref2.error;


                            if (data) {
                                _this.setState({ tokenCreationState: TOKEN_CREATED, newToken: data });
                            } else if (error) {
                                _this.setState({ serverError: error.message });
                            }

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.handleCancelConfirm = function () {
            _this.setState({
                showConfirmModal: false,
                confirmTitle: null,
                confirmMessage: null,
                confirmButton: null,
                confirmComplete: null
            });
        };

        _this.confirmCreateToken = function () {
            if (UserUtils.isSystemAdmin(_this.props.user.roles)) {
                _this.setState({
                    showConfirmModal: true,
                    confirmTitle: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.tokens.confirmCreateTitle',
                        defaultMessage: 'Create System Admin Personal Access Token'
                    }),
                    confirmMessage: _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'user.settings.tokens.confirmCreateMessage',
                            defaultMessage: 'You are generating a personal access token with System Admin permissions. Are you sure want to create this token?'
                        })
                    ),
                    confirmButton: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.tokens.confirmCreateButton',
                        defaultMessage: 'Yes, Create'
                    }),
                    confirmComplete: function confirmComplete() {
                        _this.handleCreateToken();
                        (0, _diagnostics_actions.trackEvent)('settings', 'system_admin_create_user_access_token');
                    }
                });

                return;
            }

            _this.handleCreateToken();
        };

        _this.saveTokenKeyPress = function (e) {
            if (Utils.isKeyPressed(e, _constants2.default.KeyCodes.ENTER)) {
                _this.confirmCreateToken();
            }
        };

        _this.confirmRevokeToken = function (tokenId) {
            var token = _this.props.userAccessTokens[tokenId];

            _this.setState({
                showConfirmModal: true,
                confirmTitle: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.tokens.confirmDeleteTitle',
                    defaultMessage: 'Delete Token?'
                }),
                confirmMessage: _react2.default.createElement(
                    'div',
                    { className: 'alert alert-danger' },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'user.settings.tokens.confirmDeleteMessage',
                        defaultMessage: 'Any integrations using this token will no longer be able to access the Mattermost API. You cannot undo this action. <br /><br />Are you sure want to delete the {description} token?',
                        values: {
                            description: token.description
                        }
                    })
                ),
                confirmButton: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.tokens.confirmDeleteButton',
                    defaultMessage: 'Yes, Delete'
                }),
                confirmComplete: function confirmComplete() {
                    _this.revokeToken(tokenId);
                    (0, _diagnostics_actions.trackEvent)('settings', 'revoke_user_access_token');
                }
            });
        };

        _this.revokeToken = function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(tokenId) {
                var _ref4, error;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.props.actions.revokeUserAccessToken(tokenId);

                            case 2:
                                _ref4 = _context2.sent;
                                error = _ref4.error;

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                }
                                _this.handleCancelConfirm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref3.apply(this, arguments);
            };
        }();

        _this.activateToken = function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(tokenId) {
                var _ref6, error;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this.props.actions.enableUserAccessToken(tokenId);

                            case 2:
                                _ref6 = _context3.sent;
                                error = _ref6.error;

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                } else {
                                    (0, _diagnostics_actions.trackEvent)('settings', 'activate_user_access_token');
                                }

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }));

            return function (_x2) {
                return _ref5.apply(this, arguments);
            };
        }();

        _this.deactivateToken = function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(tokenId) {
                var _ref8, error;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this.props.actions.disableUserAccessToken(tokenId);

                            case 2:
                                _ref8 = _context4.sent;
                                error = _ref8.error;

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                } else {
                                    (0, _diagnostics_actions.trackEvent)('settings', 'deactivate_user_access_token');
                                }

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this2);
            }));

            return function (_x3) {
                return _ref7.apply(this, arguments);
            };
        }();

        _this.createTokensSection = function () {
            var tokenListClass = '';

            if (_this.props.activeSection === SECTION_TOKENS) {
                var tokenList = [];
                (0, _values2.default)(_this.props.userAccessTokens).forEach(function (token) {
                    if (_this.state.newToken && _this.state.newToken.id === token.id) {
                        return;
                    }

                    var activeLink = void 0;
                    var activeStatus = void 0;

                    if (token.is_active) {
                        activeLink = _react2.default.createElement(
                            'a',
                            {
                                name: token.id + '_deactivate',
                                href: '#',
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    _this.deactivateToken(token.id);
                                }
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.deactivate',
                                defaultMessage: 'Deactivate'
                            })
                        );
                    } else {
                        activeStatus = _react2.default.createElement(
                            'span',
                            { className: 'has-error setting-box__inline-error' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.deactivatedWarning',
                                defaultMessage: '(Inactive)'
                            })
                        );
                        activeLink = _react2.default.createElement(
                            'a',
                            {
                                name: token.id + '_activate',
                                href: '#',
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    _this.activateToken(token.id);
                                }
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.activate',
                                defaultMessage: 'Activate'
                            })
                        );
                    }

                    tokenList.push(_react2.default.createElement(
                        'div',
                        {
                            key: token.id,
                            className: 'setting-box__item'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'whitespace--nowrap overflow--ellipsis' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.tokenDesc',
                                defaultMessage: 'Token Description: '
                            }),
                            token.description,
                            activeStatus
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'setting-box__token-id whitespace--nowrap overflow--ellipsis' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.tokenId',
                                defaultMessage: 'Token ID: '
                            }),
                            token.id
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            activeLink,
                            ' - ',
                            _react2.default.createElement(
                                'a',
                                {
                                    name: token.id + '_delete',
                                    href: '#',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this.confirmRevokeToken(token.id);
                                    }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.tokens.delete',
                                    defaultMessage: 'Delete'
                                })
                            )
                        ),
                        _react2.default.createElement('hr', { className: 'margin-bottom margin-top x2' })
                    ));
                });

                var noTokenText = void 0;
                if (tokenList.length === 0) {
                    noTokenText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        key: 'notokens',
                        id: 'user.settings.tokens.userAccessTokensNone',
                        defaultMessage: 'No personal access tokens.'
                    });
                }

                var extraInfo = void 0;
                if ((0, _user_agent.isMobile)()) {
                    extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'user.settings.tokens.description_mobile',
                            defaultMessage: '<a href="https://about.mattermost.com/default-user-access-tokens" target="_blank">Personal access tokens</a> function similarly to session tokens and can be used by integrations to <a href="https://about.mattermost.com/default-api-authentication" target="_blank">authenticate against the REST API</a>. Create new tokens on your desktop.'
                        })
                    );
                } else {
                    extraInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'user.settings.tokens.description',
                            defaultMessage: '<a href="https://about.mattermost.com/default-user-access-tokens" target="_blank">Personal access tokens</a> function similarly to session tokens and can be used by integrations to <a href="https://about.mattermost.com/default-api-authentication" target="_blank">authenticate against the REST API</a>.'
                        })
                    );
                }

                var newTokenSection = void 0;
                if (_this.state.tokenCreationState === TOKEN_CREATING) {
                    newTokenSection = _react2.default.createElement(
                        'div',
                        { className: 'padding-left x2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'label',
                                { className: 'col-sm-auto control-label padding-right x2' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.tokens.name',
                                    defaultMessage: 'Token Description: '
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-5' },
                                _react2.default.createElement('input', {
                                    autoFocus: true,
                                    ref: 'newtokendescription',
                                    className: 'form-control',
                                    type: 'text',
                                    maxLength: 64,
                                    onKeyPress: _this.saveTokenKeyPress
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'padding-top x2' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.tokens.nameHelp',
                                    defaultMessage: 'Enter a description for your token to remember what it does.'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    {
                                        id: 'clientError',
                                        className: 'has-error margin-top margin-bottom'
                                    },
                                    _this.state.tokenError
                                )
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'btn btn-primary',
                                    onClick: _this.confirmCreateToken
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.tokens.save',
                                    defaultMessage: 'Save'
                                })
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'btn btn-default',
                                    onClick: _this.stopCreatingToken
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.tokens.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            )
                        )
                    );
                } else if (_this.state.tokenCreationState === TOKEN_CREATED) {
                    if (tokenList.length === 0) {
                        tokenListClass = ' hidden';
                    }

                    newTokenSection = _react2.default.createElement(
                        'div',
                        {
                            className: 'alert alert-warning'
                        },
                        _react2.default.createElement('i', { className: 'fa fa-warning margin-right' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.tokens.copy',
                            defaultMessage: 'Please copy the access token below. You won\'t be able to see it again!'
                        }),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'div',
                            { className: 'whitespace--nowrap overflow--ellipsis' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.name',
                                defaultMessage: 'Token Description: '
                            }),
                            _this.state.newToken.description
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'whitespace--nowrap overflow--ellipsis' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.id',
                                defaultMessage: 'Token ID: '
                            }),
                            _this.state.newToken.id
                        ),
                        _react2.default.createElement(
                            'strong',
                            { className: 'word-break--all' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.tokens.token',
                                defaultMessage: 'Access Token: '
                            }),
                            _this.state.newToken.token
                        )
                    );
                } else {
                    newTokenSection = _react2.default.createElement(
                        'a',
                        {
                            className: 'btn btn-primary',
                            href: '#',
                            onClick: _this.startCreatingToken
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.tokens.create',
                            defaultMessage: 'Create New Token'
                        })
                    );
                }

                var inputs = [];
                inputs.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'tokensSetting',
                        className: 'padding-top'
                    },
                    _react2.default.createElement(
                        'div',
                        { key: 'tokenList' },
                        _react2.default.createElement(
                            'div',
                            { className: 'alert alert-transparent' + tokenListClass },
                            tokenList,
                            noTokenText
                        ),
                        newTokenSection
                    )
                ));

                return _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('user.settings.tokens.title', 'Personal Access Tokens'),
                    inputs: inputs,
                    extraInfo: extraInfo,
                    infoPosition: 'top',
                    serverError: _this.state.serverError,
                    updateSection: _this.handleUpdateSection,
                    width: 'full',
                    cancelButtonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.security.close',
                        defaultMessage: 'Close'
                    })
                });
            }

            var describe = Utils.localizeMessage('user.settings.tokens.clickToEdit', "Click 'Edit' to manage your personal access tokens");

            return _react2.default.createElement(_setting_item_min2.default, {
                title: Utils.localizeMessage('user.settings.tokens.title', 'Personal Access Tokens'),
                describe: describe,
                section: SECTION_TOKENS,
                updateSection: _this.handleUpdateSection
            });
        };

        _this.state = _this.getDefaultState();
        return _this;
    }

    (0, _createClass3.default)(SecurityTab, [{
        key: 'getDefaultState',
        value: function getDefaultState() {
            return {
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
                passwordError: '',
                serverError: '',
                tokenError: '',
                showConfirmModal: false,
                authService: this.props.user.auth_service,
                savingPassword: false
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            if (this.props.enableOAuthServiceProvider) {
                (0, _user_actions.getAuthorizedApps)(function (authorizedApps) {
                    _this3.setState({ authorizedApps: authorizedApps, serverError: null }); //eslint-disable-line react/no-did-mount-set-state
                }, function (err) {
                    _this3.setState({ serverError: err.message }); //eslint-disable-line react/no-did-mount-set-state
                });
            }

            if (this.props.canUseAccessTokens) {
                this.props.actions.clearUserAccessTokens();
                var userId = this.props.user ? this.props.user.id : '';
                this.props.actions.getUserAccessTokensForUser(userId, 0, 200);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var user = this.props.user;

            var passwordSection = this.createPasswordSection();

            var numMethods = 0;
            numMethods = this.props.enableSignUpWithGitLab ? numMethods + 1 : numMethods;
            numMethods = this.props.enableSignUpWithGoogle ? numMethods + 1 : numMethods;
            numMethods = this.props.enableSignUpWithOffice365 ? numMethods + 1 : numMethods;
            numMethods = this.props.enableLdap ? numMethods + 1 : numMethods;
            numMethods = this.props.enableSaml ? numMethods + 1 : numMethods;

            // If there are other sign-in methods and either email is enabled or the user's account is email, then allow switching
            var signInSection = void 0;
            if ((this.props.enableSignUpWithEmail || user.auth_service === '') && numMethods > 0 && this.props.experimentalEnableAuthenticationTransfer) {
                signInSection = this.createSignInSection();
            }

            var mfaSection = void 0;
            if (this.props.enableMultifactorAuthentication && this.props.isLicensed && (user.auth_service === '' || user.auth_service === _constants2.default.LDAP_SERVICE)) {
                mfaSection = this.createMfaSection();
            }

            var oauthSection = void 0;
            if (this.props.enableOAuthServiceProvider) {
                oauthSection = this.createOAuthAppsSection();
            }

            var tokensSection = void 0;
            if (this.props.canUseAccessTokens) {
                tokensSection = this.createTokensSection();
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': Utils.localizeMessage('user.settings.security.close', 'Close'),
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.security.title',
                            defaultMessage: 'Security Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'user-settings' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.security.title',
                            defaultMessage: 'Security Settings'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    passwordSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    mfaSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    oauthSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    tokensSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    signInSection,
                    _react2.default.createElement('div', { className: 'divider-dark' }),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        _toggle_modal_button2.default,
                        {
                            className: 'security-links color--link',
                            dialogType: _access_history_modal2.default
                        },
                        _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.security.viewHistory',
                            defaultMessage: 'View Access History'
                        })
                    ),
                    _react2.default.createElement(
                        _toggle_modal_button2.default,
                        {
                            className: 'security-links color--link margin-top',
                            dialogType: _activity_log_modal2.default
                        },
                        _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.security.logoutActiveSessions',
                            defaultMessage: 'View and Logout of Active Sessions'
                        })
                    )
                ),
                _react2.default.createElement(_confirm_modal2.default, {
                    title: this.state.confirmTitle,
                    message: this.state.confirmMessage,
                    confirmButtonText: this.state.confirmButton,
                    show: this.state.showConfirmModal,
                    onConfirm: this.state.confirmComplete || function () {} //eslint-disable-line no-empty-function
                    , onCancel: this.handleCancelConfirm
                })
            );
        }
    }]);
    return SecurityTab;
}(_react2.default.Component);

SecurityTab.propTypes = {
    user: _propTypes2.default.object,
    activeSection: _propTypes2.default.string,
    updateSection: _propTypes2.default.func,
    updateTab: _propTypes2.default.func,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    setEnforceFocus: _propTypes2.default.func.isRequired,

    /*
     * The personal access tokens for the user
     */
    userAccessTokens: _propTypes2.default.object,

    /*
     * Set if access tokens are enabled and this user can use them
     */
    canUseAccessTokens: _propTypes2.default.bool,

    // Whether or not this instance of Mattermost is licensed.
    isLicensed: _propTypes2.default.bool,

    // Whether or not this instance of Mattermost is licensed to use multi-factor authentication.
    mfaLicensed: _propTypes2.default.bool,

    // Whether or not OAuth applications are enabled.
    enableOAuthServiceProvider: _propTypes2.default.bool,

    // Whether or not multi-factor authentication is enabled.
    enableMultifactorAuthentication: _propTypes2.default.bool,

    // Whether or not multi-factor authentication is enforced.
    enforceMultifactorAuthentication: _propTypes2.default.bool,

    // Whether or not sign-up with email is enabled.
    enableSignUpWithEmail: _propTypes2.default.bool,

    // Whether or not sign-up with GitLab is enabled.
    enableSignUpWithGitLab: _propTypes2.default.bool,

    // Whether or not sign-up with Google is enabled.
    enableSignUpWithGoogle: _propTypes2.default.bool,

    // Whether or not sign-up with LDAP is enabled.
    enableLdap: _propTypes2.default.bool,

    // Whether or not sign-up with SAML is enabled.
    enableSaml: _propTypes2.default.bool,

    // Whether or not sign-up with Office 365 is enabled.
    enableSignUpWithOffice365: _propTypes2.default.bool,

    // Whether or not the experimental authentication transfer is enabled.
    experimentalEnableAuthenticationTransfer: _propTypes2.default.bool,

    passwordConfig: _propTypes2.default.object,

    actions: _propTypes2.default.shape({
        getMe: _propTypes2.default.func.isRequired,

        /*
         * Function to get personal access tokens for a user
         */
        getUserAccessTokensForUser: _propTypes2.default.func.isRequired,

        /*
         * Function to create a personal access token
         */
        createUserAccessToken: _propTypes2.default.func.isRequired,

        /*
         * Function to revoke a personal access token
         */
        revokeUserAccessToken: _propTypes2.default.func.isRequired,

        /*
         * Function to activate a personal access token
         */
        enableUserAccessToken: _propTypes2.default.func.isRequired,

        /*
         * Function to deactivate a personal access token
         */
        disableUserAccessToken: _propTypes2.default.func.isRequired,

        /*
         * Function to clear personal access tokens locally
         */
        clearUserAccessTokens: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = SecurityTab;


SecurityTab.defaultProps = {
    user: {},
    activeSection: ''
};

/***/ }),

/***/ 2343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _access_history_modal = __webpack_require__(2344);

var _access_history_modal2 = _interopRequireDefault(_access_history_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getUserAudits: _users.getUserAudits
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_access_history_modal2.default);

/***/ }),

/***/ 2344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _audit_table = __webpack_require__(1404);

var _audit_table2 = _interopRequireDefault(_audit_table);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccessHistoryModal = function (_React$Component) {
    (0, _inherits3.default)(AccessHistoryModal, _React$Component);

    function AccessHistoryModal(props) {
        (0, _classCallCheck3.default)(this, AccessHistoryModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AccessHistoryModal.__proto__ || (0, _getPrototypeOf2.default)(AccessHistoryModal)).call(this, props));

        _this.onAuditChange = _this.onAuditChange.bind(_this);
        _this.onShow = _this.onShow.bind(_this);
        _this.onHide = _this.onHide.bind(_this);

        var state = _this.getStateFromStoresForAudits();
        state.moreInfo = [];
        state.show = true;

        _this.state = state;
        return _this;
    }

    (0, _createClass3.default)(AccessHistoryModal, [{
        key: 'getStateFromStoresForAudits',
        value: function getStateFromStoresForAudits() {
            return {
                audits: _user_store2.default.getAudits()
            };
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            this.props.actions.getUserAudits(_user_store2.default.getCurrentId(), 0, 200);
            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.modal-body').perfectScrollbar();
            }
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            this.setState({ show: false });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addAuditsChangeListener(this.onAuditChange);
            this.onShow();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeAuditsChangeListener(this.onAuditChange);
        }
    }, {
        key: 'onAuditChange',
        value: function onAuditChange() {
            var newState = this.getStateFromStoresForAudits();
            if (!Utils.areObjectsEqual(newState.audits, this.state.audits)) {
                this.setState(newState);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var content = void 0;
            if (this.state.audits.length === 0) {
                content = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                content = _react2.default.createElement(_audit_table2.default, {
                    audits: this.state.audits,
                    showIp: true,
                    showSession: true
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'modal--scroll',
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide,
                    bsSize: 'large'
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'access_history.title',
                            defaultMessage: 'Access History'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    { ref: 'modalBody' },
                    content
                )
            );
        }
    }]);
    return AccessHistoryModal;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

AccessHistoryModal.propTypes = {
    onHide: _propTypes2.default.func.isRequired,
    actions: _propTypes2.default.shape({
        getUserAudits: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AccessHistoryModal;

/***/ }),

/***/ 2345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _activity_log_modal = __webpack_require__(2346);

var _activity_log_modal2 = _interopRequireDefault(_activity_log_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getSessions: _users.getSessions,
            revokeSession: _users.revokeSession
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_activity_log_modal2.default);

/***/ }),

/***/ 2346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityLogModal = function (_React$Component) {
    (0, _inherits3.default)(ActivityLogModal, _React$Component);

    function ActivityLogModal(props) {
        (0, _classCallCheck3.default)(this, ActivityLogModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ActivityLogModal.__proto__ || (0, _getPrototypeOf2.default)(ActivityLogModal)).call(this, props));

        _this.isMobileSession = function (session) {
            return session.device_id && (session.device_id.includes('apple') || session.device_id.includes('android'));
        };

        _this.mobileSessionInfo = function (session) {
            var deviceTypeId = void 0;
            var deviceTypeMessage = void 0;
            var devicePicture = void 0;

            if (session.device_id.includes('apple')) {
                devicePicture = 'fa fa-apple';
                deviceTypeId = 'activity_log_modal.iphoneNativeClassicApp';
                deviceTypeMessage = 'iPhone Native Classic App';

                if (session.device_id.includes(_constants.General.PUSH_NOTIFY_APPLE_REACT_NATIVE)) {
                    deviceTypeId = 'activity_log_modal.iphoneNativeApp';
                    deviceTypeMessage = 'iPhone Native App';
                }
            } else if (session.device_id.includes('android')) {
                devicePicture = 'fa fa-android';
                deviceTypeId = 'activity_log_modal.androidNativeClassicApp';
                deviceTypeMessage = 'Android Native Classic App';

                if (session.device_id.includes(_constants.General.PUSH_NOTIFY_ANDROID_REACT_NATIVE)) {
                    deviceTypeId = 'activity_log_modal.androidNativeApp';
                    deviceTypeMessage = 'Android Native App';
                }
            }

            return {
                devicePicture: devicePicture,
                devicePlatform: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: deviceTypeId,
                    defaultMessage: deviceTypeMessage
                })
            };
        };

        _this.submitRevoke = _this.submitRevoke.bind(_this);
        _this.onListenerChange = _this.onListenerChange.bind(_this);
        _this.handleMoreInfo = _this.handleMoreInfo.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        _this.onShow = _this.onShow.bind(_this);

        var state = _this.getStateFromStores();
        state.moreInfo = [];
        state.show = true;

        _this.state = state;
        return _this;
    }

    (0, _createClass3.default)(ActivityLogModal, [{
        key: 'getStateFromStores',
        value: function getStateFromStores() {
            return {
                sessions: _user_store2.default.getSessions(),
                clientError: null
            };
        }
    }, {
        key: 'submitRevoke',
        value: function submitRevoke(altId, e) {
            var _this2 = this;

            e.preventDefault();
            var modalContent = (0, _jquery2.default)(e.target).closest('.modal-content');
            modalContent.addClass('animation--highlight');
            setTimeout(function () {
                modalContent.removeClass('animation--highlight');
            }, 1500);
            this.props.actions.revokeSession(_user_store2.default.getCurrentId(), altId).then(function () {
                _this2.props.actions.getSessions(_user_store2.default.getCurrentId());
            });
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            this.props.actions.getSessions(_user_store2.default.getCurrentId());
            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.modal-body').perfectScrollbar();
            }
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            this.setState({ show: false });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addSessionsChangeListener(this.onListenerChange);
            this.onShow();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeSessionsChangeListener(this.onListenerChange);
        }
    }, {
        key: 'onListenerChange',
        value: function onListenerChange() {
            var newState = this.getStateFromStores();
            if (!Utils.areObjectsEqual(newState.sessions, this.state.sessions)) {
                this.setState(newState);
            }
        }
    }, {
        key: 'handleMoreInfo',
        value: function handleMoreInfo(index) {
            var newMoreInfo = this.state.moreInfo;
            newMoreInfo[index] = true;
            this.setState({ moreInfo: newMoreInfo });
        }
    }, {
        key: 'render',
        value: function render() {
            var activityList = [];

            for (var i = 0; i < this.state.sessions.length; i++) {
                var currentSession = this.state.sessions[i];
                var lastAccessTime = new Date(currentSession.last_activity_at);
                var firstAccessTime = new Date(currentSession.create_at);
                var devicePlatform = currentSession.props.platform;
                var devicePicture = '';

                if (currentSession.props.type === 'UserAccessToken') {
                    continue;
                }

                if (currentSession.props.platform === 'Windows') {
                    devicePicture = 'fa fa-windows';
                } else if (this.isMobileSession(currentSession)) {
                    var sessionInfo = this.mobileSessionInfo(currentSession);

                    devicePicture = sessionInfo.devicePicture;
                    devicePlatform = sessionInfo.devicePlatform;
                } else if (currentSession.props.platform === 'Macintosh' || currentSession.props.platform === 'iPhone') {
                    devicePicture = 'fa fa-apple';
                } else if (currentSession.props.platform === 'Linux') {
                    if (currentSession.props.os.indexOf('Android') >= 0) {
                        devicePlatform = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'activity_log_modal.android',
                            defaultMessage: 'Android'
                        });
                        devicePicture = 'fa fa-android';
                    } else {
                        devicePicture = 'fa fa-linux';
                    }
                } else if (currentSession.props.os.indexOf('Linux') !== -1) {
                    devicePicture = 'fa fa-linux';
                }

                if (currentSession.props.browser.indexOf('Desktop App') !== -1) {
                    devicePlatform = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'activity_log_modal.desktop',
                        defaultMessage: 'Native Desktop App'
                    });
                }

                var moreInfo = void 0;
                if (this.state.moreInfo[i]) {
                    moreInfo = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'activity_log.firstTime',
                                defaultMessage: 'First time active: {date}, {time}',
                                values: {
                                    date: _react2.default.createElement(_reactIntl.FormattedDate, {
                                        value: firstAccessTime,
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric'
                                    }),
                                    time: _react2.default.createElement(_reactIntl.FormattedTime, {
                                        value: firstAccessTime,
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'activity_log.os',
                                defaultMessage: 'OS: {os}',
                                values: {
                                    os: currentSession.props.os
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'activity_log.browser',
                                defaultMessage: 'Browser: {browser}',
                                values: {
                                    browser: currentSession.props.browser
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'activity_log.sessionId',
                                defaultMessage: 'Session ID: {id}',
                                values: {
                                    id: currentSession.id
                                }
                            })
                        )
                    );
                } else {
                    moreInfo = _react2.default.createElement(
                        'a',
                        {
                            className: 'theme',
                            href: '#',
                            onClick: this.handleMoreInfo.bind(this, i)
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'activity_log.moreInfo',
                            defaultMessage: 'More info'
                        })
                    );
                }

                activityList[i] = _react2.default.createElement(
                    'div',
                    {
                        key: 'activityLogEntryKey' + i,
                        className: 'activity-log__table'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'activity-log__report' },
                        _react2.default.createElement(
                            'div',
                            { className: 'report__platform' },
                            _react2.default.createElement('i', { className: devicePicture }),
                            devicePlatform
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'report__info' },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'activity_log.lastActivity',
                                    defaultMessage: 'Last activity: {date}, {time}',
                                    values: {
                                        date: _react2.default.createElement(_reactIntl.FormattedDate, {
                                            value: lastAccessTime,
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric'
                                        }),
                                        time: _react2.default.createElement(_reactIntl.FormattedTime, {
                                            value: lastAccessTime,
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })
                                    }
                                })
                            ),
                            moreInfo
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'activity-log__action' },
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: this.submitRevoke.bind(this, currentSession.id),
                                className: 'btn btn-primary'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'activity_log.logout',
                                defaultMessage: 'Logout'
                            })
                        )
                    )
                );
            }

            var content = void 0;
            if (this.state.sessions.loading) {
                content = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                content = _react2.default.createElement(
                    'form',
                    { role: 'form' },
                    activityList
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'modal--scroll',
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide,
                    bsSize: 'large'
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'activity_log.activeSessions',
                            defaultMessage: 'Active Sessions'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    { ref: 'modalBody' },
                    _react2.default.createElement(
                        'p',
                        { className: 'session-help-text' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'activity_log.sessionsDescription',
                            defaultMessage: 'Sessions are created when you log in to a new browser on a device. Sessions let you use Mattermost without having to log in again for a time period specified by the System Admin. If you want to log out sooner, use the \'Logout\' button below to end a session.'
                        })
                    ),
                    content
                )
            );
        }
    }]);
    return ActivityLogModal;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ActivityLogModal.propTypes = {
    onHide: _propTypes2.default.func.isRequired,
    actions: _propTypes2.default.shape({
        getSessions: _propTypes2.default.func.isRequired,
        revokeSession: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ActivityLogModal;

/***/ }),

/***/ 2347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _preferences = __webpack_require__(861);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _preferences2 = __webpack_require__(784);

var _users = __webpack_require__(777);

var _constants2 = __webpack_require__(29);

var _user_settings_sidebar = __webpack_require__(2348);

var _user_settings_sidebar2 = _interopRequireDefault(_user_settings_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        closeUnusedDirectMessages: (0, _preferences2.get)(state, _constants.Preferences.CATEGORY_SIDEBAR_SETTINGS, 'close_unused_direct_messages', 'after_seven_days'),
        displayUnreadSection: (0, _preferences2.get)(state, _constants.Preferences.CATEGORY_SIDEBAR_SETTINGS, 'show_unread_section', (config.ExperimentalGroupUnreadChannels === _constants2.GroupUnreadChannels.DEFAULT_ON).toString()),
        showUnusedOption: config.CloseUnusedDirectMessages === 'true',
        showUnreadOption: config.ExperimentalGroupUnreadChannels !== _constants2.GroupUnreadChannels.DISABLED,
        user: (0, _users.getCurrentUser)(state)
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            savePreferences: _preferences.savePreferences
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_user_settings_sidebar2.default);

/***/ }),

/***/ 2348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserSettingsSidebar = function (_React$Component) {
    (0, _inherits3.default)(UserSettingsSidebar, _React$Component);

    function UserSettingsSidebar(props) {
        (0, _classCallCheck3.default)(this, UserSettingsSidebar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserSettingsSidebar.__proto__ || (0, _getPrototypeOf2.default)(UserSettingsSidebar)).call(this, props));

        _this.getStateFromStores = function () {
            var _this$props = _this.props,
                closeUnusedDirectMessages = _this$props.closeUnusedDirectMessages,
                displayUnreadSection = _this$props.displayUnreadSection;

            return {
                settings: {
                    close_unused_direct_messages: closeUnusedDirectMessages,
                    show_unread_section: displayUnreadSection
                },
                isSaving: false
            };
        };

        _this.updateSetting = function (setting, value) {
            var settings = _this.state.settings;
            settings[setting] = value;
            _this.setState(settings);
        };

        _this.handleSubmit = function (setting) {
            var _this$props2 = _this.props,
                actions = _this$props2.actions,
                user = _this$props2.user;

            var preferences = [];

            preferences.push({
                user_id: user.id,
                category: _constants2.default.Preferences.CATEGORY_SIDEBAR_SETTINGS,
                name: setting,
                value: _this.state.settings[setting]
            });

            _this.setState({ isSaving: true });

            actions.savePreferences(user.id, preferences).then(function () {
                _this.updateSection('');
            });
        };

        _this.updateSection = function (section) {
            if (!section) {
                _this.setState(_this.getStateFromStores());
            }
            _this.setState({ isSaving: false });
            _this.props.updateSection(section);
        };

        _this.renderAutoCloseDMLabel = function (value) {
            if (value === 'after_seven_days') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.sidebar.after_seven_days',
                    defaultMessage: 'After 7 days with no new messages'
                });
            }

            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'user.settings.sidebar.never',
                defaultMessage: 'Never'
            });
        };

        _this.renderAutoCloseDMSection = function () {
            if (_this.props.activeSection === 'autoCloseDM') {
                return _react2.default.createElement(_setting_item_max2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.sidebar.autoCloseDMTitle',
                        defaultMessage: 'Automatically Close Direct Messages'
                    }),
                    inputs: [_react2.default.createElement(
                        'div',
                        { key: 'autoCloseDMSetting' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'autoCloseDMAfterSevenDays',
                                    type: 'radio',
                                    name: 'autoCloseDM',
                                    checked: _this.state.settings.close_unused_direct_messages === 'after_seven_days',
                                    onChange: _this.updateSetting.bind(_this, 'close_unused_direct_messages', 'after_seven_days')
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.sidebar.after_seven_days',
                                    defaultMessage: 'After 7 days with no new messages'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'autoCloseDMNever',
                                    type: 'radio',
                                    name: 'autoCloseDM',
                                    checked: _this.state.settings.close_unused_direct_messages === 'never',
                                    onChange: _this.updateSetting.bind(_this, 'close_unused_direct_messages', 'never')
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.sidebar.never',
                                    defaultMessage: 'Never'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.sidebar.autoCloseDMDesc',
                                defaultMessage: 'Direct Message conversations can be reopened with the \u201C+\u201D button in the sidebar or using the Channel Switcher (CTRL+K).'
                            })
                        )
                    )],
                    setting: 'close_unused_direct_messages',
                    submit: _this.handleSubmit,
                    saving: _this.state.isSaving,
                    server_error: _this.state.serverError,
                    updateSection: _this.updateSection
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.sidebar.autoCloseDMTitle',
                    defaultMessage: 'Automatically Close Direct Messages'
                }),
                describe: _this.renderAutoCloseDMLabel(_this.state.settings.close_unused_direct_messages),
                section: 'autoCloseDM',
                updateSection: _this.updateSection
            });
        };

        _this.renderUnreadLabel = function (value) {
            if (value === 'true') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.sidebar.showUnreadSection',
                    defaultMessage: 'At the top of the channel sidebar'
                });
            }

            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'user.settings.sidebar.never',
                defaultMessage: 'Never'
            });
        };

        _this.renderUnreadSection = function () {
            if (_this.props.activeSection === 'unreadChannels') {
                return _react2.default.createElement(_setting_item_max2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.sidebar.unreadSectionTitle',
                        defaultMessage: 'Group unread channels'
                    }),
                    inputs: [_react2.default.createElement(
                        'div',
                        { key: 'unreadSectionSetting' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'unreadSectionEnabled',
                                    type: 'radio',
                                    name: 'unreadChannels',
                                    checked: _this.state.settings.show_unread_section === 'true',
                                    onChange: _this.updateSetting.bind(_this, 'show_unread_section', 'true')
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.sidebar.showUnreadSection',
                                    defaultMessage: 'At the top of the channel sidebar'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    id: 'unreadSectionNever',
                                    type: 'radio',
                                    name: 'unreadChannels',
                                    checked: _this.state.settings.show_unread_section === 'false',
                                    onChange: _this.updateSetting.bind(_this, 'show_unread_section', 'false')
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.sidebar.never',
                                    defaultMessage: 'Never'
                                })
                            ),
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.sidebar.unreadSectionDesc',
                                defaultMessage: 'Unread channels will be sorted at the top of the channel sidebar until read.'
                            })
                        )
                    )],
                    setting: 'show_unread_section',
                    submit: _this.handleSubmit,
                    saving: _this.state.isSaving,
                    server_error: _this.state.serverError,
                    updateSection: _this.updateSection
                });
            }

            return _react2.default.createElement(_setting_item_min2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'user.settings.sidebar.unreadSectionTitle',
                    defaultMessage: 'Group unread channels'
                }),
                describe: _this.renderUnreadLabel(_this.state.settings.show_unread_section),
                section: 'unreadChannels',
                updateSection: _this.updateSection
            });
        };

        _this.state = _this.getStateFromStores();
        return _this;
    }

    (0, _createClass3.default)(UserSettingsSidebar, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                showUnusedOption = _props.showUnusedOption,
                showUnreadOption = _props.showUnreadOption;

            var autoCloseDMSection = showUnusedOption ? this.renderAutoCloseDMSection() : null;
            var unreadSection = showUnreadOption ? this.renderUnreadSection() : null;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'closeButton',
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': 'Close',
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.sidebar.title',
                            defaultMessage: 'Sidebar Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'user-settings' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.sidebar.title',
                            defaultMessage: 'Sidebar Settings'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    unreadSection,
                    showUnreadOption && _react2.default.createElement('div', { className: 'divider-light' }),
                    autoCloseDMSection,
                    _react2.default.createElement('div', { className: 'divider-dark' })
                )
            );
        }
    }]);
    return UserSettingsSidebar;
}(_react2.default.Component);

UserSettingsSidebar.propTypes = {
    actions: _propTypes2.default.shape({

        /*
         * Function to save the user's preferences
         */
        savePreferences: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
     * Current user object
     */
    user: _propTypes2.default.object,

    /**
     * The preferences for closing the unused direct messages channels
     */
    closeUnusedDirectMessages: _propTypes2.default.string.isRequired,

    /**
     * The preferences to show the unread channels section in the sidebar
     */
    displayUnreadSection: _propTypes2.default.string.isRequired,

    /**
     * Display the close unused direct messages channels options
     */
    showUnusedOption: _propTypes2.default.bool.isRequired,

    /**
     * Display the unread channels sections options
     */
    showUnreadOption: _propTypes2.default.bool.isRequired,
    updateSection: _propTypes2.default.func,
    updateTab: _propTypes2.default.func,
    activeSection: _propTypes2.default.string,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired
};
exports.default = UserSettingsSidebar;

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(935),
	__webpack_require__(813),
	__webpack_require__(2139),
	__webpack_require__(1056),
	__webpack_require__(1340),
	__webpack_require__(1341),
	__webpack_require__(1057),
	__webpack_require__(1055),
	__webpack_require__(2140),
	__webpack_require__(1058),
	__webpack_require__(1342),
	__webpack_require__(2141),
	__webpack_require__(889),
	__webpack_require__(1343)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr, document, getProto, slice, concat, push, indexOf,
	class2type, toString, hasOwn, fnToString, ObjectFunctionString,
	support, DOMEval ) {

"use strict";

var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1054)))

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return window.document;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2142) ], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Initialize a jQuery object
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(1350),

	__webpack_require__(1351)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, rsingleTag ) {

"use strict";

// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );

return init;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1354)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Data ) {
	"use strict";

	return new Data();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// Only count HTML whitespace
	// Other whitespace should count in values
	// https://html.spec.whatwg.org/multipage/infrastructure.html#space-character
	return ( /[^\x20\t\r\n\f]+/g );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};

return nodeName;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// All support tests are defined in their respective modules.
	return {};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};

return access;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1056),
	__webpack_require__(1064)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, slice ) {

"use strict";

function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1057),
	__webpack_require__(2145),
	__webpack_require__(2146),
	__webpack_require__(1352),
	__webpack_require__(868),

	__webpack_require__(839),
	__webpack_require__(1351),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, indexOf, dir, siblings, rneedsContext, nodeName ) {

"use strict";

var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(1063),
	__webpack_require__(867),
	__webpack_require__(1056),
	__webpack_require__(850),
	__webpack_require__(868),

	__webpack_require__(839),
	__webpack_require__(820)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, documentElement, rnothtmlwhite, slice, dataPriv, nodeName ) {

"use strict";

var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(813),
	__webpack_require__(867),
	__webpack_require__(2161),
	__webpack_require__(1365),
	__webpack_require__(1366),

	__webpack_require__(839),
	__webpack_require__(2162),
	__webpack_require__(1070),
	__webpack_require__(910),
	__webpack_require__(1367) // jQuery.param
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, rnothtmlwhite, location, nonce, rquery ) {

"use strict";

var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1060),
	__webpack_require__(890),
	__webpack_require__(1344),
	__webpack_require__(813),
	__webpack_require__(1059),
	__webpack_require__(1061),
	__webpack_require__(1345),
	__webpack_require__(1346),
	__webpack_require__(1339),
	__webpack_require__(1347),
	__webpack_require__(1348),
	__webpack_require__(1349),
	__webpack_require__(1062),

	__webpack_require__(839),
	__webpack_require__(1353),
	__webpack_require__(820) // contains
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, pnum, access, rmargin, document, rcssNum, rnumnonpx, cssExpand,
	getStyles, swap, curCSS, adjustCSS, addGetHookIf, support ) {

"use strict";

var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return [];
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(775),
	__webpack_require__(1340),
	__webpack_require__(1341),
	__webpack_require__(890),
	__webpack_require__(1357),
	__webpack_require__(1358),
	__webpack_require__(1359),
	__webpack_require__(1360),
	__webpack_require__(1361),
	__webpack_require__(1362),
	__webpack_require__(1363),
	__webpack_require__(2151),

	__webpack_require__(850),
	__webpack_require__(1355),
	__webpack_require__(1065),
	__webpack_require__(1343),
	__webpack_require__(868),

	__webpack_require__(839),
	__webpack_require__(911),
	__webpack_require__(820),
	__webpack_require__(912)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, concat, push, access,
	rcheckableType, rtagName, rscriptType,
	wrapMap, getAll, setGlobalEval, buildFragment, support,
	dataPriv, dataUser, acceptData, DOMEval, nodeName ) {

"use strict";

var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

});


// WEBPACK FOOTER //
// 3.8de5c051ccdcf14b2e9a.js